var $c = Object.defineProperty;
var gl = (g, I, e) => I in g ? $c(g, I, { enumerable: !0, configurable: !0, writable: !0, value: e }) : g[I] = e;
var Fg = (g, I, e) => (gl(g, typeof I != "symbol" ? I + "" : I, e), e);
import { jsx as Z, jsxs as Y } from "@emotion/react/jsx-runtime";
import { useShowNotification as Il, hideNotification as el, Box as z, Group as B, COLOR_PALETTE as hg, Anchor as FI, Text as Qe, OptimizeImage as Me, Indicator as cl, Stack as qg, Flex as Ke, ActionIcon as Wg, Icon as mg, Skeleton as _e } from "@inflearn/ds-react-next";
import { css as H } from "@emotion/react";
import { createContext as $g, useContext as gI, useState as fI, useRef as YI, useEffect as eg, useCallback as wg, useMemo as qe } from "react";
import { jsx as ll, Fragment as tl } from "react/jsx-runtime";
import pg from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import "dayjs/locale/vi";
import "dayjs/locale/ja";
import il from "dayjs/plugin/localizedFormat";
import nl from "dayjs/plugin/timezone";
import Cl from "dayjs/plugin/updateLocale";
import bl from "dayjs/plugin/utc";
import { useAnalytics as al } from "@inflearn/analytics";
import { useQuery as yg, useMutation as $e, useQueryClient as sl } from "@tanstack/react-query";
import { ResponseStatus as aI, IsomorphicFetch as Al, ApiError as Xg, StatusCodeLookup as ul } from "@inflearn/datasource-rest";
var rl = typeof global == "object" && global && global.Object === Object && global;
const gc = rl;
var dl = typeof self == "object" && self && self.Object === Object && self, ol = gc || dl || Function("return this")();
const tg = ol;
var Gl = tg.Symbol;
const Ug = Gl;
var Ic = Object.prototype, Xl = Ic.hasOwnProperty, Vl = Ic.toString, ug = Ug ? Ug.toStringTag : void 0;
function Zl(g) {
  var I = Xl.call(g, ug), e = g[ug];
  try {
    g[ug] = void 0;
    var c = !0;
  } catch {
  }
  var l = Vl.call(g);
  return c && (I ? g[ug] = e : delete g[ug]), l;
}
var hl = Object.prototype, Wl = hl.toString;
function ml(g) {
  return Wl.call(g);
}
var Nl = "[object Null]", xl = "[object Undefined]", _I = Ug ? Ug.toStringTag : void 0;
function ig(g) {
  return g == null ? g === void 0 ? xl : Nl : _I && _I in Object(g) ? Zl(g) : ml(g);
}
function q(g) {
  return g != null && typeof g == "object";
}
var Jl = "[object Symbol]";
function Rl(g) {
  return typeof g == "symbol" || q(g) && ig(g) == Jl;
}
function pl(g, I) {
  for (var e = -1, c = g == null ? 0 : g.length, l = Array(c); ++e < c; )
    l[e] = I(g[e], e, g);
  return l;
}
var yl = Array.isArray;
const Lg = yl;
var Bl = /\s/;
function vl(g) {
  for (var I = g.length; I-- && Bl.test(g.charAt(I)); )
    ;
  return I;
}
var Fl = /^\s+/;
function fl(g) {
  return g && g.slice(0, vl(g) + 1).replace(Fl, "");
}
function P(g) {
  var I = typeof g;
  return g != null && (I == "object" || I == "function");
}
var qI = 0 / 0, Yl = /^[-+]0x[0-9a-f]+$/i, Sl = /^0b[01]+$/i, Tl = /^0o[0-7]+$/i, zl = parseInt;
function Hl(g) {
  if (typeof g == "number")
    return g;
  if (Rl(g))
    return qI;
  if (P(g)) {
    var I = typeof g.valueOf == "function" ? g.valueOf() : g;
    g = P(I) ? I + "" : I;
  }
  if (typeof g != "string")
    return g === 0 ? g : +g;
  g = fl(g);
  var e = Sl.test(g);
  return e || Tl.test(g) ? zl(g.slice(2), e ? 2 : 8) : Yl.test(g) ? qI : +g;
}
var $I = 1 / 0, wl = 17976931348623157e292;
function Ul(g) {
  if (!g)
    return g === 0 ? g : 0;
  if (g = Hl(g), g === $I || g === -$I) {
    var I = g < 0 ? -1 : 1;
    return I * wl;
  }
  return g === g ? g : 0;
}
function Ll(g) {
  var I = Ul(g), e = I % 1;
  return I === I ? e ? I - e : I : 0;
}
function SI(g) {
  return g;
}
var Ol = "[object AsyncFunction]", El = "[object Function]", Pl = "[object GeneratorFunction]", Dl = "[object Proxy]";
function TI(g) {
  if (!P(g))
    return !1;
  var I = ig(g);
  return I == El || I == Pl || I == Ol || I == Dl;
}
var jl = tg["__core-js_shared__"];
const sI = jl;
var ge = function() {
  var g = /[^.]+$/.exec(sI && sI.keys && sI.keys.IE_PROTO || "");
  return g ? "Symbol(src)_1." + g : "";
}();
function kl(g) {
  return !!ge && ge in g;
}
var Ql = Function.prototype, Ml = Ql.toString;
function Kl(g) {
  if (g != null) {
    try {
      return Ml.call(g);
    } catch {
    }
    try {
      return g + "";
    } catch {
    }
  }
  return "";
}
var _l = /[\\^$.*+?()[\]{}|]/g, ql = /^\[object .+?Constructor\]$/, $l = Function.prototype, gt = Object.prototype, It = $l.toString, et = gt.hasOwnProperty, ct = RegExp(
  "^" + It.call(et).replace(_l, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function lt(g) {
  if (!P(g) || kl(g))
    return !1;
  var I = TI(g) ? ct : ql;
  return I.test(Kl(g));
}
function tt(g, I) {
  return g == null ? void 0 : g[I];
}
function zI(g, I) {
  var e = tt(g, I);
  return lt(e) ? e : void 0;
}
var Ie = Object.create, it = function() {
  function g() {
  }
  return function(I) {
    if (!P(I))
      return {};
    if (Ie)
      return Ie(I);
    g.prototype = I;
    var e = new g();
    return g.prototype = void 0, e;
  };
}();
const nt = it;
function Ct(g, I, e) {
  switch (e.length) {
    case 0:
      return g.call(I);
    case 1:
      return g.call(I, e[0]);
    case 2:
      return g.call(I, e[0], e[1]);
    case 3:
      return g.call(I, e[0], e[1], e[2]);
  }
  return g.apply(I, e);
}
function bt(g, I) {
  var e = -1, c = g.length;
  for (I || (I = Array(c)); ++e < c; )
    I[e] = g[e];
  return I;
}
var at = 800, st = 16, At = Date.now;
function ut(g) {
  var I = 0, e = 0;
  return function() {
    var c = At(), l = st - (c - e);
    if (e = c, l > 0) {
      if (++I >= at)
        return arguments[0];
    } else
      I = 0;
    return g.apply(void 0, arguments);
  };
}
function ec(g) {
  return function() {
    return g;
  };
}
var rt = function() {
  try {
    var g = zI(Object, "defineProperty");
    return g({}, "", {}), g;
  } catch {
  }
}();
const Og = rt;
var dt = Og ? function(g, I) {
  return Og(g, "toString", {
    configurable: !0,
    enumerable: !1,
    value: ec(I),
    writable: !0
  });
} : SI;
const ot = dt;
var Gt = ut(ot);
const Xt = Gt;
function Vt(g, I, e, c) {
  for (var l = g.length, t = e + (c ? 1 : -1); c ? t-- : ++t < l; )
    if (I(g[t], t, g))
      return t;
  return -1;
}
function Zt(g) {
  return g !== g;
}
function ht(g, I, e) {
  for (var c = e - 1, l = g.length; ++c < l; )
    if (g[c] === I)
      return c;
  return -1;
}
function Wt(g, I, e) {
  return I === I ? ht(g, I, e) : Vt(g, Zt, e);
}
var mt = 9007199254740991, Nt = /^(?:0|[1-9]\d*)$/;
function cc(g, I) {
  var e = typeof g;
  return I = I ?? mt, !!I && (e == "number" || e != "symbol" && Nt.test(g)) && g > -1 && g % 1 == 0 && g < I;
}
function HI(g, I, e) {
  I == "__proto__" && Og ? Og(g, I, {
    configurable: !0,
    enumerable: !0,
    value: e,
    writable: !0
  }) : g[I] = e;
}
function II(g, I) {
  return g === I || g !== g && I !== I;
}
var xt = Object.prototype, Jt = xt.hasOwnProperty;
function Rt(g, I, e) {
  var c = g[I];
  (!(Jt.call(g, I) && II(c, e)) || e === void 0 && !(I in g)) && HI(g, I, e);
}
function pt(g, I, e, c) {
  var l = !e;
  e || (e = {});
  for (var t = -1, i = I.length; ++t < i; ) {
    var n = I[t], b = c ? c(e[n], g[n], n, e, g) : void 0;
    b === void 0 && (b = g[n]), l ? HI(e, n, b) : Rt(e, n, b);
  }
  return e;
}
var ee = Math.max;
function yt(g, I, e) {
  return I = ee(I === void 0 ? g.length - 1 : I, 0), function() {
    for (var c = arguments, l = -1, t = ee(c.length - I, 0), i = Array(t); ++l < t; )
      i[l] = c[I + l];
    l = -1;
    for (var n = Array(I + 1); ++l < I; )
      n[l] = c[l];
    return n[I] = e(i), Ct(g, this, n);
  };
}
function Bt(g, I) {
  return Xt(yt(g, I, SI), g + "");
}
var vt = 9007199254740991;
function lc(g) {
  return typeof g == "number" && g > -1 && g % 1 == 0 && g <= vt;
}
function Bg(g) {
  return g != null && lc(g.length) && !TI(g);
}
function Ft(g, I, e) {
  if (!P(e))
    return !1;
  var c = typeof I;
  return (c == "number" ? Bg(e) && cc(I, e.length) : c == "string" && I in e) ? II(e[I], g) : !1;
}
function ft(g) {
  return Bt(function(I, e) {
    var c = -1, l = e.length, t = l > 1 ? e[l - 1] : void 0, i = l > 2 ? e[2] : void 0;
    for (t = g.length > 3 && typeof t == "function" ? (l--, t) : void 0, i && Ft(e[0], e[1], i) && (t = l < 3 ? void 0 : t, l = 1), I = Object(I); ++c < l; ) {
      var n = e[c];
      n && g(I, n, c, t);
    }
    return I;
  });
}
var Yt = Object.prototype;
function wI(g) {
  var I = g && g.constructor, e = typeof I == "function" && I.prototype || Yt;
  return g === e;
}
function St(g, I) {
  for (var e = -1, c = Array(g); ++e < g; )
    c[e] = I(e);
  return c;
}
var Tt = "[object Arguments]";
function ce(g) {
  return q(g) && ig(g) == Tt;
}
var tc = Object.prototype, zt = tc.hasOwnProperty, Ht = tc.propertyIsEnumerable, wt = ce(function() {
  return arguments;
}()) ? ce : function(g) {
  return q(g) && zt.call(g, "callee") && !Ht.call(g, "callee");
};
const VI = wt;
function Ut() {
  return !1;
}
var ic = typeof exports == "object" && exports && !exports.nodeType && exports, le = ic && typeof module == "object" && module && !module.nodeType && module, Lt = le && le.exports === ic, te = Lt ? tg.Buffer : void 0, Ot = te ? te.isBuffer : void 0, Et = Ot || Ut;
const nc = Et;
var Pt = "[object Arguments]", Dt = "[object Array]", jt = "[object Boolean]", kt = "[object Date]", Qt = "[object Error]", Mt = "[object Function]", Kt = "[object Map]", _t = "[object Number]", qt = "[object Object]", $t = "[object RegExp]", gi = "[object Set]", Ii = "[object String]", ei = "[object WeakMap]", ci = "[object ArrayBuffer]", li = "[object DataView]", ti = "[object Float32Array]", ii = "[object Float64Array]", ni = "[object Int8Array]", Ci = "[object Int16Array]", bi = "[object Int32Array]", ai = "[object Uint8Array]", si = "[object Uint8ClampedArray]", Ai = "[object Uint16Array]", ui = "[object Uint32Array]", p = {};
p[ti] = p[ii] = p[ni] = p[Ci] = p[bi] = p[ai] = p[si] = p[Ai] = p[ui] = !0;
p[Pt] = p[Dt] = p[ci] = p[jt] = p[li] = p[kt] = p[Qt] = p[Mt] = p[Kt] = p[_t] = p[qt] = p[$t] = p[gi] = p[Ii] = p[ei] = !1;
function ri(g) {
  return q(g) && lc(g.length) && !!p[ig(g)];
}
function di(g) {
  return function(I) {
    return g(I);
  };
}
var Cc = typeof exports == "object" && exports && !exports.nodeType && exports, Vg = Cc && typeof module == "object" && module && !module.nodeType && module, oi = Vg && Vg.exports === Cc, AI = oi && gc.process, Gi = function() {
  try {
    var g = Vg && Vg.require && Vg.require("util").types;
    return g || AI && AI.binding && AI.binding("util");
  } catch {
  }
}();
const ie = Gi;
var ne = ie && ie.isTypedArray, Xi = ne ? di(ne) : ri;
const bc = Xi;
var Vi = Object.prototype, Zi = Vi.hasOwnProperty;
function ac(g, I) {
  var e = Lg(g), c = !e && VI(g), l = !e && !c && nc(g), t = !e && !c && !l && bc(g), i = e || c || l || t, n = i ? St(g.length, String) : [], b = n.length;
  for (var C in g)
    (I || Zi.call(g, C)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (C == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    l && (C == "offset" || C == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    t && (C == "buffer" || C == "byteLength" || C == "byteOffset") || // Skip index properties.
    cc(C, b))) && n.push(C);
  return n;
}
function sc(g, I) {
  return function(e) {
    return g(I(e));
  };
}
var hi = sc(Object.keys, Object);
const Wi = hi;
var mi = Object.prototype, Ni = mi.hasOwnProperty;
function xi(g) {
  if (!wI(g))
    return Wi(g);
  var I = [];
  for (var e in Object(g))
    Ni.call(g, e) && e != "constructor" && I.push(e);
  return I;
}
function Ac(g) {
  return Bg(g) ? ac(g) : xi(g);
}
function Ji(g) {
  var I = [];
  if (g != null)
    for (var e in Object(g))
      I.push(e);
  return I;
}
var Ri = Object.prototype, pi = Ri.hasOwnProperty;
function yi(g) {
  if (!P(g))
    return Ji(g);
  var I = wI(g), e = [];
  for (var c in g)
    c == "constructor" && (I || !pi.call(g, c)) || e.push(c);
  return e;
}
function uc(g) {
  return Bg(g) ? ac(g, !0) : yi(g);
}
var Bi = zI(Object, "create");
const Ng = Bi;
function vi() {
  this.__data__ = Ng ? Ng(null) : {}, this.size = 0;
}
function Fi(g) {
  var I = this.has(g) && delete this.__data__[g];
  return this.size -= I ? 1 : 0, I;
}
var fi = "__lodash_hash_undefined__", Yi = Object.prototype, Si = Yi.hasOwnProperty;
function Ti(g) {
  var I = this.__data__;
  if (Ng) {
    var e = I[g];
    return e === fi ? void 0 : e;
  }
  return Si.call(I, g) ? I[g] : void 0;
}
var zi = Object.prototype, Hi = zi.hasOwnProperty;
function wi(g) {
  var I = this.__data__;
  return Ng ? I[g] !== void 0 : Hi.call(I, g);
}
var Ui = "__lodash_hash_undefined__";
function Li(g, I) {
  var e = this.__data__;
  return this.size += this.has(g) ? 0 : 1, e[g] = Ng && I === void 0 ? Ui : I, this;
}
function _(g) {
  var I = -1, e = g == null ? 0 : g.length;
  for (this.clear(); ++I < e; ) {
    var c = g[I];
    this.set(c[0], c[1]);
  }
}
_.prototype.clear = vi;
_.prototype.delete = Fi;
_.prototype.get = Ti;
_.prototype.has = wi;
_.prototype.set = Li;
function Oi() {
  this.__data__ = [], this.size = 0;
}
function eI(g, I) {
  for (var e = g.length; e--; )
    if (II(g[e][0], I))
      return e;
  return -1;
}
var Ei = Array.prototype, Pi = Ei.splice;
function Di(g) {
  var I = this.__data__, e = eI(I, g);
  if (e < 0)
    return !1;
  var c = I.length - 1;
  return e == c ? I.pop() : Pi.call(I, e, 1), --this.size, !0;
}
function ji(g) {
  var I = this.__data__, e = eI(I, g);
  return e < 0 ? void 0 : I[e][1];
}
function ki(g) {
  return eI(this.__data__, g) > -1;
}
function Qi(g, I) {
  var e = this.__data__, c = eI(e, g);
  return c < 0 ? (++this.size, e.push([g, I])) : e[c][1] = I, this;
}
function j(g) {
  var I = -1, e = g == null ? 0 : g.length;
  for (this.clear(); ++I < e; ) {
    var c = g[I];
    this.set(c[0], c[1]);
  }
}
j.prototype.clear = Oi;
j.prototype.delete = Di;
j.prototype.get = ji;
j.prototype.has = ki;
j.prototype.set = Qi;
var Mi = zI(tg, "Map");
const rc = Mi;
function Ki() {
  this.size = 0, this.__data__ = {
    hash: new _(),
    map: new (rc || j)(),
    string: new _()
  };
}
function _i(g) {
  var I = typeof g;
  return I == "string" || I == "number" || I == "symbol" || I == "boolean" ? g !== "__proto__" : g === null;
}
function cI(g, I) {
  var e = g.__data__;
  return _i(I) ? e[typeof I == "string" ? "string" : "hash"] : e.map;
}
function qi(g) {
  var I = cI(this, g).delete(g);
  return this.size -= I ? 1 : 0, I;
}
function $i(g) {
  return cI(this, g).get(g);
}
function gn(g) {
  return cI(this, g).has(g);
}
function In(g, I) {
  var e = cI(this, g), c = e.size;
  return e.set(g, I), this.size += e.size == c ? 0 : 1, this;
}
function ng(g) {
  var I = -1, e = g == null ? 0 : g.length;
  for (this.clear(); ++I < e; ) {
    var c = g[I];
    this.set(c[0], c[1]);
  }
}
ng.prototype.clear = Ki;
ng.prototype.delete = qi;
ng.prototype.get = $i;
ng.prototype.has = gn;
ng.prototype.set = In;
var en = sc(Object.getPrototypeOf, Object);
const dc = en;
var cn = "[object Object]", ln = Function.prototype, tn = Object.prototype, oc = ln.toString, nn = tn.hasOwnProperty, Cn = oc.call(Object);
function bn(g) {
  if (!q(g) || ig(g) != cn)
    return !1;
  var I = dc(g);
  if (I === null)
    return !0;
  var e = nn.call(I, "constructor") && I.constructor;
  return typeof e == "function" && e instanceof e && oc.call(e) == Cn;
}
function an() {
  this.__data__ = new j(), this.size = 0;
}
function sn(g) {
  var I = this.__data__, e = I.delete(g);
  return this.size = I.size, e;
}
function An(g) {
  return this.__data__.get(g);
}
function un(g) {
  return this.__data__.has(g);
}
var rn = 200;
function dn(g, I) {
  var e = this.__data__;
  if (e instanceof j) {
    var c = e.__data__;
    if (!rc || c.length < rn - 1)
      return c.push([g, I]), this.size = ++e.size, this;
    e = this.__data__ = new ng(c);
  }
  return e.set(g, I), this.size = e.size, this;
}
function Cg(g) {
  var I = this.__data__ = new j(g);
  this.size = I.size;
}
Cg.prototype.clear = an;
Cg.prototype.delete = sn;
Cg.prototype.get = An;
Cg.prototype.has = un;
Cg.prototype.set = dn;
var Gc = typeof exports == "object" && exports && !exports.nodeType && exports, Ce = Gc && typeof module == "object" && module && !module.nodeType && module, on = Ce && Ce.exports === Gc, be = on ? tg.Buffer : void 0, ae = be ? be.allocUnsafe : void 0;
function Gn(g, I) {
  if (I)
    return g.slice();
  var e = g.length, c = ae ? ae(e) : new g.constructor(e);
  return g.copy(c), c;
}
var Xn = tg.Uint8Array;
const se = Xn;
function Vn(g) {
  var I = new g.constructor(g.byteLength);
  return new se(I).set(new se(g)), I;
}
function Zn(g, I) {
  var e = I ? Vn(g.buffer) : g.buffer;
  return new g.constructor(e, g.byteOffset, g.length);
}
function hn(g) {
  return typeof g.constructor == "function" && !wI(g) ? nt(dc(g)) : {};
}
function Wn(g) {
  return function(I, e, c) {
    for (var l = -1, t = Object(I), i = c(I), n = i.length; n--; ) {
      var b = i[g ? n : ++l];
      if (e(t[b], b, t) === !1)
        break;
    }
    return I;
  };
}
var mn = Wn();
const Xc = mn;
function Nn(g, I) {
  return g && Xc(g, I, Ac);
}
function ZI(g, I, e) {
  (e !== void 0 && !II(g[I], e) || e === void 0 && !(I in g)) && HI(g, I, e);
}
function xn(g) {
  return q(g) && Bg(g);
}
function hI(g, I) {
  if (!(I === "constructor" && typeof g[I] == "function") && I != "__proto__")
    return g[I];
}
function Jn(g) {
  return pt(g, uc(g));
}
function Rn(g, I, e, c, l, t, i) {
  var n = hI(g, e), b = hI(I, e), C = i.get(b);
  if (C) {
    ZI(g, e, C);
    return;
  }
  var a = t ? t(n, b, e + "", g, I, i) : void 0, u = a === void 0;
  if (u) {
    var A = Lg(b), G = !A && nc(b), N = !A && !G && bc(b);
    a = b, A || G || N ? Lg(n) ? a = n : xn(n) ? a = bt(n) : G ? (u = !1, a = Gn(b, !0)) : N ? (u = !1, a = Zn(b, !0)) : a = [] : bn(b) || VI(b) ? (a = n, VI(n) ? a = Jn(n) : (!P(n) || TI(n)) && (a = hn(b))) : u = !1;
  }
  u && (i.set(b, a), l(a, b, c, t, i), i.delete(b)), ZI(g, e, a);
}
function Vc(g, I, e, c, l) {
  g !== I && Xc(I, function(t, i) {
    if (l || (l = new Cg()), P(t))
      Rn(g, I, i, e, Vc, c, l);
    else {
      var n = c ? c(hI(g, i), t, i + "", g, I, l) : void 0;
      n === void 0 && (n = t), ZI(g, i, n);
    }
  }, uc);
}
var pn = "[object String]";
function yn(g) {
  return typeof g == "string" || !Lg(g) && q(g) && ig(g) == pn;
}
function Bn(g, I) {
  return pl(I, function(e) {
    return g[e];
  });
}
function vn(g) {
  return g == null ? [] : Bn(g, Ac(g));
}
var Fn = Math.max;
function fn(g, I, e, c) {
  g = Bg(g) ? g : vn(g), e = e && !c ? Ll(e) : 0;
  var l = g.length;
  return e < 0 && (e = Fn(l + e, 0)), yn(g) ? e <= l && g.indexOf(I, e) > -1 : !!l && Wt(g, I, e) > -1;
}
function Yn(g, I, e, c) {
  return Nn(g, function(l, t, i) {
    I(c, e(l), t, i);
  }), c;
}
function Sn(g, I) {
  return function(e, c) {
    return Yn(e, g, I(c), {});
  };
}
var Tn = Object.prototype, zn = Tn.toString, Hn = Sn(function(g, I, e) {
  I != null && typeof I.toString != "function" && (I = zn.call(I)), g[I] = e;
}, ec(SI));
const wn = Hn;
var Un = ft(function(g, I, e) {
  Vc(g, I, e);
});
const Zc = Un;
function hc(g) {
  return g && g.__esModule && Object.prototype.hasOwnProperty.call(g, "default") ? g.default : g;
}
const Ln = (...g) => {
  console != null && console.warn && (K(g[0]) && (g[0] = `react-i18next:: ${g[0]}`), console.warn(...g));
}, Ae = {}, WI = (...g) => {
  K(g[0]) && Ae[g[0]] || (K(g[0]) && (Ae[g[0]] = /* @__PURE__ */ new Date()), Ln(...g));
}, Wc = (g, I) => () => {
  if (g.isInitialized)
    I();
  else {
    const e = () => {
      setTimeout(() => {
        g.off("initialized", e);
      }, 0), I();
    };
    g.on("initialized", e);
  }
}, ue = (g, I, e) => {
  g.loadNamespaces(I, Wc(g, e));
}, re = (g, I, e, c) => {
  K(e) && (e = [e]), e.forEach((l) => {
    g.options.ns.indexOf(l) < 0 && g.options.ns.push(l);
  }), g.loadLanguages(I, Wc(g, c));
}, On = (g, I, e = {}) => !I.languages || !I.languages.length ? (WI("i18n.languages were undefined or empty", I.languages), !0) : I.hasLoadedNamespace(g, {
  lng: e.lng,
  precheck: (c, l) => {
    var t;
    if (((t = e.bindI18n) == null ? void 0 : t.indexOf("languageChanging")) > -1 && c.services.backendConnector.backend && c.isLanguageChangingTo && !l(c.isLanguageChangingTo, g))
      return !1;
  }
}), K = (g) => typeof g == "string", En = (g) => typeof g == "object" && g !== null, Pn = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Dn = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, jn = (g) => Dn[g], kn = (g) => g.replace(Pn, jn);
let mI = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: kn
};
const Qn = (g = {}) => {
  mI = {
    ...mI,
    ...g
  };
}, Mn = () => mI;
let mc;
const Kn = (g) => {
  mc = g;
}, _n = () => mc, qn = {
  type: "3rdParty",
  init(g) {
    Qn(g.options.react), Kn(g);
  }
}, $n = $g();
class gC {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(I) {
    I.forEach((e) => {
      this.usedNamespaces[e] || (this.usedNamespaces[e] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const IC = (g, I) => {
  const e = YI();
  return eg(() => {
    e.current = I ? e.current : g;
  }, [g, I]), e.current;
}, Nc = (g, I, e, c) => g.getFixedT(I, e, c), eC = (g, I, e, c) => wg(Nc(g, I, e, c), [g, I, e, c]), xc = (g, I = {}) => {
  var r, o, X, m;
  const {
    i18n: e
  } = I, {
    i18n: c,
    defaultNS: l
  } = gI($n) || {}, t = e || c || _n();
  if (t && !t.reportNamespaces && (t.reportNamespaces = new gC()), !t) {
    WI("You will need to pass in an i18next instance by using initReactI18next");
    const h = (S, f) => K(f) ? f : En(f) && K(f.defaultValue) ? f.defaultValue : Array.isArray(S) ? S[S.length - 1] : S, R = [h, {}, !1];
    return R.t = h, R.i18n = {}, R.ready = !1, R;
  }
  (r = t.options.react) != null && r.wait && WI("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const i = {
    ...Mn(),
    ...t.options.react,
    ...I
  }, {
    useSuspense: n,
    keyPrefix: b
  } = i;
  let C = g || l || ((o = t.options) == null ? void 0 : o.defaultNS);
  C = K(C) ? [C] : C || ["translation"], (m = (X = t.reportNamespaces).addUsedNamespaces) == null || m.call(X, C);
  const a = (t.isInitialized || t.initializedStoreOnce) && C.every((h) => On(h, t, i)), u = eC(t, I.lng || null, i.nsMode === "fallback" ? C : C[0], b), A = () => u, G = () => Nc(t, I.lng || null, i.nsMode === "fallback" ? C : C[0], b), [N, W] = fI(A);
  let J = C.join();
  I.lng && (J = `${I.lng}${J}`);
  const y = IC(J), s = YI(!0);
  eg(() => {
    const {
      bindI18n: h,
      bindI18nStore: R
    } = i;
    s.current = !0, !a && !n && (I.lng ? re(t, I.lng, C, () => {
      s.current && W(G);
    }) : ue(t, C, () => {
      s.current && W(G);
    })), a && y && y !== J && s.current && W(G);
    const S = () => {
      s.current && W(G);
    };
    return h && (t == null || t.on(h, S)), R && (t == null || t.store.on(R, S)), () => {
      s.current = !1, t && (h == null || h.split(" ").forEach((f) => t.off(f, S))), R && t && R.split(" ").forEach((f) => t.store.off(f, S));
    };
  }, [t, J]), eg(() => {
    s.current && a && W(A);
  }, [t, b, a]);
  const d = [N, t, a];
  if (d.t = N, d.i18n = t, d.ready = a, a || !a && !n)
    return d;
  throw new Promise((h) => {
    I.lng ? re(t, I.lng, C, () => h()) : ue(t, C, () => h());
  });
};
function Jc(g) {
  return xc("appShell", g);
}
/*! js-cookie v3.0.5 | MIT */
function fg(g) {
  for (var I = 1; I < arguments.length; I++) {
    var e = arguments[I];
    for (var c in e)
      g[c] = e[c];
  }
  return g;
}
var cC = {
  read: function(g) {
    return g[0] === '"' && (g = g.slice(1, -1)), g.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(g) {
    return encodeURIComponent(g).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function NI(g, I) {
  function e(l, t, i) {
    if (!(typeof document > "u")) {
      i = fg({}, I, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires && (i.expires = i.expires.toUTCString()), l = encodeURIComponent(l).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var n = "";
      for (var b in i)
        i[b] && (n += "; " + b, i[b] !== !0 && (n += "=" + i[b].split(";")[0]));
      return document.cookie = l + "=" + g.write(t, l) + n;
    }
  }
  function c(l) {
    if (!(typeof document > "u" || arguments.length && !l)) {
      for (var t = document.cookie ? document.cookie.split("; ") : [], i = {}, n = 0; n < t.length; n++) {
        var b = t[n].split("="), C = b.slice(1).join("=");
        try {
          var a = decodeURIComponent(b[0]);
          if (i[a] = g.read(C, a), l === a)
            break;
        } catch {
        }
      }
      return l ? i[l] : i;
    }
  }
  return Object.create(
    {
      set: e,
      get: c,
      remove: function(l, t) {
        e(
          l,
          "",
          fg({}, t, {
            expires: -1
          })
        );
      },
      withAttributes: function(l) {
        return NI(this.converter, fg({}, this.attributes, l));
      },
      withConverter: function(l) {
        return NI(fg({}, this.converter, l), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(I) },
      converter: { value: Object.freeze(g) }
    }
  );
}
var Rc = NI(cC, { path: "/" });
const Xs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rc
}, Symbol.toStringTag, { value: "Module" })), lC = {
  MODE: "development",
  CDN_URL: "https://cdn.devinflearn.com",
  API_URL: "https://www.devinflearn.com",
  SITE_URL: "https://www.devinflearn.com",
  MENTORING_SITE_URL: "https://mentoring.devinflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.devinflearn.com",
  ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  COURSE_API_URL: "https://course-api.devinflearn.com",
  UCC_API_URL: "https://ucc-api.devinflearn.com",
  RALLIT_SITE_URL: "https://www.devrallit.com",
  BUSINESS_DOMAIN: "https://business.devinflearn.com",
  ADMIN_DOMAIN: "https://admin.devinflearn.com",
  COOKIE_DOMAIN: ".devinflearn.com",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.test",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "65fef69e7b3b778bd124",
  OAUTH_GITHUB_CLIENT_ID: "41f342acfada922e9fb5",
  OAUTH_GOOGLE_CLIENT_ID: "333892070963-abo0eoss3ielmeukj8dtvpr4l0fbniun.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "1281a93457d30e1f2ffafe9fe0c197ab",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, tC = {
  MODE: "localhost",
  CDN_URL: "https://cdn.devinflearn.com",
  API_URL: "http://localhost:3000",
  SITE_URL: "http://localhost:3000",
  MENTORING_SITE_URL: "https://mentoring.devinflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.devinflearn.com",
  ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  COURSE_API_URL: "https://course-api.devinflearn.com",
  UCC_API_URL: "https://ucc-api.devinflearn.com",
  RALLIT_SITE_URL: "https://www.devrallit.com",
  BUSINESS_DOMAIN: "http://localhost:7020",
  ADMIN_DOMAIN: "http://localhost:7010",
  COOKIE_DOMAIN: "localhost",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.test",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "65fef69e7b3b778bd124",
  OAUTH_GITHUB_CLIENT_ID: "41f342acfada922e9fb5",
  OAUTH_GOOGLE_CLIENT_ID: "333892070963-abo0eoss3ielmeukj8dtvpr4l0fbniun.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "1281a93457d30e1f2ffafe9fe0c197ab",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, de = {
  MODE: "production",
  CDN_URL: "https://cdn.inflearn.com",
  API_URL: "https://www.inflearn.com",
  SITE_URL: "https://www.inflearn.com",
  MENTORING_SITE_URL: "https://mentoring.inflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.inflearn.com",
  ACCOUNT_API_URL: "https://account-api.inflearn.com",
  COURSE_API_URL: "https://course-api.inflearn.com",
  UCC_API_URL: "https://ucc-api.inflearn.com",
  RALLIT_SITE_URL: "https://www.rallit.com",
  BUSINESS_DOMAIN: "https://business.inflearn.com",
  ADMIN_DOMAIN: "https://admin.inflearn.com",
  COOKIE_DOMAIN: ".inflearn.com",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.web",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "5fd8e44b142806d9cbea",
  OAUTH_GITHUB_CLIENT_ID: "419780d6d3750d84d1db",
  OAUTH_GOOGLE_CLIENT_ID: "887875630717-ror9t8ig4obhvokdij07eoochpqbu5kf.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "0de1184063abadc9cef9dbf417c567a5",
  HACKLE_BROWSER_SDK_KEY: "rb1wDPCB39swIGfTAhDcz0QXvmh6hayS",
  MIXPANEL_TOKEN: "c05d8cc017a29af05e50c0d43d848d2d",
  CDN_INTEGRATION_URL: "https://cdn.inflab.com"
};
function iC() {
  return typeof window < "u" && (window != null && window.env) ? window.env : process.env.NEXT_PUBLIC_ENV || process.env.APP_ENV;
}
function nC() {
  const g = iC();
  return g ? g === "localhost" ? tC : g === "production" ? de : lC : (console.error("app-shell env is not defined"), de);
}
const v = nC(), UI = v.CDN_URL, LI = v.SITE_URL, Eg = v.MENTORING_SITE_URL, Vs = v.SOCIAL_ACCOUNT_URL, CC = v.API_URL, bC = `${CC}/api`, aC = v.ACCOUNT_API_URL, sC = v.COURSE_API_URL, AC = v.UCC_API_URL, uC = v.MODE, oe = v.RALLIT_SITE_URL, Zs = v.OAUTH_APPLE_CLIENT_ID, hs = v.OAUTH_GITHUB_CLIENT_ID, Ws = v.OAUTH_GOOGLE_CLIENT_ID, ms = v.OAUTH_KAKAO_REST_ID, Pg = v.BUSINESS_DOMAIN, rC = v.COOKIE_DOMAIN, Ns = v.HACKLE_BROWSER_SDK_KEY, dC = v.MIXPANEL_TOKEN;
v.CDN_INTEGRATION_URL;
const uI = Rc.withAttributes({
  path: "/",
  domain: rC
}).withConverter({
  write: function(g) {
    return encodeURIComponent(g);
  }
});
class zg {
  static set(I, e, c = this.COOKIE_EXPIRE_DAY, l = "Medium") {
    uI.set(I, e, {
      expires: c,
      priority: l
    });
  }
  static get(I) {
    return uI.get(I);
  }
  static remove(I) {
    uI.remove(I);
  }
}
Fg(zg, "COOKIE_EXPIRE_DAY", 7);
var lI = { exports: {} };
function oC(g) {
  try {
    return JSON.stringify(g);
  } catch {
    return '"[Circular]"';
  }
}
var GC = XC;
function XC(g, I, e) {
  var c = e && e.stringify || oC, l = 1;
  if (typeof g == "object" && g !== null) {
    var t = I.length + l;
    if (t === 1)
      return g;
    var i = new Array(t);
    i[0] = c(g);
    for (var n = 1; n < t; n++)
      i[n] = c(I[n]);
    return i.join(" ");
  }
  if (typeof g != "string")
    return g;
  var b = I.length;
  if (b === 0)
    return g;
  for (var C = "", a = 1 - l, u = -1, A = g && g.length || 0, G = 0; G < A; ) {
    if (g.charCodeAt(G) === 37 && G + 1 < A) {
      switch (u = u > -1 ? u : 0, g.charCodeAt(G + 1)) {
        case 100:
        case 102:
          if (a >= b || I[a] == null)
            break;
          u < G && (C += g.slice(u, G)), C += Number(I[a]), u = G + 2, G++;
          break;
        case 105:
          if (a >= b || I[a] == null)
            break;
          u < G && (C += g.slice(u, G)), C += Math.floor(Number(I[a])), u = G + 2, G++;
          break;
        case 79:
        case 111:
        case 106:
          if (a >= b || I[a] === void 0)
            break;
          u < G && (C += g.slice(u, G));
          var N = typeof I[a];
          if (N === "string") {
            C += "'" + I[a] + "'", u = G + 2, G++;
            break;
          }
          if (N === "function") {
            C += I[a].name || "<anonymous>", u = G + 2, G++;
            break;
          }
          C += c(I[a]), u = G + 2, G++;
          break;
        case 115:
          if (a >= b)
            break;
          u < G && (C += g.slice(u, G)), C += String(I[a]), u = G + 2, G++;
          break;
        case 37:
          u < G && (C += g.slice(u, G)), C += "%", u = G + 2, G++, a--;
          break;
      }
      ++a;
    }
    ++G;
  }
  return u === -1 ? g : (u < A && (C += g.slice(u)), C);
}
const Ge = GC;
lI.exports = D;
const xg = fC().console || {}, VC = {
  mapHttpRequest: Yg,
  mapHttpResponse: Yg,
  wrapRequestSerializer: rI,
  wrapResponseSerializer: rI,
  wrapErrorSerializer: rI,
  req: Yg,
  res: Yg,
  err: Ve,
  errWithCause: Ve
};
function Dg(g, I) {
  return g === "silent" ? 1 / 0 : I.levels.values[g];
}
const OI = Symbol("pino.logFuncs"), xI = Symbol("pino.hierarchy"), ZC = {
  error: "log",
  fatal: "error",
  warn: "error",
  info: "log",
  debug: "log",
  trace: "log"
};
function Xe(g, I) {
  const e = {
    logger: I,
    parent: g[xI]
  };
  I[xI] = e;
}
function hC(g, I, e) {
  const c = {};
  I.forEach((l) => {
    c[l] = e[l] ? e[l] : xg[l] || xg[ZC[l] || "log"] || Jg;
  }), g[OI] = c;
}
function WC(g, I) {
  return Array.isArray(g) ? g.filter(function(c) {
    return c !== "!stdSerializers.err";
  }) : g === !0 ? Object.keys(I) : !1;
}
function D(g) {
  g = g || {}, g.browser = g.browser || {};
  const I = g.browser.transmit;
  if (I && typeof I.send != "function")
    throw Error("pino: transmit option must have a send function");
  const e = g.browser.write || xg;
  g.browser.write && (g.browser.asObject = !0);
  const c = g.serializers || {}, l = WC(g.browser.serialize, c);
  let t = g.browser.serialize;
  Array.isArray(g.browser.serialize) && g.browser.serialize.indexOf("!stdSerializers.err") > -1 && (t = !1);
  const i = Object.keys(g.customLevels || {}), n = ["error", "fatal", "warn", "info", "debug", "trace"].concat(i);
  typeof e == "function" && n.forEach(function(W) {
    e[W] = e;
  }), (g.enabled === !1 || g.browser.disabled) && (g.level = "silent");
  const b = g.level || "info", C = Object.create(e);
  C.log || (C.log = Jg), hC(C, n, e), Xe({}, C), Object.defineProperty(C, "levelVal", {
    get: u
  }), Object.defineProperty(C, "level", {
    get: A,
    set: G
  });
  const a = {
    transmit: I,
    serialize: l,
    asObject: g.browser.asObject,
    formatters: g.browser.formatters,
    levels: n,
    timestamp: BC(g)
  };
  C.levels = mC(g), C.level = b, C.setMaxListeners = C.getMaxListeners = C.emit = C.addListener = C.on = C.prependListener = C.once = C.prependOnceListener = C.removeListener = C.removeAllListeners = C.listeners = C.listenerCount = C.eventNames = C.write = C.flush = Jg, C.serializers = c, C._serialize = l, C._stdErrSerialize = t, C.child = N, I && (C._logEvent = JI());
  function u() {
    return Dg(this.level, this);
  }
  function A() {
    return this._level;
  }
  function G(W) {
    if (W !== "silent" && !this.levels.values[W])
      throw Error("unknown level " + W);
    this._level = W, M(this, a, C, "error"), M(this, a, C, "fatal"), M(this, a, C, "warn"), M(this, a, C, "info"), M(this, a, C, "debug"), M(this, a, C, "trace"), i.forEach((J) => {
      M(this, a, C, J);
    });
  }
  function N(W, J) {
    if (!W)
      throw new Error("missing bindings for child Pino");
    J = J || {}, l && W.serializers && (J.serializers = W.serializers);
    const y = J.serializers;
    if (l && y) {
      var s = Object.assign({}, c, y), d = g.browser.serialize === !0 ? Object.keys(s) : l;
      delete W.serializers, tI([W], d, s, this._stdErrSerialize);
    }
    function r(X) {
      this._childLevel = (X._childLevel | 0) + 1, this.bindings = W, s && (this.serializers = s, this._serialize = d), I && (this._logEvent = JI(
        [].concat(X._logEvent.bindings, W)
      ));
    }
    r.prototype = this;
    const o = new r(this);
    return Xe(this, o), o.level = this.level, o;
  }
  return C;
}
function mC(g) {
  const I = g.customLevels || {}, e = Object.assign({}, D.levels.values, I), c = Object.assign({}, D.levels.labels, NC(I));
  return {
    values: e,
    labels: c
  };
}
function NC(g) {
  const I = {};
  return Object.keys(g).forEach(function(e) {
    I[g[e]] = e;
  }), I;
}
D.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
D.stdSerializers = VC;
D.stdTimeFunctions = Object.assign({}, { nullTime: pc, epochTime: yc, unixTime: vC, isoTime: FC });
function xC(g) {
  const I = [];
  g.bindings && I.push(g.bindings);
  let e = g[xI];
  for (; e.parent; )
    e = e.parent, e.logger.bindings && I.push(e.logger.bindings);
  return I.reverse();
}
function M(g, I, e, c) {
  if (Object.defineProperty(g, c, {
    value: Dg(g.level, e) > Dg(c, e) ? Jg : e[OI][c],
    writable: !0,
    enumerable: !0,
    configurable: !0
  }), !I.transmit && g[c] === Jg)
    return;
  g[c] = RC(g, I, e, c);
  const l = xC(g);
  l.length !== 0 && (g[c] = JC(l, g[c]));
}
function JC(g, I) {
  return function() {
    return I.apply(this, [...g, ...arguments]);
  };
}
function RC(g, I, e, c) {
  return function(l) {
    return function() {
      const i = I.timestamp(), n = new Array(arguments.length), b = Object.getPrototypeOf && Object.getPrototypeOf(this) === xg ? xg : this;
      for (var C = 0; C < n.length; C++)
        n[C] = arguments[C];
      if (I.serialize && !I.asObject && tI(n, this._serialize, this.serializers, this._stdErrSerialize), I.asObject || I.formatters ? l.call(b, pC(this, c, n, i, I.formatters)) : l.apply(b, n), I.transmit) {
        const a = I.transmit.level || g._level, u = e.levels.values[a], A = e.levels.values[c];
        if (A < u)
          return;
        yC(this, {
          ts: i,
          methodLevel: c,
          methodValue: A,
          transmitLevel: a,
          transmitValue: e.levels.values[I.transmit.level || g._level],
          send: I.transmit.send,
          val: Dg(g._level, e)
        }, n);
      }
    };
  }(g[OI][c]);
}
function pC(g, I, e, c, l = {}) {
  const {
    level: t = () => g.levels.values[I],
    log: i = (A) => A
  } = l;
  g._serialize && tI(e, g._serialize, g.serializers, g._stdErrSerialize);
  const n = e.slice();
  let b = n[0];
  const C = {};
  c && (C.time = c), C.level = t(I, g.levels.values[I]);
  let a = (g._childLevel | 0) + 1;
  if (a < 1 && (a = 1), b !== null && typeof b == "object") {
    for (; a-- && typeof n[0] == "object"; )
      Object.assign(C, n.shift());
    b = n.length ? Ge(n.shift(), n) : void 0;
  } else
    typeof b == "string" && (b = Ge(n.shift(), n));
  return b !== void 0 && (C.msg = b), i(C);
}
function tI(g, I, e, c) {
  for (const l in g)
    if (c && g[l] instanceof Error)
      g[l] = D.stdSerializers.err(g[l]);
    else if (typeof g[l] == "object" && !Array.isArray(g[l]))
      for (const t in g[l])
        I && I.indexOf(t) > -1 && t in e && (g[l][t] = e[t](g[l][t]));
}
function yC(g, I, e) {
  const c = I.send, l = I.ts, t = I.methodLevel, i = I.methodValue, n = I.val, b = g._logEvent.bindings;
  tI(
    e,
    g._serialize || Object.keys(g.serializers),
    g.serializers,
    g._stdErrSerialize === void 0 ? !0 : g._stdErrSerialize
  ), g._logEvent.ts = l, g._logEvent.messages = e.filter(function(C) {
    return b.indexOf(C) === -1;
  }), g._logEvent.level.label = t, g._logEvent.level.value = i, c(t, g._logEvent, n), g._logEvent = JI(b);
}
function JI(g) {
  return {
    ts: 0,
    messages: [],
    bindings: g || [],
    level: { label: "", value: 0 }
  };
}
function Ve(g) {
  const I = {
    type: g.constructor.name,
    msg: g.message,
    stack: g.stack
  };
  for (const e in g)
    I[e] === void 0 && (I[e] = g[e]);
  return I;
}
function BC(g) {
  return typeof g.timestamp == "function" ? g.timestamp : g.timestamp === !1 ? pc : yc;
}
function Yg() {
  return {};
}
function rI(g) {
  return g;
}
function Jg() {
}
function pc() {
  return !1;
}
function yc() {
  return Date.now();
}
function vC() {
  return Math.round(Date.now() / 1e3);
}
function FC() {
  return new Date(Date.now()).toISOString();
}
function fC() {
  function g(I) {
    return typeof I < "u" && I;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return g(self) || g(window) || g(this) || {};
  }
}
lI.exports.default = D;
lI.exports.pino = D;
var YC = lI.exports;
const SC = /* @__PURE__ */ hc(YC);
class TC {
  constructor() {
    Fg(this, "logger");
    /**
     * 서버와 log level을 동기화 하기 위한 설정
     * @see {@link https://github.com/winstonjs/winston#logging-levels Winston log level}
     */
    Fg(this, "defaultLogLevelMap");
    this.defaultLogLevelMap = {
      error: 3,
      warn: 4,
      info: 6,
      debug: 7
    }, this.logger = SC(), this.logger.levels = {
      labels: wn(this.defaultLogLevelMap),
      values: this.defaultLogLevelMap
    };
  }
  debug(I) {
    this.log("debug", I);
  }
  info(I) {
    this.log("info", I);
  }
  warn(I) {
    this.log("warn", I);
  }
  error(I) {
    this.log("error", I);
  }
  log(I, e) {
    if (this.isLogLevelKey(I)) {
      this.logger[I](e);
      return;
    }
    const c = this.findLoggerTypeForSyslogLevel(I);
    c && this.logger[c](e);
  }
  isLogLevelKey(I) {
    return typeof I == "string" && fn(Object.keys(this.defaultLogLevelMap), I);
  }
  findLoggerTypeForSyslogLevel(I) {
    const e = this.logger.levels.labels[I];
    return this.isLogLevelKey(e) ? e : null;
  }
}
const Ze = new TC(), zC = 10 * 1e3, HC = [aI.NOT_FOUND, aI.UNAUTHORIZED, aI.BAD_PARAMETER];
class bg extends Al {
  static from(I) {
    return new bg({
      credentials: "include",
      timeout: zC,
      ...I
    });
  }
  afterRequest(I, e, c, l) {
    if (Xg.isHandledResponse(l)) {
      const t = Xg.createApiError(l, {
        status: I,
        handled: !0,
        extra: l,
        url: c.path
      }), {
        level: i,
        message: n
      } = t.logMessage();
      throw Ze[i](n), t;
    }
    return l;
  }
  performError(I) {
    if (!(I instanceof DOMException && I.name === "AbortError") && Xg.isUnhandledResponse(I)) {
      const e = Xg.createApiError({
        statusCode: ul[I.status] || String(I.status),
        message: `[${I.name}] ${I.url} | ${I}`,
        data: null
      }, {
        handled: !1,
        url: I.url,
        status: I.status
      }, HC), {
        level: c,
        message: l
      } = e.logMessage();
      Ze[c](l);
    }
  }
}
const iI = bg.from({
  baseUrl: bC
}), wC = bg.from({
  baseUrl: aC
}), xs = bg.from({
  baseUrl: sC
}), Js = bg.from({
  baseUrl: AC
});
var Bc = /* @__PURE__ */ ((g) => (g.OK = "OK", g.SERVER_ERROR = "SERVER_ERROR", g.DUPLICATE = "DUPLICATE", g.NOT_FOUND = "NOT_FOUND", g.BAD_REQUEST = "BAD_REQUEST", g.BAD_PARAMETER = "BAD_PARAMETER", g.CONFLICT = "CONFLICT", g.UNAUTHORIZED = "UNAUTHORIZED", g.FORBIDDEN = "FORBIDDEN", g.PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE", g.TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS", g))(Bc || {});
const Rs = {
  V1_MESSAGE: "/user/api/v1/messages/unchecked",
  V1_USER_META: "/v1/user/meta",
  V1_GROUP_BY_USER: "/v1/group/by-user",
  V1_GROUP_ID_NOTICE_EXPOSURE: (g) => `/v1/group/${g}/notice/exposure`,
  V1_NOTICE_EXPOSURE: "/v1/notice/exposure"
}, UC = async (g, I) => iI.get(g, I);
function ps({
  queryKey: g,
  url: I,
  options: e,
  requestOptions: c
}) {
  var t;
  const l = yg(g, () => UC(I, c), e);
  return {
    ...l,
    data: (t = l.data) == null ? void 0 : t.data
  };
}
const LC = async (g, I) => iI.get(g, I);
function ys({
  queryKey: g,
  url: I,
  options: e,
  requestOptions: c
}) {
  var t;
  const l = yg(g, () => LC(I, c), e);
  return {
    ...l,
    data: (t = l.data) == null ? void 0 : t.data
  };
}
const OC = async (g, I) => iI.get(g, I);
function Bs({
  queryKey: g,
  url: I,
  options: e,
  requestOptions: c
}) {
  var t;
  const l = yg(g, () => OC(I, c), e);
  return {
    ...l,
    data: (t = l.data) == null ? void 0 : t.data
  };
}
const EC = async (g, I) => iI.get(g, I);
function vs({
  queryKey: g,
  url: I,
  options: e,
  requestOptions: c
}) {
  var t;
  const l = yg(g, () => EC(I, c), e);
  return {
    ...l,
    data: (t = l.data) == null ? void 0 : t.data
  };
}
const EI = () => typeof window < "u", Fs = () => typeof document < "u", fs = () => typeof window < "u", PC = (g) => {
  if (typeof window > "u")
    return "";
  try {
    return new URLSearchParams(window.location.search).get(g) ?? "";
  } catch {
    return "";
  }
}, DC = (g) => new URL(g).hostname.split(".").slice(-2).join("."), jC = (g) => {
  try {
    const I = DC(LI);
    if (!I)
      return !1;
    const e = new URL(g).hostname;
    return e === I || e.endsWith(`.${I}`);
  } catch {
    return !1;
  }
}, nI = (g) => g.replace(/^\/(ko|en|ja|vi)(\/|$)/, "/"), U = {
  COURSES: (g) => g === "/courses" || g.startsWith("/courses/") || g.startsWith("/course/"),
  CHALLENGES: (g) => g.startsWith("/challenges") || g.startsWith("/challenge"),
  MENTORING: (g, I) => I === Eg || g.startsWith("/mentors"),
  ROADMAPS: (g) => g.startsWith("/roadmaps"),
  SEARCH: (g) => g.startsWith("/search"),
  CLIPS: (g) => g.startsWith("/clips") || g.startsWith("/clip"),
  COMMUNITY: (g) => g.startsWith("/community")
}, vc = {
  COURSES: (g) => g === "/" || g === "/courses" || g.startsWith("/courses/"),
  CHALLENGES: (g) => g === "/challenges",
  MENTORING: (g) => g === "/mentors",
  ROADMAPS: (g) => g === "/roadmaps",
  SEARCH: (g) => g === "/search",
  CLIPS: (g) => g === "/clips",
  COMMUNITY: (g) => g === "/community"
}, Ys = () => {
  if (!EI())
    return !1;
  const g = window.location.pathname, I = nI(g);
  return Object.values(vc).some((e) => e(I));
}, kC = (g) => {
  const I = nI(g);
  return Object.values(vc).some((e) => e(I));
}, he = (g) => {
  if (!EI())
    return !1;
  const I = window.location.pathname, e = window.location.origin, c = nI(I);
  return jC(e) ? e === Eg ? g === "MENTORING" : g === "COURSES" ? U.COURSES(c) : g === "ROADMAPS" ? U.ROADMAPS(c) : g === "CLIPS" ? U.CLIPS(c) : g === "CHALLENGES" ? U.CHALLENGES(c) : g === "COMMUNITY" ? U.COMMUNITY(c) : !1 : !1;
}, Ss = () => {
  if (!EI())
    return "COURSES";
  const g = window.location.pathname, I = window.location.origin, e = PC("types"), c = nI(g);
  return U.ROADMAPS(c) ? "ROADMAPS" : U.CHALLENGES(c) ? "CHALLENGES" : U.MENTORING(c, I) ? "MENTORING" : U.CLIPS(c) ? "CLIPS" : e === "CHALLENGE" ? "CHALLENGES" : U.COMMUNITY(c) ? "COMMUNITY" : "COURSES";
}, Hg = "gnb_snapshot", Fc = {
  COURSES: "courses",
  // 강의 메뉴
  ROADMAPS: "roadmaps",
  // 로드맵 메뉴
  MENTORING: "mentoring",
  // 멘토링 메뉴
  COMMUNITY: "community",
  // 커뮤니티 메뉴
  CHALLENGES: "challenges",
  // 챌린지 메뉴
  INSTRUCTOR: "instructor",
  // 강사 메뉴
  BUSINESS: "business",
  // 비즈니스 메뉴
  clips: "clips"
  // 클립 메뉴
}, jg = {
  SHOW_MENU: "data-show-menu",
  // 메뉴 표시 여부 (예: data-show-menu-courses="1")
  LABEL: "data-label",
  // 메뉴 라벨 텍스트 (예: data-label-courses="강의")
  SHOW_BUTTON: "data-show-button",
  // 버튼 표시 여부 (예: data-show-button-profile="1")
  COUNT: "data-count",
  // 카운트 값 (예: data-count-cart="3")
  FEATURE: "data-feature",
  // A/B 테스트 플래그 (예: data-feature-196="1")
  SHOW_SEARCH_BAR: "data-show-search-bar"
  // 검색바 표시 여부 (예: data-show-search-bar="1")
}, RI = {
  LABEL: "--label",
  // 메뉴 라벨 (예: --label-courses: "강의")
  CART_COUNT: "--cart-count",
  // 장바구니 개수 (예: --cart-count: "3")
  GNB_LOGO_URL: "--gnb-logo-url",
  // GNB 로고 이미지 (예: --gnb-logo-url: url('logo.png'))
  PROFILE_THUMBNAIL_URL: "--profile-thumbnail-url"
  // 프로필 썸네일 (예: --profile-thumbnail-url: url('thumb.jpg'))
};
function We(g) {
  const I = {};
  return g && g.split(";").forEach((e) => {
    const c = e.indexOf("=");
    if (c < 0)
      return;
    const l = decodeURIComponent(e.slice(0, c).trim()), t = decodeURIComponent(e.slice(c + 1).trim());
    l && (I[l] = t);
  }), I;
}
function QC(g) {
  return (g == null ? void 0 : g.cookieHeader) != null ? We(g.cookieHeader) : typeof document < "u" ? We(document.cookie) : {};
}
function MC(g) {
  if (g)
    try {
      return JSON.parse(g);
    } catch {
      return;
    }
}
const KC = (g) => g ? `url('${g.replace(/'/g, "\\'")}')` : "none", me = (g) => g ? "1" : "0", _C = (g) => g == null || g === "" ? "0" : "1", qC = (g) => (g ?? "").toString(), fc = (g) => `'${(g ?? "").replace(/'/g, "\\'")}'`, $C = (g, I) => {
  const e = {}, c = {};
  return Object.values(Fc).forEach((l) => {
    const t = g[l], i = l === "courses" || I;
    e[`${jg.SHOW_MENU}-${l}`] = i ? _C(t) : "0", c[`${jg.LABEL}-${l}`] = qC(t);
  }), {
    visibilityAttributes: e,
    labelAttributes: c
  };
}, gb = (g) => {
  const I = {};
  return Object.values(Fc).forEach((e) => {
    const c = g[e];
    I[`${RI.LABEL}-${e}`] = fc(c);
  }), I;
};
function Ib(g, I) {
  const e = {
    attrs: {},
    cssVars: {}
  };
  if (!g)
    return e;
  const c = g.menuList || {}, l = g.lang === "ko", {
    visibilityAttributes: t,
    labelAttributes: i
  } = $C(c, l), n = gb(c);
  Object.assign(e.cssVars, n), e.cssVars[`${RI.LABEL}-language`] = fc(g.lang), Object.assign(e.attrs, t, i);
  const b = I != null && I.pathname ? kC(I.pathname) : !1;
  if (e.attrs[jg.SHOW_SEARCH_BAR] = me(b), g.hackleFeatures)
    for (const [C, a] of Object.entries(g.hackleFeatures))
      e.attrs[`${jg.FEATURE}-${C}`] = me(!!a);
  return e.cssVars[RI.GNB_LOGO_URL] = KC(g.logo), e;
}
function Ts(g) {
  const I = QC(g), e = MC(I[Hg]), c = g != null && g.overwrite ? Zc({}, e, g.overwrite) : e;
  return Ib(c, {
    pathname: g == null ? void 0 : g.pathname
  });
}
function zs(g, I = "html", e = !1) {
  if (typeof document > "u")
    return e;
  const l = (I === "html" ? document.documentElement : I === "body" ? document.body : document.querySelector(I) || document.documentElement).getAttribute(g);
  return l === null ? e : l === "1" || l === "true" || l === "True";
}
function Hs(g, I = "html", e = "") {
  if (typeof document > "u")
    return e;
  const l = (I === "html" ? document.documentElement : I === "body" ? document.body : document.querySelector(I) || document.documentElement).getAttribute(g);
  return l === null ? e : l;
}
function ws(g, I = "html") {
  if (typeof document > "u")
    return;
  const e = I === "html" ? document.documentElement : I === "body" ? document.body : document.querySelector(I) || document.documentElement;
  Object.entries(g.attrs).forEach(([c, l]) => e.setAttribute(c, l)), Object.entries(g.cssVars).forEach(([c, l]) => e.style.setProperty(c, l));
}
function eb(g) {
  return g / (24 * 60);
}
const cb = 60 * 24, lb = () => {
  const g = wg((e) => {
    const c = I(), l = typeof document < "u" && document.documentElement.lang || "ko", t = {
      ...e,
      lang: l
    };
    zg.set(Hg, JSON.stringify(Zc({}, c, t)), eb(cb), "High");
  }, []), I = wg(() => {
    const e = zg.get(Hg);
    if (!e)
      return null;
    try {
      return JSON.parse(e);
    } catch (c) {
      return console.error("Failed to parse GNB Snapshot:", c), zg.remove(Hg), null;
    }
  }, []);
  return {
    setSnapshot: g,
    getSnapshot: I
  };
}, pI = (g) => !!g.group || !!g.managedGroup, tb = (g) => !!g.group, ib = (g) => !!g.managedGroup, nb = (g) => !!g.marketingPartner, Cb = 42, bb = 6233, Us = (g) => g === bb || g === Cb, PI = wC, yI = {
  CLIENT_V2_ACCOUNTS_PROFILE: "/client/api/v2/accounts/profile",
  CLIENT_V2_AUTH_SIGNIN: "/client/api/v2/auth/signin",
  CLIENT_V3_AUTH_SIGNUP_VERIFY_EMAIL: "/client/api/v3/auth/signup/verify/email"
};
function Ls({
  url: g,
  options: I,
  requestOptions: e
}) {
  var l;
  const c = $e({
    mutationFn: (t) => PI.post(g, t, e),
    ...I
  });
  return {
    ...c,
    data: (l = c.data) == null ? void 0 : l.data
  };
}
function Os({
  url: g,
  options: I,
  requestOptions: e
}) {
  var l;
  const c = $e({
    mutationFn: (t) => PI.post(g, t, e),
    ...I
  });
  return {
    ...c,
    data: (l = c.data) == null ? void 0 : l.data
  };
}
const ab = async (g, I) => PI.get(g, I), sb = ({
  queryKey: g,
  url: I,
  options: e,
  requestOptions: c
}) => ({
  queryKey: g,
  queryFn: () => ab(I, c),
  ...e
});
function Ab(g) {
  var e;
  const I = yg(sb(g));
  return {
    ...I,
    data: (e = I.data) == null ? void 0 : e.data
  };
}
const Es = (g) => g * (24 * (60 * (1e3 * 60))), Ps = (g) => g * 1e3, Ne = (g) => g * (1e3 * 60);
function ub(g) {
  const I = g == null ? void 0 : g.options;
  return Ab({
    queryKey: [yI.CLIENT_V2_ACCOUNTS_PROFILE],
    url: yI.CLIENT_V2_ACCOUNTS_PROFILE,
    options: {
      cacheTime: Ne(1),
      staleTime: Ne(1),
      suspense: !1,
      useErrorBoundary: !1,
      keepPreviousData: !0,
      refetchOnReconnect: !0,
      ...I
    }
  });
}
const Yc = $g(null), Ds = (g) => /* @__PURE__ */ Z(Yc.Provider, { value: {
  isShowing: g.isShowing
}, children: g.children }), rb = () => {
  const g = gI(Yc);
  if (!g)
    throw Error("useShowLoginNeededNotificationContext must use in ShowLoginNeededNotificationContext");
  return g;
};
function db(g) {
  const {
    isShowing: I
  } = rb(), {
    showNotification: e
  } = Il(), {
    t: c
  } = Jc();
  eg(() => {
    g instanceof Xg && g.statusCode === Bc.UNAUTHORIZED && I && (el("UNAUTHORIZED"), e({
      type: "error",
      id: "UNAUTHORIZED",
      title: c("로그인이 필요한 요청입니다.")
    }));
  }, [I, g]);
}
var Sc = {}, ob = (g) => encodeURIComponent(g).replace(/[!'()*]/g, (I) => `%${I.charCodeAt(0).toString(16).toUpperCase()}`), Tc = "%[a-f0-9]{2}", xe = new RegExp("(" + Tc + ")|([^%]+?)", "gi"), Je = new RegExp("(" + Tc + ")+", "gi");
function BI(g, I) {
  try {
    return [decodeURIComponent(g.join(""))];
  } catch {
  }
  if (g.length === 1)
    return g;
  I = I || 1;
  var e = g.slice(0, I), c = g.slice(I);
  return Array.prototype.concat.call([], BI(e), BI(c));
}
function Gb(g) {
  try {
    return decodeURIComponent(g);
  } catch {
    for (var I = g.match(xe) || [], e = 1; e < I.length; e++)
      g = BI(I, e).join(""), I = g.match(xe) || [];
    return g;
  }
}
function Xb(g) {
  for (var I = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  }, e = Je.exec(g); e; ) {
    try {
      I[e[0]] = decodeURIComponent(e[0]);
    } catch {
      var c = Gb(e[0]);
      c !== e[0] && (I[e[0]] = c);
    }
    e = Je.exec(g);
  }
  I["%C2"] = "�";
  for (var l = Object.keys(I), t = 0; t < l.length; t++) {
    var i = l[t];
    g = g.replace(new RegExp(i, "g"), I[i]);
  }
  return g;
}
var Vb = function(g) {
  if (typeof g != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof g + "`");
  try {
    return g = g.replace(/\+/g, " "), decodeURIComponent(g);
  } catch {
    return Xb(g);
  }
}, Zb = (g, I) => {
  if (!(typeof g == "string" && typeof I == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (I === "")
    return [g];
  const e = g.indexOf(I);
  return e === -1 ? [g] : [
    g.slice(0, e),
    g.slice(e + I.length)
  ];
}, hb = function(g, I) {
  for (var e = {}, c = Object.keys(g), l = Array.isArray(I), t = 0; t < c.length; t++) {
    var i = c[t], n = g[i];
    (l ? I.indexOf(i) !== -1 : I(i, n, g)) && (e[i] = n);
  }
  return e;
};
(function(g) {
  const I = ob, e = Vb, c = Zb, l = hb, t = (s) => s == null, i = Symbol("encodeFragmentIdentifier");
  function n(s) {
    switch (s.arrayFormat) {
      case "index":
        return (d) => (r, o) => {
          const X = r.length;
          return o === void 0 || s.skipNull && o === null || s.skipEmptyString && o === "" ? r : o === null ? [...r, [a(d, s), "[", X, "]"].join("")] : [
            ...r,
            [a(d, s), "[", a(X, s), "]=", a(o, s)].join("")
          ];
        };
      case "bracket":
        return (d) => (r, o) => o === void 0 || s.skipNull && o === null || s.skipEmptyString && o === "" ? r : o === null ? [...r, [a(d, s), "[]"].join("")] : [...r, [a(d, s), "[]=", a(o, s)].join("")];
      case "colon-list-separator":
        return (d) => (r, o) => o === void 0 || s.skipNull && o === null || s.skipEmptyString && o === "" ? r : o === null ? [...r, [a(d, s), ":list="].join("")] : [...r, [a(d, s), ":list=", a(o, s)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const d = s.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (r) => (o, X) => X === void 0 || s.skipNull && X === null || s.skipEmptyString && X === "" ? o : (X = X === null ? "" : X, o.length === 0 ? [[a(r, s), d, a(X, s)].join("")] : [[o, a(X, s)].join(s.arrayFormatSeparator)]);
      }
      default:
        return (d) => (r, o) => o === void 0 || s.skipNull && o === null || s.skipEmptyString && o === "" ? r : o === null ? [...r, a(d, s)] : [...r, [a(d, s), "=", a(o, s)].join("")];
    }
  }
  function b(s) {
    let d;
    switch (s.arrayFormat) {
      case "index":
        return (r, o, X) => {
          if (d = /\[(\d*)\]$/.exec(r), r = r.replace(/\[\d*\]$/, ""), !d) {
            X[r] = o;
            return;
          }
          X[r] === void 0 && (X[r] = {}), X[r][d[1]] = o;
        };
      case "bracket":
        return (r, o, X) => {
          if (d = /(\[\])$/.exec(r), r = r.replace(/\[\]$/, ""), !d) {
            X[r] = o;
            return;
          }
          if (X[r] === void 0) {
            X[r] = [o];
            return;
          }
          X[r] = [].concat(X[r], o);
        };
      case "colon-list-separator":
        return (r, o, X) => {
          if (d = /(:list)$/.exec(r), r = r.replace(/:list$/, ""), !d) {
            X[r] = o;
            return;
          }
          if (X[r] === void 0) {
            X[r] = [o];
            return;
          }
          X[r] = [].concat(X[r], o);
        };
      case "comma":
      case "separator":
        return (r, o, X) => {
          const m = typeof o == "string" && o.includes(s.arrayFormatSeparator), h = typeof o == "string" && !m && u(o, s).includes(s.arrayFormatSeparator);
          o = h ? u(o, s) : o;
          const R = m || h ? o.split(s.arrayFormatSeparator).map((S) => u(S, s)) : o === null ? o : u(o, s);
          X[r] = R;
        };
      case "bracket-separator":
        return (r, o, X) => {
          const m = /(\[\])$/.test(r);
          if (r = r.replace(/\[\]$/, ""), !m) {
            X[r] = o && u(o, s);
            return;
          }
          const h = o === null ? [] : o.split(s.arrayFormatSeparator).map((R) => u(R, s));
          if (X[r] === void 0) {
            X[r] = h;
            return;
          }
          X[r] = [].concat(X[r], h);
        };
      default:
        return (r, o, X) => {
          if (X[r] === void 0) {
            X[r] = o;
            return;
          }
          X[r] = [].concat(X[r], o);
        };
    }
  }
  function C(s) {
    if (typeof s != "string" || s.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function a(s, d) {
    return d.encode ? d.strict ? I(s) : encodeURIComponent(s) : s;
  }
  function u(s, d) {
    return d.decode ? e(s) : s;
  }
  function A(s) {
    return Array.isArray(s) ? s.sort() : typeof s == "object" ? A(Object.keys(s)).sort((d, r) => Number(d) - Number(r)).map((d) => s[d]) : s;
  }
  function G(s) {
    const d = s.indexOf("#");
    return d !== -1 && (s = s.slice(0, d)), s;
  }
  function N(s) {
    let d = "";
    const r = s.indexOf("#");
    return r !== -1 && (d = s.slice(r)), d;
  }
  function W(s) {
    s = G(s);
    const d = s.indexOf("?");
    return d === -1 ? "" : s.slice(d + 1);
  }
  function J(s, d) {
    return d.parseNumbers && !Number.isNaN(Number(s)) && typeof s == "string" && s.trim() !== "" ? s = Number(s) : d.parseBooleans && s !== null && (s.toLowerCase() === "true" || s.toLowerCase() === "false") && (s = s.toLowerCase() === "true"), s;
  }
  function y(s, d) {
    d = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, d), C(d.arrayFormatSeparator);
    const r = b(d), o = /* @__PURE__ */ Object.create(null);
    if (typeof s != "string" || (s = s.trim().replace(/^[?#&]/, ""), !s))
      return o;
    for (const X of s.split("&")) {
      if (X === "")
        continue;
      let [m, h] = c(d.decode ? X.replace(/\+/g, " ") : X, "=");
      h = h === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(d.arrayFormat) ? h : u(h, d), r(u(m, d), h, o);
    }
    for (const X of Object.keys(o)) {
      const m = o[X];
      if (typeof m == "object" && m !== null)
        for (const h of Object.keys(m))
          m[h] = J(m[h], d);
      else
        o[X] = J(m, d);
    }
    return d.sort === !1 ? o : (d.sort === !0 ? Object.keys(o).sort() : Object.keys(o).sort(d.sort)).reduce((X, m) => {
      const h = o[m];
      return h && typeof h == "object" && !Array.isArray(h) ? X[m] = A(h) : X[m] = h, X;
    }, /* @__PURE__ */ Object.create(null));
  }
  g.extract = W, g.parse = y, g.stringify = (s, d) => {
    if (!s)
      return "";
    d = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, d), C(d.arrayFormatSeparator);
    const r = (h) => d.skipNull && t(s[h]) || d.skipEmptyString && s[h] === "", o = n(d), X = {};
    for (const h of Object.keys(s))
      r(h) || (X[h] = s[h]);
    const m = Object.keys(X);
    return d.sort !== !1 && m.sort(d.sort), m.map((h) => {
      const R = s[h];
      return R === void 0 ? "" : R === null ? a(h, d) : Array.isArray(R) ? R.length === 0 && d.arrayFormat === "bracket-separator" ? a(h, d) + "[]" : R.reduce(o(h), []).join("&") : a(h, d) + "=" + a(R, d);
    }).filter((h) => h.length > 0).join("&");
  }, g.parseUrl = (s, d) => {
    d = Object.assign({
      decode: !0
    }, d);
    const [r, o] = c(s, "#");
    return Object.assign(
      {
        url: r.split("?")[0] || "",
        query: y(W(s), d)
      },
      d && d.parseFragmentIdentifier && o ? { fragmentIdentifier: u(o, d) } : {}
    );
  }, g.stringifyUrl = (s, d) => {
    d = Object.assign({
      encode: !0,
      strict: !0,
      [i]: !0
    }, d);
    const r = G(s.url).split("?")[0] || "", o = g.extract(s.url), X = g.parse(o, { sort: !1 }), m = Object.assign(X, s.query);
    let h = g.stringify(m, d);
    h && (h = `?${h}`);
    let R = N(s.url);
    return s.fragmentIdentifier && (R = `#${d[i] ? a(s.fragmentIdentifier, d) : s.fragmentIdentifier}`), `${r}${h}${R}`;
  }, g.pick = (s, d, r) => {
    r = Object.assign({
      parseFragmentIdentifier: !0,
      [i]: !1
    }, r);
    const { url: o, query: X, fragmentIdentifier: m } = g.parseUrl(s, r);
    return g.stringifyUrl({
      url: o,
      query: l(X, d),
      fragmentIdentifier: m
    }, r);
  }, g.exclude = (s, d, r) => {
    const o = Array.isArray(d) ? (X) => !d.includes(X) : (X, m) => !d(X, m);
    return g.pick(s, o, r);
  };
})(Sc);
const O = /* @__PURE__ */ hc(Sc), Wb = {
  CLICK_SEARCHBAR: "click_searchbar",
  GNB_NOTI_ICON_CLICK: "GNB_noti-icon-click",
  GNB_ROADMAP_CLICK: "GNB_roadmap-click",
  GNB_PROFILE_ICON_CLICK: "GNB_profile-icon-click",
  GNB_OPENKNOWLEDGE_CLICK: "GNB_openknowledge-click",
  GNB_MENTORS_CLICK: "GNB_mentors-click",
  GNB_LOGIN_BTN_CLICK: "GNB_login-btn-click",
  CLICK_CATEGORY_AT_HEADER: "click_category_at_header",
  VIEW_SIGNIN_MODAL: "view_signin_modal",
  CLICK_SIGNIN_AT_SIGNIN: "click_signin_at_signin",
  CLICK_FIND_ID_AT_SIGNIN: "click_find_id_at_signin",
  CLICK_FIND_PW_AT_SIGNIN: "click_find_pw_at_signin",
  CLICK_SIGNUP_AT_SIGNIN: "click_signup_at_signin",
  /**
   * @deprecated 헤더 '인프런' 메뉴 deprecated
   * */
  GNB_COURSES_CLICK: "GNB_courses-click",
  GNB_COMMUNITY_CLICK: "GNB_community-click",
  GNB_CART_COURSE_CLICK: "GNB_cart-course-click",
  GNB_CART_TOTAL_CLICK: "GNB_cart-total-click",
  GNB_INFLEARN_LOGO_CLICK: "GNB_inflearn-logo-click",
  GNB_CART_ICON_CLICK: "GNB_cart-icon-click",
  GNB_RALLIT_CLICK: "GNB_Rallit_Click",
  GNB_SEARCH_ICON_CLICK: "GNB_search-icon-click",
  GNB_SEARCH_INPUT_CLICK: "GNB_search-input-click",
  GNB_DASHBOARD_CLICK: "GNB_dashboard-click",
  HEADER_BUSINESS_CLICK: "Header_business-click",
  HEADER_INFLEARN_CLICK: "Header_inflearn-click",
  HEADER_INSTRUCTOR_CLICK: "Header_instructor-click",
  HEADER_BIZ_INTRO_CLICK: "header_biz-intro-click",
  COMPLETE_SIGNUP: "complete_signup",
  COMPLETE_REGISTRATION: "complete_registration",
  CLICK_WELCOME_BUTTON: "click_welcome_button",
  CLICK_MYCATEGORY_GUIDE_BUTTON: "click_mycategory_guide_button",
  VIEW_MYCATEGORY: "view_mycategory",
  CLICK_SAVE_MYCATEGORY: "click_save_mycategory",
  SEARCH_COURSE: "search_course",
  EXPERIMENT_STARTED: "experiment_started",
  /**
   * 신규 헤더 신규 이벤트
   */
  CLICK_HEADER_MENU: "click_header_menu",
  CLICK_LOGO_AT_HEADER: "click_logo_at_header",
  CLICK_LOGIN_AT_HEADER: "click_login_at_header",
  CLICK_CART_AT_HEADER: "click_cart_at_header",
  CLICK_PROFILE_MENU_AT_HEADER: "click_profile_menu_at_header",
  CLICK_CATEGORY_AT_SEARCHBAR: "click_category_at_searchbar",
  CLICK_HEADER_MENU_AT_SEARCHBAR: "click_header_menu_at_searchbar",
  CLICK_RECOMMENDATION_AT_SEARCHBAR: "click_recommendation_at_searchbar",
  CLICK_HEADER_NOTICE: "click_header_notice",
  CLICK_SERVICE_MENU_AT_HEADER: "click_service_menu_at_header",
  /**
   * Footer 이벤트
   */
  CLICK_INTRO_BUSINESS: "click_intro_business"
};
var Ig = { ko: "ko", en: "en", ja: "ja", vi: "vi" }, cg = Ig.ko;
Object.values(Ig);
var mb = { [Ig.ko]: "82", [Ig.en]: "1", [Ig.ja]: "81", [Ig.vi]: "84" }, Nb = { ko: "ko-KR", en: "en-US", ja: "ja-JP", vi: "vi-VN" };
function xb() {
  let { i18n: g } = xc();
  return qe(() => {
    let I = g.language || cg;
    return { lang: I, locale: Nb[I], countryCode: mb[I], isKo: I === cg };
  }, [g.language]);
}
var js = ({ children: g }) => {
  let { isKo: I } = xb();
  return ll(tl, { children: I && g });
};
pg.extend(nl);
pg.extend(bl);
pg.extend(Cl);
pg.extend(il);
pg.updateLocale("ko", { formats: { L: "YYYY. MM. DD.", LL: "YYYY년 MM월 DD일", LT: "A h:mm" } });
const x = (g) => typeof g == "string", rg = () => {
  let g, I;
  const e = new Promise((c, l) => {
    g = c, I = l;
  });
  return e.resolve = g, e.reject = I, e;
}, Re = (g) => g == null ? "" : "" + g, Jb = (g, I, e) => {
  g.forEach((c) => {
    I[c] && (e[c] = I[c]);
  });
}, Rb = /###/g, pe = (g) => g && g.indexOf("###") > -1 ? g.replace(Rb, ".") : g, ye = (g) => !g || x(g), Zg = (g, I, e) => {
  const c = x(I) ? I.split(".") : I;
  let l = 0;
  for (; l < c.length - 1; ) {
    if (ye(g))
      return {};
    const t = pe(c[l]);
    !g[t] && e && (g[t] = new e()), Object.prototype.hasOwnProperty.call(g, t) ? g = g[t] : g = {}, ++l;
  }
  return ye(g) ? {} : {
    obj: g,
    k: pe(c[l])
  };
}, Be = (g, I, e) => {
  const {
    obj: c,
    k: l
  } = Zg(g, I, Object);
  if (c !== void 0 || I.length === 1) {
    c[l] = e;
    return;
  }
  let t = I[I.length - 1], i = I.slice(0, I.length - 1), n = Zg(g, i, Object);
  for (; n.obj === void 0 && i.length; )
    t = `${i[i.length - 1]}.${t}`, i = i.slice(0, i.length - 1), n = Zg(g, i, Object), n && n.obj && typeof n.obj[`${n.k}.${t}`] < "u" && (n.obj = void 0);
  n.obj[`${n.k}.${t}`] = e;
}, pb = (g, I, e, c) => {
  const {
    obj: l,
    k: t
  } = Zg(g, I, Object);
  l[t] = l[t] || [], l[t].push(e);
}, kg = (g, I) => {
  const {
    obj: e,
    k: c
  } = Zg(g, I);
  if (e)
    return e[c];
}, yb = (g, I, e) => {
  const c = kg(g, e);
  return c !== void 0 ? c : kg(I, e);
}, zc = (g, I, e) => {
  for (const c in I)
    c !== "__proto__" && c !== "constructor" && (c in g ? x(g[c]) || g[c] instanceof String || x(I[c]) || I[c] instanceof String ? e && (g[c] = I[c]) : zc(g[c], I[c], e) : g[c] = I[c]);
  return g;
}, $ = (g) => g.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Bb = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const vb = (g) => x(g) ? g.replace(/[&<>"'\/]/g, (I) => Bb[I]) : g;
class Fb {
  constructor(I) {
    this.capacity = I, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(I) {
    const e = this.regExpMap.get(I);
    if (e !== void 0)
      return e;
    const c = new RegExp(I);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(I, c), this.regExpQueue.push(I), c;
  }
}
const fb = [" ", ",", "?", "!", ";"], Yb = new Fb(20), Sb = (g, I, e) => {
  I = I || "", e = e || "";
  const c = fb.filter((i) => I.indexOf(i) < 0 && e.indexOf(i) < 0);
  if (c.length === 0)
    return !0;
  const l = Yb.getRegExp(`(${c.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let t = !l.test(g);
  if (!t) {
    const i = g.indexOf(e);
    i > 0 && !l.test(g.substring(0, i)) && (t = !0);
  }
  return t;
}, vI = function(g, I) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!g)
    return;
  if (g[I])
    return g[I];
  const c = I.split(e);
  let l = g;
  for (let t = 0; t < c.length; ) {
    if (!l || typeof l != "object")
      return;
    let i, n = "";
    for (let b = t; b < c.length; ++b)
      if (b !== t && (n += e), n += c[b], i = l[n], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && b < c.length - 1)
          continue;
        t += b - t + 1;
        break;
      }
    l = i;
  }
  return l;
}, Qg = (g) => g && g.replace("_", "-"), Tb = {
  type: "logger",
  log(g) {
    this.output("log", g);
  },
  warn(g) {
    this.output("warn", g);
  },
  error(g) {
    this.output("error", g);
  },
  output(g, I) {
    console && console[g] && console[g].apply(console, I);
  }
};
class Mg {
  constructor(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(I, e);
  }
  init(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = e.prefix || "i18next:", this.logger = I || Tb, this.options = e, this.debug = e.debug;
  }
  log() {
    for (var I = arguments.length, e = new Array(I), c = 0; c < I; c++)
      e[c] = arguments[c];
    return this.forward(e, "log", "", !0);
  }
  warn() {
    for (var I = arguments.length, e = new Array(I), c = 0; c < I; c++)
      e[c] = arguments[c];
    return this.forward(e, "warn", "", !0);
  }
  error() {
    for (var I = arguments.length, e = new Array(I), c = 0; c < I; c++)
      e[c] = arguments[c];
    return this.forward(e, "error", "");
  }
  deprecate() {
    for (var I = arguments.length, e = new Array(I), c = 0; c < I; c++)
      e[c] = arguments[c];
    return this.forward(e, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(I, e, c, l) {
    return l && !this.debug ? null : (x(I[0]) && (I[0] = `${c}${this.prefix} ${I[0]}`), this.logger[e](I));
  }
  create(I) {
    return new Mg(this.logger, {
      prefix: `${this.prefix}:${I}:`,
      ...this.options
    });
  }
  clone(I) {
    return I = I || this.options, I.prefix = I.prefix || this.prefix, new Mg(this.logger, I);
  }
}
var L = new Mg();
class CI {
  constructor() {
    this.observers = {};
  }
  on(I, e) {
    return I.split(" ").forEach((c) => {
      this.observers[c] || (this.observers[c] = /* @__PURE__ */ new Map());
      const l = this.observers[c].get(e) || 0;
      this.observers[c].set(e, l + 1);
    }), this;
  }
  off(I, e) {
    if (this.observers[I]) {
      if (!e) {
        delete this.observers[I];
        return;
      }
      this.observers[I].delete(e);
    }
  }
  emit(I) {
    for (var e = arguments.length, c = new Array(e > 1 ? e - 1 : 0), l = 1; l < e; l++)
      c[l - 1] = arguments[l];
    this.observers[I] && Array.from(this.observers[I].entries()).forEach((i) => {
      let [n, b] = i;
      for (let C = 0; C < b; C++)
        n(...c);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((i) => {
      let [n, b] = i;
      for (let C = 0; C < b; C++)
        n.apply(n, [I, ...c]);
    });
  }
}
class ve extends CI {
  constructor(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = I || {}, this.options = e, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(I) {
    this.options.ns.indexOf(I) < 0 && this.options.ns.push(I);
  }
  removeNamespaces(I) {
    const e = this.options.ns.indexOf(I);
    e > -1 && this.options.ns.splice(e, 1);
  }
  getResource(I, e, c) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const t = l.keySeparator !== void 0 ? l.keySeparator : this.options.keySeparator, i = l.ignoreJSONStructure !== void 0 ? l.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let n;
    I.indexOf(".") > -1 ? n = I.split(".") : (n = [I, e], c && (Array.isArray(c) ? n.push(...c) : x(c) && t ? n.push(...c.split(t)) : n.push(c)));
    const b = kg(this.data, n);
    return !b && !e && !c && I.indexOf(".") > -1 && (I = n[0], e = n[1], c = n.slice(2).join(".")), b || !i || !x(c) ? b : vI(this.data && this.data[I] && this.data[I][e], c, t);
  }
  addResource(I, e, c, l) {
    let t = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const i = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let n = [I, e];
    c && (n = n.concat(i ? c.split(i) : c)), I.indexOf(".") > -1 && (n = I.split("."), l = e, e = n[1]), this.addNamespaces(e), Be(this.data, n, l), t.silent || this.emit("added", I, e, c, l);
  }
  addResources(I, e, c) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const t in c)
      (x(c[t]) || Array.isArray(c[t])) && this.addResource(I, e, t, c[t], {
        silent: !0
      });
    l.silent || this.emit("added", I, e, c);
  }
  addResourceBundle(I, e, c, l, t) {
    let i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, n = [I, e];
    I.indexOf(".") > -1 && (n = I.split("."), l = c, c = e, e = n[1]), this.addNamespaces(e);
    let b = kg(this.data, n) || {};
    i.skipCopy || (c = JSON.parse(JSON.stringify(c))), l ? zc(b, c, t) : b = {
      ...b,
      ...c
    }, Be(this.data, n, b), i.silent || this.emit("added", I, e, c);
  }
  removeResourceBundle(I, e) {
    this.hasResourceBundle(I, e) && delete this.data[I][e], this.removeNamespaces(e), this.emit("removed", I, e);
  }
  hasResourceBundle(I, e) {
    return this.getResource(I, e) !== void 0;
  }
  getResourceBundle(I, e) {
    return e || (e = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(I, e)
    } : this.getResource(I, e);
  }
  getDataByLanguage(I) {
    return this.data[I];
  }
  hasLanguageSomeTranslations(I) {
    const e = this.getDataByLanguage(I);
    return !!(e && Object.keys(e) || []).find((l) => e[l] && Object.keys(e[l]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Hc = {
  processors: {},
  addPostProcessor(g) {
    this.processors[g.name] = g;
  },
  handle(g, I, e, c, l) {
    return g.forEach((t) => {
      this.processors[t] && (I = this.processors[t].process(I, e, c, l));
    }), I;
  }
};
const Fe = {};
class Kg extends CI {
  constructor(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Jb(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], I, this), this.options = e, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = L.create("translator");
  }
  changeLanguage(I) {
    I && (this.language = I);
  }
  exists(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (I == null)
      return !1;
    const c = this.resolve(I, e);
    return c && c.res !== void 0;
  }
  extractFromKey(I, e) {
    let c = e.nsSeparator !== void 0 ? e.nsSeparator : this.options.nsSeparator;
    c === void 0 && (c = ":");
    const l = e.keySeparator !== void 0 ? e.keySeparator : this.options.keySeparator;
    let t = e.ns || this.options.defaultNS || [];
    const i = c && I.indexOf(c) > -1, n = !this.options.userDefinedKeySeparator && !e.keySeparator && !this.options.userDefinedNsSeparator && !e.nsSeparator && !Sb(I, c, l);
    if (i && !n) {
      const b = I.match(this.interpolator.nestingRegexp);
      if (b && b.length > 0)
        return {
          key: I,
          namespaces: t
        };
      const C = I.split(c);
      (c !== l || c === l && this.options.ns.indexOf(C[0]) > -1) && (t = C.shift()), I = C.join(l);
    }
    return x(t) && (t = [t]), {
      key: I,
      namespaces: t
    };
  }
  translate(I, e, c) {
    if (typeof e != "object" && this.options.overloadTranslationOptionHandler && (e = this.options.overloadTranslationOptionHandler(arguments)), typeof e == "object" && (e = {
      ...e
    }), e || (e = {}), I == null)
      return "";
    Array.isArray(I) || (I = [String(I)]);
    const l = e.returnDetails !== void 0 ? e.returnDetails : this.options.returnDetails, t = e.keySeparator !== void 0 ? e.keySeparator : this.options.keySeparator, {
      key: i,
      namespaces: n
    } = this.extractFromKey(I[I.length - 1], e), b = n[n.length - 1], C = e.lng || this.language, a = e.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (C && C.toLowerCase() === "cimode") {
      if (a) {
        const r = e.nsSeparator || this.options.nsSeparator;
        return l ? {
          res: `${b}${r}${i}`,
          usedKey: i,
          exactUsedKey: i,
          usedLng: C,
          usedNS: b,
          usedParams: this.getUsedParamsDetails(e)
        } : `${b}${r}${i}`;
      }
      return l ? {
        res: i,
        usedKey: i,
        exactUsedKey: i,
        usedLng: C,
        usedNS: b,
        usedParams: this.getUsedParamsDetails(e)
      } : i;
    }
    const u = this.resolve(I, e);
    let A = u && u.res;
    const G = u && u.usedKey || i, N = u && u.exactUsedKey || i, W = Object.prototype.toString.apply(A), J = ["[object Number]", "[object Function]", "[object RegExp]"], y = e.joinArrays !== void 0 ? e.joinArrays : this.options.joinArrays, s = !this.i18nFormat || this.i18nFormat.handleAsObject, d = !x(A) && typeof A != "boolean" && typeof A != "number";
    if (s && A && d && J.indexOf(W) < 0 && !(x(y) && Array.isArray(A))) {
      if (!e.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(G, A, {
          ...e,
          ns: n
        }) : `key '${i} (${this.language})' returned an object instead of string.`;
        return l ? (u.res = r, u.usedParams = this.getUsedParamsDetails(e), u) : r;
      }
      if (t) {
        const r = Array.isArray(A), o = r ? [] : {}, X = r ? N : G;
        for (const m in A)
          if (Object.prototype.hasOwnProperty.call(A, m)) {
            const h = `${X}${t}${m}`;
            o[m] = this.translate(h, {
              ...e,
              joinArrays: !1,
              ns: n
            }), o[m] === h && (o[m] = A[m]);
          }
        A = o;
      }
    } else if (s && x(y) && Array.isArray(A))
      A = A.join(y), A && (A = this.extendTranslation(A, I, e, c));
    else {
      let r = !1, o = !1;
      const X = e.count !== void 0 && !x(e.count), m = Kg.hasDefaultValue(e), h = X ? this.pluralResolver.getSuffix(C, e.count, e) : "", R = e.ordinal && X ? this.pluralResolver.getSuffix(C, e.count, {
        ordinal: !1
      }) : "", S = X && !e.ordinal && e.count === 0 && this.pluralResolver.shouldUseIntlApi(), f = S && e[`defaultValue${this.options.pluralSeparator}zero`] || e[`defaultValue${h}`] || e[`defaultValue${R}`] || e.defaultValue;
      !this.isValidLookup(A) && m && (r = !0, A = f), this.isValidLookup(A) || (o = !0, A = i);
      const qc = (e.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && o ? void 0 : A, ag = m && f !== A && this.options.updateMissing;
      if (o || r || ag) {
        if (this.logger.log(ag ? "updateKey" : "missingKey", C, b, i, ag ? f : A), t) {
          const T = this.resolve(i, {
            ...e,
            keySeparator: !1
          });
          T && T.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let sg = [];
        const vg = this.languageUtils.getFallbackCodes(this.options.fallbackLng, e.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && vg && vg[0])
          for (let T = 0; T < vg.length; T++)
            sg.push(vg[T]);
        else
          this.options.saveMissingTo === "all" ? sg = this.languageUtils.toResolveHierarchy(e.lng || this.language) : sg.push(e.lng || this.language);
        const MI = (T, Q, Ag) => {
          const KI = m && Ag !== A ? Ag : qc;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(T, b, Q, KI, ag, e) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(T, b, Q, KI, ag, e), this.emit("missingKey", T, b, Q, A);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && X ? sg.forEach((T) => {
          const Q = this.pluralResolver.getSuffixes(T, e);
          S && e[`defaultValue${this.options.pluralSeparator}zero`] && Q.indexOf(`${this.options.pluralSeparator}zero`) < 0 && Q.push(`${this.options.pluralSeparator}zero`), Q.forEach((Ag) => {
            MI([T], i + Ag, e[`defaultValue${Ag}`] || f);
          });
        }) : MI(sg, i, f));
      }
      A = this.extendTranslation(A, I, e, u, c), o && A === i && this.options.appendNamespaceToMissingKey && (A = `${b}:${i}`), (o || r) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? A = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${b}:${i}` : i, r ? A : void 0) : A = this.options.parseMissingKeyHandler(A));
    }
    return l ? (u.res = A, u.usedParams = this.getUsedParamsDetails(e), u) : A;
  }
  extendTranslation(I, e, c, l, t) {
    var i = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      I = this.i18nFormat.parse(I, {
        ...this.options.interpolation.defaultVariables,
        ...c
      }, c.lng || this.language || l.usedLng, l.usedNS, l.usedKey, {
        resolved: l
      });
    else if (!c.skipInterpolation) {
      c.interpolation && this.interpolator.init({
        ...c,
        interpolation: {
          ...this.options.interpolation,
          ...c.interpolation
        }
      });
      const C = x(I) && (c && c.interpolation && c.interpolation.skipOnVariables !== void 0 ? c.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let a;
      if (C) {
        const A = I.match(this.interpolator.nestingRegexp);
        a = A && A.length;
      }
      let u = c.replace && !x(c.replace) ? c.replace : c;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), I = this.interpolator.interpolate(I, u, c.lng || this.language || l.usedLng, c), C) {
        const A = I.match(this.interpolator.nestingRegexp), G = A && A.length;
        a < G && (c.nest = !1);
      }
      !c.lng && this.options.compatibilityAPI !== "v1" && l && l.res && (c.lng = this.language || l.usedLng), c.nest !== !1 && (I = this.interpolator.nest(I, function() {
        for (var A = arguments.length, G = new Array(A), N = 0; N < A; N++)
          G[N] = arguments[N];
        return t && t[0] === G[0] && !c.context ? (i.logger.warn(`It seems you are nesting recursively key: ${G[0]} in key: ${e[0]}`), null) : i.translate(...G, e);
      }, c)), c.interpolation && this.interpolator.reset();
    }
    const n = c.postProcess || this.options.postProcess, b = x(n) ? [n] : n;
    return I != null && b && b.length && c.applyPostProcessor !== !1 && (I = Hc.handle(b, I, e, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...l,
        usedParams: this.getUsedParamsDetails(c)
      },
      ...c
    } : c, this)), I;
  }
  resolve(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c, l, t, i, n;
    return x(I) && (I = [I]), I.forEach((b) => {
      if (this.isValidLookup(c))
        return;
      const C = this.extractFromKey(b, e), a = C.key;
      l = a;
      let u = C.namespaces;
      this.options.fallbackNS && (u = u.concat(this.options.fallbackNS));
      const A = e.count !== void 0 && !x(e.count), G = A && !e.ordinal && e.count === 0 && this.pluralResolver.shouldUseIntlApi(), N = e.context !== void 0 && (x(e.context) || typeof e.context == "number") && e.context !== "", W = e.lngs ? e.lngs : this.languageUtils.toResolveHierarchy(e.lng || this.language, e.fallbackLng);
      u.forEach((J) => {
        this.isValidLookup(c) || (n = J, !Fe[`${W[0]}-${J}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(n) && (Fe[`${W[0]}-${J}`] = !0, this.logger.warn(`key "${l}" for languages "${W.join(", ")}" won't get resolved as namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), W.forEach((y) => {
          if (this.isValidLookup(c))
            return;
          i = y;
          const s = [a];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(s, a, y, J, e);
          else {
            let r;
            A && (r = this.pluralResolver.getSuffix(y, e.count, e));
            const o = `${this.options.pluralSeparator}zero`, X = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (A && (s.push(a + r), e.ordinal && r.indexOf(X) === 0 && s.push(a + r.replace(X, this.options.pluralSeparator)), G && s.push(a + o)), N) {
              const m = `${a}${this.options.contextSeparator}${e.context}`;
              s.push(m), A && (s.push(m + r), e.ordinal && r.indexOf(X) === 0 && s.push(m + r.replace(X, this.options.pluralSeparator)), G && s.push(m + o));
            }
          }
          let d;
          for (; d = s.pop(); )
            this.isValidLookup(c) || (t = d, c = this.getResource(y, J, d, e));
        }));
      });
    }), {
      res: c,
      usedKey: l,
      exactUsedKey: t,
      usedLng: i,
      usedNS: n
    };
  }
  isValidLookup(I) {
    return I !== void 0 && !(!this.options.returnNull && I === null) && !(!this.options.returnEmptyString && I === "");
  }
  getResource(I, e, c) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(I, e, c, l) : this.resourceStore.getResource(I, e, c, l);
  }
  getUsedParamsDetails() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const e = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], c = I.replace && !x(I.replace);
    let l = c ? I.replace : I;
    if (c && typeof I.count < "u" && (l.count = I.count), this.options.interpolation.defaultVariables && (l = {
      ...this.options.interpolation.defaultVariables,
      ...l
    }), !c) {
      l = {
        ...l
      };
      for (const t of e)
        delete l[t];
    }
    return l;
  }
  static hasDefaultValue(I) {
    const e = "defaultValue";
    for (const c in I)
      if (Object.prototype.hasOwnProperty.call(I, c) && e === c.substring(0, e.length) && I[c] !== void 0)
        return !0;
    return !1;
  }
}
const dI = (g) => g.charAt(0).toUpperCase() + g.slice(1);
class fe {
  constructor(I) {
    this.options = I, this.supportedLngs = this.options.supportedLngs || !1, this.logger = L.create("languageUtils");
  }
  getScriptPartFromCode(I) {
    if (I = Qg(I), !I || I.indexOf("-") < 0)
      return null;
    const e = I.split("-");
    return e.length === 2 || (e.pop(), e[e.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(e.join("-"));
  }
  getLanguagePartFromCode(I) {
    if (I = Qg(I), !I || I.indexOf("-") < 0)
      return I;
    const e = I.split("-");
    return this.formatLanguageCode(e[0]);
  }
  formatLanguageCode(I) {
    if (x(I) && I.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let l = Intl.getCanonicalLocales(I)[0];
          if (l && this.options.lowerCaseLng && (l = l.toLowerCase()), l)
            return l;
        } catch {
        }
      const e = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let c = I.split("-");
      return this.options.lowerCaseLng ? c = c.map((l) => l.toLowerCase()) : c.length === 2 ? (c[0] = c[0].toLowerCase(), c[1] = c[1].toUpperCase(), e.indexOf(c[1].toLowerCase()) > -1 && (c[1] = dI(c[1].toLowerCase()))) : c.length === 3 && (c[0] = c[0].toLowerCase(), c[1].length === 2 && (c[1] = c[1].toUpperCase()), c[0] !== "sgn" && c[2].length === 2 && (c[2] = c[2].toUpperCase()), e.indexOf(c[1].toLowerCase()) > -1 && (c[1] = dI(c[1].toLowerCase())), e.indexOf(c[2].toLowerCase()) > -1 && (c[2] = dI(c[2].toLowerCase()))), c.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? I.toLowerCase() : I;
  }
  isSupportedCode(I) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (I = this.getLanguagePartFromCode(I)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(I) > -1;
  }
  getBestMatchFromCodes(I) {
    if (!I)
      return null;
    let e;
    return I.forEach((c) => {
      if (e)
        return;
      const l = this.formatLanguageCode(c);
      (!this.options.supportedLngs || this.isSupportedCode(l)) && (e = l);
    }), !e && this.options.supportedLngs && I.forEach((c) => {
      if (e)
        return;
      const l = this.getLanguagePartFromCode(c);
      if (this.isSupportedCode(l))
        return e = l;
      e = this.options.supportedLngs.find((t) => {
        if (t === l)
          return t;
        if (!(t.indexOf("-") < 0 && l.indexOf("-") < 0) && (t.indexOf("-") > 0 && l.indexOf("-") < 0 && t.substring(0, t.indexOf("-")) === l || t.indexOf(l) === 0 && l.length > 1))
          return t;
      });
    }), e || (e = this.getFallbackCodes(this.options.fallbackLng)[0]), e;
  }
  getFallbackCodes(I, e) {
    if (!I)
      return [];
    if (typeof I == "function" && (I = I(e)), x(I) && (I = [I]), Array.isArray(I))
      return I;
    if (!e)
      return I.default || [];
    let c = I[e];
    return c || (c = I[this.getScriptPartFromCode(e)]), c || (c = I[this.formatLanguageCode(e)]), c || (c = I[this.getLanguagePartFromCode(e)]), c || (c = I.default), c || [];
  }
  toResolveHierarchy(I, e) {
    const c = this.getFallbackCodes(e || this.options.fallbackLng || [], I), l = [], t = (i) => {
      i && (this.isSupportedCode(i) ? l.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return x(I) && (I.indexOf("-") > -1 || I.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && t(this.formatLanguageCode(I)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && t(this.getScriptPartFromCode(I)), this.options.load !== "currentOnly" && t(this.getLanguagePartFromCode(I))) : x(I) && t(this.formatLanguageCode(I)), c.forEach((i) => {
      l.indexOf(i) < 0 && t(this.formatLanguageCode(i));
    }), l;
  }
}
let zb = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Hb = {
  1: (g) => +(g > 1),
  2: (g) => +(g != 1),
  3: (g) => 0,
  4: (g) => g % 10 == 1 && g % 100 != 11 ? 0 : g % 10 >= 2 && g % 10 <= 4 && (g % 100 < 10 || g % 100 >= 20) ? 1 : 2,
  5: (g) => g == 0 ? 0 : g == 1 ? 1 : g == 2 ? 2 : g % 100 >= 3 && g % 100 <= 10 ? 3 : g % 100 >= 11 ? 4 : 5,
  6: (g) => g == 1 ? 0 : g >= 2 && g <= 4 ? 1 : 2,
  7: (g) => g == 1 ? 0 : g % 10 >= 2 && g % 10 <= 4 && (g % 100 < 10 || g % 100 >= 20) ? 1 : 2,
  8: (g) => g == 1 ? 0 : g == 2 ? 1 : g != 8 && g != 11 ? 2 : 3,
  9: (g) => +(g >= 2),
  10: (g) => g == 1 ? 0 : g == 2 ? 1 : g < 7 ? 2 : g < 11 ? 3 : 4,
  11: (g) => g == 1 || g == 11 ? 0 : g == 2 || g == 12 ? 1 : g > 2 && g < 20 ? 2 : 3,
  12: (g) => +(g % 10 != 1 || g % 100 == 11),
  13: (g) => +(g !== 0),
  14: (g) => g == 1 ? 0 : g == 2 ? 1 : g == 3 ? 2 : 3,
  15: (g) => g % 10 == 1 && g % 100 != 11 ? 0 : g % 10 >= 2 && (g % 100 < 10 || g % 100 >= 20) ? 1 : 2,
  16: (g) => g % 10 == 1 && g % 100 != 11 ? 0 : g !== 0 ? 1 : 2,
  17: (g) => g == 1 || g % 10 == 1 && g % 100 != 11 ? 0 : 1,
  18: (g) => g == 0 ? 0 : g == 1 ? 1 : 2,
  19: (g) => g == 1 ? 0 : g == 0 || g % 100 > 1 && g % 100 < 11 ? 1 : g % 100 > 10 && g % 100 < 20 ? 2 : 3,
  20: (g) => g == 1 ? 0 : g == 0 || g % 100 > 0 && g % 100 < 20 ? 1 : 2,
  21: (g) => g % 100 == 1 ? 1 : g % 100 == 2 ? 2 : g % 100 == 3 || g % 100 == 4 ? 3 : 0,
  22: (g) => g == 1 ? 0 : g == 2 ? 1 : (g < 0 || g > 10) && g % 10 == 0 ? 2 : 3
};
const wb = ["v1", "v2", "v3"], Ub = ["v4"], Ye = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Lb = () => {
  const g = {};
  return zb.forEach((I) => {
    I.lngs.forEach((e) => {
      g[e] = {
        numbers: I.nr,
        plurals: Hb[I.fc]
      };
    });
  }), g;
};
class Ob {
  constructor(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = I, this.options = e, this.logger = L.create("pluralResolver"), (!this.options.compatibilityJSON || Ub.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Lb(), this.pluralRulesCache = {};
  }
  addRule(I, e) {
    this.rules[I] = e;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        const c = Qg(I === "dev" ? "en" : I), l = e.ordinal ? "ordinal" : "cardinal", t = JSON.stringify({
          cleanedCode: c,
          type: l
        });
        if (t in this.pluralRulesCache)
          return this.pluralRulesCache[t];
        const i = new Intl.PluralRules(c, {
          type: l
        });
        return this.pluralRulesCache[t] = i, i;
      } catch {
        return;
      }
    return this.rules[I] || this.rules[this.languageUtils.getLanguagePartFromCode(I)];
  }
  needsPlural(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const c = this.getRule(I, e);
    return this.shouldUseIntlApi() ? c && c.resolvedOptions().pluralCategories.length > 1 : c && c.numbers.length > 1;
  }
  getPluralFormsOfKey(I, e) {
    let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(I, c).map((l) => `${e}${l}`);
  }
  getSuffixes(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const c = this.getRule(I, e);
    return c ? this.shouldUseIntlApi() ? c.resolvedOptions().pluralCategories.sort((l, t) => Ye[l] - Ye[t]).map((l) => `${this.options.prepend}${e.ordinal ? `ordinal${this.options.prepend}` : ""}${l}`) : c.numbers.map((l) => this.getSuffix(I, l, e)) : [];
  }
  getSuffix(I, e) {
    let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const l = this.getRule(I, c);
    return l ? this.shouldUseIntlApi() ? `${this.options.prepend}${c.ordinal ? `ordinal${this.options.prepend}` : ""}${l.select(e)}` : this.getSuffixRetroCompatible(l, e) : (this.logger.warn(`no plural rule found for: ${I}`), "");
  }
  getSuffixRetroCompatible(I, e) {
    const c = I.noAbs ? I.plurals(e) : I.plurals(Math.abs(e));
    let l = I.numbers[c];
    this.options.simplifyPluralSuffix && I.numbers.length === 2 && I.numbers[0] === 1 && (l === 2 ? l = "plural" : l === 1 && (l = ""));
    const t = () => this.options.prepend && l.toString() ? this.options.prepend + l.toString() : l.toString();
    return this.options.compatibilityJSON === "v1" ? l === 1 ? "" : typeof l == "number" ? `_plural_${l.toString()}` : t() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && I.numbers.length === 2 && I.numbers[0] === 1 ? t() : this.options.prepend && c.toString() ? this.options.prepend + c.toString() : c.toString();
  }
  shouldUseIntlApi() {
    return !wb.includes(this.options.compatibilityJSON);
  }
}
const Se = function(g, I, e) {
  let c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, t = yb(g, I, e);
  return !t && l && x(e) && (t = vI(g, e, c), t === void 0 && (t = vI(I, e, c))), t;
}, oI = (g) => g.replace(/\$/g, "$$$$");
class Eb {
  constructor() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = L.create("interpolator"), this.options = I, this.format = I.interpolation && I.interpolation.format || ((e) => e), this.init(I);
  }
  init() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    I.interpolation || (I.interpolation = {
      escapeValue: !0
    });
    const {
      escape: e,
      escapeValue: c,
      useRawValueToEscape: l,
      prefix: t,
      prefixEscaped: i,
      suffix: n,
      suffixEscaped: b,
      formatSeparator: C,
      unescapeSuffix: a,
      unescapePrefix: u,
      nestingPrefix: A,
      nestingPrefixEscaped: G,
      nestingSuffix: N,
      nestingSuffixEscaped: W,
      nestingOptionsSeparator: J,
      maxReplaces: y,
      alwaysFormat: s
    } = I.interpolation;
    this.escape = e !== void 0 ? e : vb, this.escapeValue = c !== void 0 ? c : !0, this.useRawValueToEscape = l !== void 0 ? l : !1, this.prefix = t ? $(t) : i || "{{", this.suffix = n ? $(n) : b || "}}", this.formatSeparator = C || ",", this.unescapePrefix = a ? "" : u || "-", this.unescapeSuffix = this.unescapePrefix ? "" : a || "", this.nestingPrefix = A ? $(A) : G || $("$t("), this.nestingSuffix = N ? $(N) : W || $(")"), this.nestingOptionsSeparator = J || ",", this.maxReplaces = y || 1e3, this.alwaysFormat = s !== void 0 ? s : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const I = (e, c) => e && e.source === c ? (e.lastIndex = 0, e) : new RegExp(c, "g");
    this.regexp = I(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = I(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = I(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(I, e, c, l) {
    let t, i, n;
    const b = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, C = (G) => {
      if (G.indexOf(this.formatSeparator) < 0) {
        const y = Se(e, b, G, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(y, void 0, c, {
          ...l,
          ...e,
          interpolationkey: G
        }) : y;
      }
      const N = G.split(this.formatSeparator), W = N.shift().trim(), J = N.join(this.formatSeparator).trim();
      return this.format(Se(e, b, W, this.options.keySeparator, this.options.ignoreJSONStructure), J, c, {
        ...l,
        ...e,
        interpolationkey: W
      });
    };
    this.resetRegExp();
    const a = l && l.missingInterpolationHandler || this.options.missingInterpolationHandler, u = l && l.interpolation && l.interpolation.skipOnVariables !== void 0 ? l.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (G) => oI(G)
    }, {
      regex: this.regexp,
      safeValue: (G) => this.escapeValue ? oI(this.escape(G)) : oI(G)
    }].forEach((G) => {
      for (n = 0; t = G.regex.exec(I); ) {
        const N = t[1].trim();
        if (i = C(N), i === void 0)
          if (typeof a == "function") {
            const J = a(I, t, l);
            i = x(J) ? J : "";
          } else if (l && Object.prototype.hasOwnProperty.call(l, N))
            i = "";
          else if (u) {
            i = t[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${N} for interpolating ${I}`), i = "";
        else
          !x(i) && !this.useRawValueToEscape && (i = Re(i));
        const W = G.safeValue(i);
        if (I = I.replace(t[0], W), u ? (G.regex.lastIndex += i.length, G.regex.lastIndex -= t[0].length) : G.regex.lastIndex = 0, n++, n >= this.maxReplaces)
          break;
      }
    }), I;
  }
  nest(I, e) {
    let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l, t, i;
    const n = (b, C) => {
      const a = this.nestingOptionsSeparator;
      if (b.indexOf(a) < 0)
        return b;
      const u = b.split(new RegExp(`${a}[ ]*{`));
      let A = `{${u[1]}`;
      b = u[0], A = this.interpolate(A, i);
      const G = A.match(/'/g), N = A.match(/"/g);
      (G && G.length % 2 === 0 && !N || N.length % 2 !== 0) && (A = A.replace(/'/g, '"'));
      try {
        i = JSON.parse(A), C && (i = {
          ...C,
          ...i
        });
      } catch (W) {
        return this.logger.warn(`failed parsing options string in nesting for key ${b}`, W), `${b}${a}${A}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, b;
    };
    for (; l = this.nestingRegexp.exec(I); ) {
      let b = [];
      i = {
        ...c
      }, i = i.replace && !x(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      let C = !1;
      if (l[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(l[1])) {
        const a = l[1].split(this.formatSeparator).map((u) => u.trim());
        l[1] = a.shift(), b = a, C = !0;
      }
      if (t = e(n.call(this, l[1].trim(), i), i), t && l[0] === I && !x(t))
        return t;
      x(t) || (t = Re(t)), t || (this.logger.warn(`missed to resolve ${l[1]} for nesting ${I}`), t = ""), C && (t = b.reduce((a, u) => this.format(a, u, c.lng, {
        ...c,
        interpolationkey: l[1].trim()
      }), t.trim())), I = I.replace(l[0], t), this.regexp.lastIndex = 0;
    }
    return I;
  }
}
const Pb = (g) => {
  let I = g.toLowerCase().trim();
  const e = {};
  if (g.indexOf("(") > -1) {
    const c = g.split("(");
    I = c[0].toLowerCase().trim();
    const l = c[1].substring(0, c[1].length - 1);
    I === "currency" && l.indexOf(":") < 0 ? e.currency || (e.currency = l.trim()) : I === "relativetime" && l.indexOf(":") < 0 ? e.range || (e.range = l.trim()) : l.split(";").forEach((i) => {
      if (i) {
        const [n, ...b] = i.split(":"), C = b.join(":").trim().replace(/^'+|'+$/g, ""), a = n.trim();
        e[a] || (e[a] = C), C === "false" && (e[a] = !1), C === "true" && (e[a] = !0), isNaN(C) || (e[a] = parseInt(C, 10));
      }
    });
  }
  return {
    formatName: I,
    formatOptions: e
  };
}, gg = (g) => {
  const I = {};
  return (e, c, l) => {
    let t = l;
    l && l.interpolationkey && l.formatParams && l.formatParams[l.interpolationkey] && l[l.interpolationkey] && (t = {
      ...t,
      [l.interpolationkey]: void 0
    });
    const i = c + JSON.stringify(t);
    let n = I[i];
    return n || (n = g(Qg(c), l), I[i] = n), n(e);
  };
};
class Db {
  constructor() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = L.create("formatter"), this.options = I, this.formats = {
      number: gg((e, c) => {
        const l = new Intl.NumberFormat(e, {
          ...c
        });
        return (t) => l.format(t);
      }),
      currency: gg((e, c) => {
        const l = new Intl.NumberFormat(e, {
          ...c,
          style: "currency"
        });
        return (t) => l.format(t);
      }),
      datetime: gg((e, c) => {
        const l = new Intl.DateTimeFormat(e, {
          ...c
        });
        return (t) => l.format(t);
      }),
      relativetime: gg((e, c) => {
        const l = new Intl.RelativeTimeFormat(e, {
          ...c
        });
        return (t) => l.format(t, c.range || "day");
      }),
      list: gg((e, c) => {
        const l = new Intl.ListFormat(e, {
          ...c
        });
        return (t) => l.format(t);
      })
    }, this.init(I);
  }
  init(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = e.interpolation.formatSeparator || ",";
  }
  add(I, e) {
    this.formats[I.toLowerCase().trim()] = e;
  }
  addCached(I, e) {
    this.formats[I.toLowerCase().trim()] = gg(e);
  }
  format(I, e, c) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const t = e.split(this.formatSeparator);
    if (t.length > 1 && t[0].indexOf("(") > 1 && t[0].indexOf(")") < 0 && t.find((n) => n.indexOf(")") > -1)) {
      const n = t.findIndex((b) => b.indexOf(")") > -1);
      t[0] = [t[0], ...t.splice(1, n)].join(this.formatSeparator);
    }
    return t.reduce((n, b) => {
      const {
        formatName: C,
        formatOptions: a
      } = Pb(b);
      if (this.formats[C]) {
        let u = n;
        try {
          const A = l && l.formatParams && l.formatParams[l.interpolationkey] || {}, G = A.locale || A.lng || l.locale || l.lng || c;
          u = this.formats[C](n, G, {
            ...a,
            ...l,
            ...A
          });
        } catch (A) {
          this.logger.warn(A);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${C}`);
      return n;
    }, I);
  }
}
const jb = (g, I) => {
  g.pending[I] !== void 0 && (delete g.pending[I], g.pendingCount--);
};
class kb extends CI {
  constructor(I, e, c) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = I, this.store = e, this.services = c, this.languageUtils = c.languageUtils, this.options = l, this.logger = L.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = l.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = l.maxRetries >= 0 ? l.maxRetries : 5, this.retryTimeout = l.retryTimeout >= 1 ? l.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(c, l.backend, l);
  }
  queueLoad(I, e, c, l) {
    const t = {}, i = {}, n = {}, b = {};
    return I.forEach((C) => {
      let a = !0;
      e.forEach((u) => {
        const A = `${C}|${u}`;
        !c.reload && this.store.hasResourceBundle(C, u) ? this.state[A] = 2 : this.state[A] < 0 || (this.state[A] === 1 ? i[A] === void 0 && (i[A] = !0) : (this.state[A] = 1, a = !1, i[A] === void 0 && (i[A] = !0), t[A] === void 0 && (t[A] = !0), b[u] === void 0 && (b[u] = !0)));
      }), a || (n[C] = !0);
    }), (Object.keys(t).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: l
    }), {
      toLoad: Object.keys(t),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(n),
      toLoadNamespaces: Object.keys(b)
    };
  }
  loaded(I, e, c) {
    const l = I.split("|"), t = l[0], i = l[1];
    e && this.emit("failedLoading", t, i, e), !e && c && this.store.addResourceBundle(t, i, c, void 0, void 0, {
      skipCopy: !0
    }), this.state[I] = e ? -1 : 2, e && c && (this.state[I] = 0);
    const n = {};
    this.queue.forEach((b) => {
      pb(b.loaded, [t], i), jb(b, I), e && b.errors.push(e), b.pendingCount === 0 && !b.done && (Object.keys(b.loaded).forEach((C) => {
        n[C] || (n[C] = {});
        const a = b.loaded[C];
        a.length && a.forEach((u) => {
          n[C][u] === void 0 && (n[C][u] = !0);
        });
      }), b.done = !0, b.errors.length ? b.callback(b.errors) : b.callback());
    }), this.emit("loaded", n), this.queue = this.queue.filter((b) => !b.done);
  }
  read(I, e, c) {
    let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, t = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, i = arguments.length > 5 ? arguments[5] : void 0;
    if (!I.length)
      return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: I,
        ns: e,
        fcName: c,
        tried: l,
        wait: t,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const n = (C, a) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const u = this.waitingReads.shift();
        this.read(u.lng, u.ns, u.fcName, u.tried, u.wait, u.callback);
      }
      if (C && a && l < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, I, e, c, l + 1, t * 2, i);
        }, t);
        return;
      }
      i(C, a);
    }, b = this.backend[c].bind(this.backend);
    if (b.length === 2) {
      try {
        const C = b(I, e);
        C && typeof C.then == "function" ? C.then((a) => n(null, a)).catch(n) : n(null, C);
      } catch (C) {
        n(C);
      }
      return;
    }
    return b(I, e, n);
  }
  prepareLoading(I, e) {
    let c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), l && l();
    x(I) && (I = this.languageUtils.toResolveHierarchy(I)), x(e) && (e = [e]);
    const t = this.queueLoad(I, e, c, l);
    if (!t.toLoad.length)
      return t.pending.length || l(), null;
    t.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(I, e, c) {
    this.prepareLoading(I, e, {}, c);
  }
  reload(I, e, c) {
    this.prepareLoading(I, e, {
      reload: !0
    }, c);
  }
  loadOne(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const c = I.split("|"), l = c[0], t = c[1];
    this.read(l, t, "read", void 0, void 0, (i, n) => {
      i && this.logger.warn(`${e}loading namespace ${t} for language ${l} failed`, i), !i && n && this.logger.log(`${e}loaded namespace ${t} for language ${l}`, n), this.loaded(I, i, n);
    });
  }
  saveMissing(I, e, c, l, t) {
    let i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(e)) {
      this.logger.warn(`did not save key "${c}" as the namespace "${e}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(c == null || c === "")) {
      if (this.backend && this.backend.create) {
        const b = {
          ...i,
          isUpdate: t
        }, C = this.backend.create.bind(this.backend);
        if (C.length < 6)
          try {
            let a;
            C.length === 5 ? a = C(I, e, c, l, b) : a = C(I, e, c, l), a && typeof a.then == "function" ? a.then((u) => n(null, u)).catch(n) : n(null, a);
          } catch (a) {
            n(a);
          }
        else
          C(I, e, c, l, n, b);
      }
      !I || !I[0] || this.store.addResource(I[0], e, c, l);
    }
  }
}
const Te = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (g) => {
    let I = {};
    if (typeof g[1] == "object" && (I = g[1]), x(g[1]) && (I.defaultValue = g[1]), x(g[2]) && (I.tDescription = g[2]), typeof g[2] == "object" || typeof g[3] == "object") {
      const e = g[3] || g[2];
      Object.keys(e).forEach((c) => {
        I[c] = e[c];
      });
    }
    return I;
  },
  interpolation: {
    escapeValue: !0,
    format: (g) => g,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), ze = (g) => (x(g.ns) && (g.ns = [g.ns]), x(g.fallbackLng) && (g.fallbackLng = [g.fallbackLng]), x(g.fallbackNS) && (g.fallbackNS = [g.fallbackNS]), g.supportedLngs && g.supportedLngs.indexOf("cimode") < 0 && (g.supportedLngs = g.supportedLngs.concat(["cimode"])), g), Sg = () => {
}, Qb = (g) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(g)).forEach((e) => {
    typeof g[e] == "function" && (g[e] = g[e].bind(g));
  });
};
class Rg extends CI {
  constructor() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = ze(I), this.services = {}, this.logger = L, this.modules = {
      external: []
    }, Qb(this), e && !this.isInitialized && !I.isClone) {
      if (!this.options.initImmediate)
        return this.init(I, e), this;
      setTimeout(() => {
        this.init(I, e);
      }, 0);
    }
  }
  init() {
    var I = this;
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof e == "function" && (c = e, e = {}), !e.defaultNS && e.defaultNS !== !1 && e.ns && (x(e.ns) ? e.defaultNS = e.ns : e.ns.indexOf("translation") < 0 && (e.defaultNS = e.ns[0]));
    const l = Te();
    this.options = {
      ...l,
      ...this.options,
      ...ze(e)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...l.interpolation,
      ...this.options.interpolation
    }), e.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = e.keySeparator), e.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = e.nsSeparator);
    const t = (a) => a ? typeof a == "function" ? new a() : a : null;
    if (!this.options.isClone) {
      this.modules.logger ? L.init(t(this.modules.logger), this.options) : L.init(null, this.options);
      let a;
      this.modules.formatter ? a = this.modules.formatter : typeof Intl < "u" && (a = Db);
      const u = new fe(this.options);
      this.store = new ve(this.options.resources, this.options);
      const A = this.services;
      A.logger = L, A.resourceStore = this.store, A.languageUtils = u, A.pluralResolver = new Ob(u, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), a && (!this.options.interpolation.format || this.options.interpolation.format === l.interpolation.format) && (A.formatter = t(a), A.formatter.init(A, this.options), this.options.interpolation.format = A.formatter.format.bind(A.formatter)), A.interpolator = new Eb(this.options), A.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, A.backendConnector = new kb(t(this.modules.backend), A.resourceStore, A, this.options), A.backendConnector.on("*", function(G) {
        for (var N = arguments.length, W = new Array(N > 1 ? N - 1 : 0), J = 1; J < N; J++)
          W[J - 1] = arguments[J];
        I.emit(G, ...W);
      }), this.modules.languageDetector && (A.languageDetector = t(this.modules.languageDetector), A.languageDetector.init && A.languageDetector.init(A, this.options.detection, this.options)), this.modules.i18nFormat && (A.i18nFormat = t(this.modules.i18nFormat), A.i18nFormat.init && A.i18nFormat.init(this)), this.translator = new Kg(this.services, this.options), this.translator.on("*", function(G) {
        for (var N = arguments.length, W = new Array(N > 1 ? N - 1 : 0), J = 1; J < N; J++)
          W[J - 1] = arguments[J];
        I.emit(G, ...W);
      }), this.modules.external.forEach((G) => {
        G.init && G.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, c || (c = Sg), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const a = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      a.length > 0 && a[0] !== "dev" && (this.options.lng = a[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((a) => {
      this[a] = function() {
        return I.store[a](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((a) => {
      this[a] = function() {
        return I.store[a](...arguments), I;
      };
    });
    const b = rg(), C = () => {
      const a = (u, A) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), b.resolve(A), c(u, A);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return a(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, a);
    };
    return this.options.resources || !this.options.initImmediate ? C() : setTimeout(C, 0), b;
  }
  loadResources(I) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Sg;
    const l = x(I) ? I : this.language;
    if (typeof I == "function" && (c = I), !this.options.resources || this.options.partialBundledLanguages) {
      if (l && l.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return c();
      const t = [], i = (n) => {
        if (!n || n === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(n).forEach((C) => {
          C !== "cimode" && t.indexOf(C) < 0 && t.push(C);
        });
      };
      l ? i(l) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((b) => i(b)), this.options.preload && this.options.preload.forEach((n) => i(n)), this.services.backendConnector.load(t, this.options.ns, (n) => {
        !n && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), c(n);
      });
    } else
      c(null);
  }
  reloadResources(I, e, c) {
    const l = rg();
    return typeof I == "function" && (c = I, I = void 0), typeof e == "function" && (c = e, e = void 0), I || (I = this.languages), e || (e = this.options.ns), c || (c = Sg), this.services.backendConnector.reload(I, e, (t) => {
      l.resolve(), c(t);
    }), l;
  }
  use(I) {
    if (!I)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!I.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return I.type === "backend" && (this.modules.backend = I), (I.type === "logger" || I.log && I.warn && I.error) && (this.modules.logger = I), I.type === "languageDetector" && (this.modules.languageDetector = I), I.type === "i18nFormat" && (this.modules.i18nFormat = I), I.type === "postProcessor" && Hc.addPostProcessor(I), I.type === "formatter" && (this.modules.formatter = I), I.type === "3rdParty" && this.modules.external.push(I), this;
  }
  setResolvedLanguage(I) {
    if (!(!I || !this.languages) && !(["cimode", "dev"].indexOf(I) > -1))
      for (let e = 0; e < this.languages.length; e++) {
        const c = this.languages[e];
        if (!(["cimode", "dev"].indexOf(c) > -1) && this.store.hasLanguageSomeTranslations(c)) {
          this.resolvedLanguage = c;
          break;
        }
      }
  }
  changeLanguage(I, e) {
    var c = this;
    this.isLanguageChangingTo = I;
    const l = rg();
    this.emit("languageChanging", I);
    const t = (b) => {
      this.language = b, this.languages = this.services.languageUtils.toResolveHierarchy(b), this.resolvedLanguage = void 0, this.setResolvedLanguage(b);
    }, i = (b, C) => {
      C ? (t(C), this.translator.changeLanguage(C), this.isLanguageChangingTo = void 0, this.emit("languageChanged", C), this.logger.log("languageChanged", C)) : this.isLanguageChangingTo = void 0, l.resolve(function() {
        return c.t(...arguments);
      }), e && e(b, function() {
        return c.t(...arguments);
      });
    }, n = (b) => {
      !I && !b && this.services.languageDetector && (b = []);
      const C = x(b) ? b : this.services.languageUtils.getBestMatchFromCodes(b);
      C && (this.language || t(C), this.translator.language || this.translator.changeLanguage(C), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(C)), this.loadResources(C, (a) => {
        i(a, C);
      });
    };
    return !I && this.services.languageDetector && !this.services.languageDetector.async ? n(this.services.languageDetector.detect()) : !I && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(n) : this.services.languageDetector.detect(n) : n(I), l;
  }
  getFixedT(I, e, c) {
    var l = this;
    const t = function(i, n) {
      let b;
      if (typeof n != "object") {
        for (var C = arguments.length, a = new Array(C > 2 ? C - 2 : 0), u = 2; u < C; u++)
          a[u - 2] = arguments[u];
        b = l.options.overloadTranslationOptionHandler([i, n].concat(a));
      } else
        b = {
          ...n
        };
      b.lng = b.lng || t.lng, b.lngs = b.lngs || t.lngs, b.ns = b.ns || t.ns, b.keyPrefix !== "" && (b.keyPrefix = b.keyPrefix || c || t.keyPrefix);
      const A = l.options.keySeparator || ".";
      let G;
      return b.keyPrefix && Array.isArray(i) ? G = i.map((N) => `${b.keyPrefix}${A}${N}`) : G = b.keyPrefix ? `${b.keyPrefix}${A}${i}` : i, l.t(G, b);
    };
    return x(I) ? t.lng = I : t.lngs = I, t.ns = e, t.keyPrefix = c, t;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(I) {
    this.options.defaultNS = I;
  }
  hasLoadedNamespace(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const c = e.lng || this.resolvedLanguage || this.languages[0], l = this.options ? this.options.fallbackLng : !1, t = this.languages[this.languages.length - 1];
    if (c.toLowerCase() === "cimode")
      return !0;
    const i = (n, b) => {
      const C = this.services.backendConnector.state[`${n}|${b}`];
      return C === -1 || C === 0 || C === 2;
    };
    if (e.precheck) {
      const n = e.precheck(this, i);
      if (n !== void 0)
        return n;
    }
    return !!(this.hasResourceBundle(c, I) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(c, I) && (!l || i(t, I)));
  }
  loadNamespaces(I, e) {
    const c = rg();
    return this.options.ns ? (x(I) && (I = [I]), I.forEach((l) => {
      this.options.ns.indexOf(l) < 0 && this.options.ns.push(l);
    }), this.loadResources((l) => {
      c.resolve(), e && e(l);
    }), c) : (e && e(), Promise.resolve());
  }
  loadLanguages(I, e) {
    const c = rg();
    x(I) && (I = [I]);
    const l = this.options.preload || [], t = I.filter((i) => l.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return t.length ? (this.options.preload = l.concat(t), this.loadResources((i) => {
      c.resolve(), e && e(i);
    }), c) : (e && e(), Promise.resolve());
  }
  dir(I) {
    if (I || (I = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !I)
      return "rtl";
    const e = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], c = this.services && this.services.languageUtils || new fe(Te());
    return e.indexOf(c.getLanguagePartFromCode(I)) > -1 || I.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = arguments.length > 1 ? arguments[1] : void 0;
    return new Rg(I, e);
  }
  cloneInstance() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Sg;
    const c = I.forkResourceStore;
    c && delete I.forkResourceStore;
    const l = {
      ...this.options,
      ...I,
      isClone: !0
    }, t = new Rg(l);
    return (I.debug !== void 0 || I.prefix !== void 0) && (t.logger = t.logger.clone(I)), ["store", "services", "language"].forEach((n) => {
      t[n] = this[n];
    }), t.services = {
      ...this.services
    }, t.services.utils = {
      hasLoadedNamespace: t.hasLoadedNamespace.bind(t)
    }, c && (t.store = new ve(this.store.data, l), t.services.resourceStore = t.store), t.translator = new Kg(t.services, l), t.translator.on("*", function(n) {
      for (var b = arguments.length, C = new Array(b > 1 ? b - 1 : 0), a = 1; a < b; a++)
        C[a - 1] = arguments[a];
      t.emit(n, ...C);
    }), t.init(l, e), t.translator.options = l, t.translator.backendConnector.services.utils = {
      hasLoadedNamespace: t.hasLoadedNamespace.bind(t)
    }, t;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const F = Rg.createInstance();
F.createInstance = Rg.createInstance;
F.createInstance;
F.dir;
F.init;
F.loadResources;
F.reloadResources;
F.use;
F.changeLanguage;
F.getFixedT;
F.t;
F.exists;
F.setDefaultNamespace;
F.hasLoadedNamespace;
F.loadNamespaces;
F.loadLanguages;
const {
  slice: Mb,
  forEach: Kb
} = [];
function _b(g) {
  return Kb.call(Mb.call(arguments, 1), (I) => {
    if (I)
      for (const e in I)
        g[e] === void 0 && (g[e] = I[e]);
  }), g;
}
const He = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, qb = (g, I, e) => {
  const c = e || {};
  c.path = c.path || "/";
  const l = encodeURIComponent(I);
  let t = `${g}=${l}`;
  if (c.maxAge > 0) {
    const i = c.maxAge - 0;
    if (Number.isNaN(i))
      throw new Error("maxAge should be a Number");
    t += `; Max-Age=${Math.floor(i)}`;
  }
  if (c.domain) {
    if (!He.test(c.domain))
      throw new TypeError("option domain is invalid");
    t += `; Domain=${c.domain}`;
  }
  if (c.path) {
    if (!He.test(c.path))
      throw new TypeError("option path is invalid");
    t += `; Path=${c.path}`;
  }
  if (c.expires) {
    if (typeof c.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    t += `; Expires=${c.expires.toUTCString()}`;
  }
  if (c.httpOnly && (t += "; HttpOnly"), c.secure && (t += "; Secure"), c.sameSite)
    switch (typeof c.sameSite == "string" ? c.sameSite.toLowerCase() : c.sameSite) {
      case !0:
        t += "; SameSite=Strict";
        break;
      case "lax":
        t += "; SameSite=Lax";
        break;
      case "strict":
        t += "; SameSite=Strict";
        break;
      case "none":
        t += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  return t;
}, we = {
  create(g, I, e, c) {
    let l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    e && (l.expires = /* @__PURE__ */ new Date(), l.expires.setTime(l.expires.getTime() + e * 60 * 1e3)), c && (l.domain = c), document.cookie = qb(g, encodeURIComponent(I), l);
  },
  read(g) {
    const I = `${g}=`, e = document.cookie.split(";");
    for (let c = 0; c < e.length; c++) {
      let l = e[c];
      for (; l.charAt(0) === " "; )
        l = l.substring(1, l.length);
      if (l.indexOf(I) === 0)
        return l.substring(I.length, l.length);
    }
    return null;
  },
  remove(g) {
    this.create(g, "", -1);
  }
};
var $b = {
  name: "cookie",
  // Deconstruct the options object and extract the lookupCookie property
  lookup(g) {
    let {
      lookupCookie: I
    } = g;
    if (I && typeof document < "u")
      return we.read(I) || void 0;
  },
  // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
  cacheUserLanguage(g, I) {
    let {
      lookupCookie: e,
      cookieMinutes: c,
      cookieDomain: l,
      cookieOptions: t
    } = I;
    e && typeof document < "u" && we.create(e, g, c, l, t);
  }
}, ga = {
  name: "querystring",
  // Deconstruct the options object and extract the lookupQuerystring property
  lookup(g) {
    var c;
    let {
      lookupQuerystring: I
    } = g, e;
    if (typeof window < "u") {
      let {
        search: l
      } = window.location;
      !window.location.search && ((c = window.location.hash) == null ? void 0 : c.indexOf("?")) > -1 && (l = window.location.hash.substring(window.location.hash.indexOf("?")));
      const i = l.substring(1).split("&");
      for (let n = 0; n < i.length; n++) {
        const b = i[n].indexOf("=");
        b > 0 && i[n].substring(0, b) === I && (e = i[n].substring(b + 1));
      }
    }
    return e;
  }
};
let dg = null;
const Ue = () => {
  if (dg !== null)
    return dg;
  try {
    dg = window !== "undefined" && window.localStorage !== null;
    const g = "i18next.translate.boo";
    window.localStorage.setItem(g, "foo"), window.localStorage.removeItem(g);
  } catch {
    dg = !1;
  }
  return dg;
};
var Ia = {
  name: "localStorage",
  // Deconstruct the options object and extract the lookupLocalStorage property
  lookup(g) {
    let {
      lookupLocalStorage: I
    } = g;
    if (I && Ue())
      return window.localStorage.getItem(I) || void 0;
  },
  // Deconstruct the options object and extract the lookupLocalStorage property
  cacheUserLanguage(g, I) {
    let {
      lookupLocalStorage: e
    } = I;
    e && Ue() && window.localStorage.setItem(e, g);
  }
};
let og = null;
const Le = () => {
  if (og !== null)
    return og;
  try {
    og = window !== "undefined" && window.sessionStorage !== null;
    const g = "i18next.translate.boo";
    window.sessionStorage.setItem(g, "foo"), window.sessionStorage.removeItem(g);
  } catch {
    og = !1;
  }
  return og;
};
var ea = {
  name: "sessionStorage",
  lookup(g) {
    let {
      lookupSessionStorage: I
    } = g;
    if (I && Le())
      return window.sessionStorage.getItem(I) || void 0;
  },
  cacheUserLanguage(g, I) {
    let {
      lookupSessionStorage: e
    } = I;
    e && Le() && window.sessionStorage.setItem(e, g);
  }
}, ca = {
  name: "navigator",
  lookup(g) {
    const I = [];
    if (typeof navigator < "u") {
      const {
        languages: e,
        userLanguage: c,
        language: l
      } = navigator;
      if (e)
        for (let t = 0; t < e.length; t++)
          I.push(e[t]);
      c && I.push(c), l && I.push(l);
    }
    return I.length > 0 ? I : void 0;
  }
}, la = {
  name: "htmlTag",
  // Deconstruct the options object and extract the htmlTag property
  lookup(g) {
    let {
      htmlTag: I
    } = g, e;
    const c = I || (typeof document < "u" ? document.documentElement : null);
    return c && typeof c.getAttribute == "function" && (e = c.getAttribute("lang")), e;
  }
}, ta = {
  name: "path",
  // Deconstruct the options object and extract the lookupFromPathIndex property
  lookup(g) {
    var l;
    let {
      lookupFromPathIndex: I
    } = g;
    if (typeof window > "u")
      return;
    const e = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
    return Array.isArray(e) ? (l = e[typeof I == "number" ? I : 0]) == null ? void 0 : l.replace("/", "") : void 0;
  }
}, ia = {
  name: "subdomain",
  lookup(g) {
    var l, t;
    let {
      lookupFromSubdomainIndex: I
    } = g;
    const e = typeof I == "number" ? I + 1 : 1, c = typeof window < "u" && ((t = (l = window.location) == null ? void 0 : l.hostname) == null ? void 0 : t.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i));
    if (c)
      return c[e];
  }
};
function na() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: (g) => g
  };
}
class wc {
  constructor(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.type = "languageDetector", this.detectors = {}, this.init(I, e);
  }
  init(I) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.services = I || {
      languageUtils: {}
    }, this.options = _b(e, this.options || {}, na()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = (l) => l.replace("-", "_")), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = c, this.addDetector($b), this.addDetector(ga), this.addDetector(Ia), this.addDetector(ea), this.addDetector(ca), this.addDetector(la), this.addDetector(ta), this.addDetector(ia);
  }
  addDetector(I) {
    return this.detectors[I.name] = I, this;
  }
  detect(I) {
    I || (I = this.options.order);
    let e = [];
    return I.forEach((c) => {
      if (this.detectors[c]) {
        let l = this.detectors[c].lookup(this.options);
        l && typeof l == "string" && (l = [l]), l && (e = e.concat(l));
      }
    }), e = e.map((c) => this.options.convertDetectedLanguage(c)), this.services.languageUtils.getBestMatchFromCodes ? e : e.length > 0 ? e[0] : null;
  }
  cacheUserLanguage(I, e) {
    e || (e = this.options.caches), e && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(I) > -1 || e.forEach((c) => {
      this.detectors[c] && this.detectors[c].cacheUserLanguage(I, this.options);
    }));
  }
}
wc.type = "languageDetector";
const Ca = {
  "(주)인프랩": "Inflab Co., Ltd.",
  "(주)인프랩 사업자 정보": "Inflab Co., Ltd. Business Information",
  "3동 5층": "Republic of Korea",
  "IT 인재 채용 서비스": "IT talents recruiting service",
  "MY 카테고리": "My category",
  "With us": "With us",
  "{{category.title}} > 전체": "{{category.title}} > All",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}, thank you for being with Inflearn. 😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}, we’re cheering for your first step forward. 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}, we’re cheering for your career growth. 👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}’s profile image",
  "{{provider}}-로그인-버튼": "{{provider}}-Login-Button",
  "{{socialProviderNameMap[provider]}}로 로그인": "Log in with {{socialProviderNameMap[provider]}}",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "With 'Inflearn Business,' you can provide an environment where all team members can",
  "가입 이메일 인증이 필요합니다.": "Email verification is required for registration.",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `This account requires email verification.
Please try again after 24 hours or contact customer support.`,
  "간편 로그인": "Social login",
  강의: "Course",
  "강의 · 기능요청": "Ask for course/function",
  "강의/강사명을 입력해주세요": "Enter the course/instructor name",
  "강의리스트 보기": "View course list",
  개: "ea",
  "개인정보보호책임자: 이동욱": "CPO: Lee Dongwook",
  개인정보처리방침: "Privacy Policy",
  검색: "Search",
  "검색바.01": "What are you interested in now?",
  "검색바.02": "Enter a keyword you’re exploring.",
  "검색바.03": "Which skill are you exploring now?",
  "검색바.04": "Discover courses for your next step.",
  "검색바.05": "Looking for something specific?",
  "검색바.06": "Type a course, topic, or keyword.",
  "검색바.07": "What do you want to learn today?",
  "검색바.08": "Search for anything.",
  "검색바.09": "What are you interested in now?",
  "검색바.10": "What do you want to learn today?",
  "검색바.11": "Which skill are you exploring now?",
  "검색할 강의 입력": "Enter course name",
  "경기도 성남시 분당구 판교로289번길 20": "5F, Bldg #3, 20, Pangyo-ro 289beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do,",
  "경제적 보상을 받아보세요.": "and get financial rewards.",
  "계정 설정": "Account Settings",
  고객센터: "Customer Services",
  고민있어요: "I need help",
  공지사항: "Notice",
  교육: "Training",
  구글: "Google",
  "구매 / 혜택": "Purchase / Benefits",
  "구매 내역": "Purchase history",
  국비지원교육: "Government-sponsored courses",
  기업: "Business",
  "기업 교육을 위한 인프런": "Inflearn for business education",
  깃허브: "GitHub",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "Search for great pieces of knowledge that’ll help you grow.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "Find practical courses that can actually help you grow.",
  난이도: "Level",
  "난이도 선택": "Select Level",
  "난이도 옵션": "Level Options",
  "난이도 초기화": "Reset Level",
  "나한테 딱 맞는 걸 찾고 싶다면": "Looking for the perfect match?",
  "어떤 강의가 나한테 맞을까?": "Which course is right for me?",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "Find courses for your goals",
  "지금 많이 듣는 강의 확인해보세요": "Check out the most popular courses right now",
  "남았어요.": "left.",
  "내 학습": "My learning",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "Naver does not support Google Login.",
  "누구나 들을 수 있는": "Open to everyone",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "Please use a different mobile browser (Chrome, Safari).",
  닫기: "Close",
  "담긴 강의가 없습니다.": "No courses in cart.",
  대시보드: "Dashboard",
  "대표자: 이형주": "CEO: Lee Hyeongjoo",
  더보기: "More",
  둘러보기: "Explore",
  "딱 맞는 강의가 기다리고 있어요.": "The perfect course for you awaits.",
  "랠릿 서비스 링크": "Rallit service link",
  로그아웃: "Log out",
  로그인: "Sign in",
  "로그인 또는 회원가입": "Log In or Sign Up",
  "로그인이 필요한 요청입니다.": "You need to log in to make this request.",
  로드맵: "Roadmap",
  "마음에 드는 강의를 수강해보세요!": "Take the course that draws your attention!",
  "많은 사람들에게 배움의 기회를 주고,": "Provide an opportunity to learn",
  "메인 페이지로 이동하기": "Go to main page",
  멘토링: "Mentoring",
  "멘토링 소개": "About mentoring",
  "멘토링 후기": "Mentoring Reviews",
  "모임/부트캠프": "Clubs/Bootcamp",
  "문제가 발생했습니다.": "An issue has occurred.",
  보관함: "Storage",
  분: "min",
  블로그: "Blog",
  비밀번호: "Password",
  "비밀번호 찾기": "Find my password",
  "비밀번호를 입력해주세요.": "Enter your password.",
  비즈니스: "Business",
  "비즈니스 브랜드 로고": "Business brand logo",
  "비즈니스 수강내역": "Business course history",
  "사업자 정보 확인": "Check business information",
  "사업자번호: 499-81-00612": "Business Registration No.: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "Go to user dashboard page",
  "사용자 알림 페이지로 이동": "Go to user notification page",
  서비스: "Service",
  "서비스 언어를 선택하세요.": "Select the service language.",
  "선수 지식이 필요한": "Prerequisite knowledge required",
  설정: "Settings",
  수강바구니: "Cart",
  "수강바구니에서 전체보기": "Go to cart",
  "수강코드 등록": "Register course code",
  수강평: "Review",
  "수강평 모아보기": "See all reviews",
  "수료증 확인": "See certificate",
  스터디: "Study Clubs",
  시간: "hr",
  신청하기: "Apply",
  "아이디(이메일) 찾기": "Find my ID (email)",
  애플: "Apple",
  어드민: "Admin",
  "언어 변경": "Change Language",
  "언어 설정": "Language Settings",
  원: "$",
  "유저 대시보드로 이동": "Go to user dashboard",
  "이 공지를 그만 볼래요": "Don't show me this notice",
  이메일: "Email",
  "이메일 또는 비밀번호를 확인해주세요.": "Check your email or password again.",
  "이메일 형식이 올바르지 않습니다.": "Invalid email format",
  "이메일을 입력해주세요.": "Enter your email.",
  "이어서 학습하기": "Continue learning",
  이용약관: "Terms of Use",
  인프랩: "Inflab",
  "인프랩 스토리": "Inflab story",
  "인프랩 실Log": "Inflab Log",
  "인프랩 테크": "Inflab tech",
  인프런: "Inflearn",
  "인프런 네이버 블로그 바로가기": "Go to Inflearn’s Naver blog",
  "인프런 네이버 포스트 바로가기": "Go to Inflearn’s Naver post",
  "인프런 메인 페이지로 이동": "Go to Inflearn main page",
  "인프런 브랜드 로고": "Inflearn brand logo",
  "인프런 비즈니스": "Inflearn business",
  "인프런 소개": "About Inflearn",
  "인프런 영문 브랜드 로고": "Inflearn English brand logo",
  "인프런 유튜브 바로가기": "Go to Inflearn’s YouTube channel",
  "인프런 인스타그램 바로가기": "Go to Inflearn’s Instagram",
  "인프런 제휴": "Inflearn partners",
  "인프런 통합 검색": "Search in Inflearn",
  "인프런 트위터 바로가기": "Go to Inflearn’s X (Twitter)",
  "인프런 페이스북 바로가기": "Go to Inflearn’s Facebook",
  "인프런 피드": "Inflearn feed",
  "인프런으로 이동하기": "Go to Inflearn",
  입문: "Beginner",
  잎: "leaf",
  "자유롭게 학습하는 환경을 제공하세요.": "learn all they want through Inflearn’s courses.",
  "자주묻는 질문": "FAQ",
  "작성한 게시글": "Written posts",
  "장바구니 페이지로 이동": "Go to cart page",
  "저작권 신고센터": "Report copyright issues",
  "전문성을 높이는": "Enhancing expertise",
  전체: "All",
  "전체 강의": "All courses",
  "전화번호: 070-4948-1181": "Phone: 070-4948-1181",
  좋아요: "Likes",
  주소: "Address",
  중급이상: "Intermediate",
  "지금 둘러 보기": "Check out now",
  지식공유: "Instructor",
  "지식공유 참여": "Teach on Inflearn",
  지식공유자: "Instructors",
  "지식공유자 되기": "Teach on Inflearn",
  지식공유참여: "Teach on Inflearn",
  지식공유하기: "Share Knowledge",
  "질문 & 답변": "QnA",
  "질문 게시판": "Questions",
  "채널톡 아이콘": "ChannelTalk icon",
  챌린지: "Challenge",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Something went wrong. Please try again later.",
  "청강대 게임스쿨": "Chungkang College Game School",
  초: "sec",
  초급: "Basic",
  "총 결제금액": "Total amount",
  "최근 강의 바로가기": "Go to recent course",
  "최근 로그인": "Recent login",
  카카오: "Kakao",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "KakaoTalk does not support Google Login.",
  "카테고리 설정": "Set category",
  커리어: "Career",
  커뮤니티: "Community",
  "코드 등록": "Register Code",
  쿠폰: "Coupon",
  "통신판매업: 2018-성남분당B-0062": "E-Commerce Business: 2018-SeongnamBundangB-0062",
  "특정 상거래법": "",
  "팀 프로젝트": "Team Projects",
  파트너스: "Partners",
  포인트: "Points",
  "포인트코드 등록": "Register point code",
  학생: "Student",
  "할인 종료까지": "Discount ends in",
  홈: "Home",
  확인: "OK",
  회원가입: "Sign up",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Surprise! Enjoy a special {{discountPercent}}% thank-you discount on our courses – don’t miss out!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 A special discount for new members has been applied to courses, so don’t wait and grab it now!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Your first-purchase discount ({{discountPercent}}%) is already applied — start learning now!"
}, ba = {
  "(주)인프랩": "株式会社インフラップ",
  "(주)인프랩 사업자 정보": "株式会社インフラップ事業者情報",
  "3동 5층": "3棟5階",
  "IT 인재 채용 서비스": "IT人材採用サービス",
  "MY 카테고리": "私のカテゴリ",
  "With us": "ウィズアス",
  "{{category.title}} > 전체": "{{category.title}} > 全体",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}さん、インフランと一緒にいてくれてありがとう。😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}さんの初飛躍を応援しています。🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}さんのキャリアを応援しています。👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}さんのプロフィール画像",
  "{{provider}}-로그인-버튼": "{{provider}}-ログイン-ボタン",
  "{{socialProviderNameMap[provider]}}로 로그인": "{{socialProviderNameMap[provider]}}でログイン",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "「インフラントビジネス」を通じてすべてのチームメンバーがインフランの講義を",
  "가입 이메일 인증이 필요합니다.": "登録メールの認証が必要です。",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `メール認証が必要なアカウントです。
24時間後に再度お試しいただくか、カスタマーサポートへお問い合わせください。`,
  "간편 로그인": "簡単ログイン",
  강의: "講義",
  "강의 · 기능요청": "講義・機能リクエスト",
  "강의/강사명을 입력해주세요": "講義/講師名を入力してください",
  "강의리스트 보기": "講義リストを見る",
  개: "個",
  "개인정보보호책임자: 이동욱": "個人情報保護責任者：イ・ドンウク",
  개인정보처리방침: "個人情報処理方針",
  검색: "検索",
  "검색바.01": "今日は何を学びますか？",
  "검색바.02": "今すぐ検索",
  "검색바.03": "キーワード入力",
  "검색바.04": "今学びたいことは何ですか？",
  "검색바.05": "「プログラミング」で検索",
  "검색바.06": "「Python」で検索",
  "검색바.07": "「デザイン」で検索",
  "검색바.08": "新しい学び、新しい未来ーインフラン",
  "검색바.09": "今日は何を学びますか？",
  "검색바.10": "「デザイン」で検索",
  "검색바.11": "キーワード入力",
  "검색할 강의 입력": "講義名を入力",
  "경기도 성남시 분당구 판교로289번길 20": "京畿道城南市盆唐区パンギョ路289番道20",
  "경제적 보상을 받아보세요.": "経済的な報酬を受け取ってください。",
  "계정 설정": "アカウント設定",
  고객센터: "カスタマーセンター",
  고민있어요: "悩みがありますか",
  공지사항: "お知らせ",
  교육: "教育",
  구글: "グーグル",
  "구매 / 혜택": "購入 / 特典",
  "구매 내역": "購入履歴",
  국비지원교육: "国費支援教育",
  기업: "企業",
  "기업 교육을 위한 인프런": "企業教育のためのインフラン",
  깃허브: "ギットハブ",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "私を成長させてくれる良い知識を探してみてください。",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "私の本当の成長を助ける実務講義を探してみてください",
  난이도: "レベル",
  "난이도 선택": "レベルを選択",
  "난이도 옵션": "レベルオプション",
  "난이도 초기화": "レベルをリセット",
  "나한테 딱 맞는 걸 찾고 싶다면": "ぴったりな講座をお探しなら",
  "어떤 강의가 나한테 맞을까?": "自分に合う講座はどれ？",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "目標に合った講座を見つける",
  "지금 많이 듣는 강의 확인해보세요": "今人気の講座をチェックしてみましょう",
  "남았어요.": "残っています。",
  "내 학습": "私の学習",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "ネイバーではグーグルログインをサポートしていません。",
  "누구나 들을 수 있는": "誰でも受講できる",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "他のモバイルブラウザ（Chrome、Safari）をご利用ください。",
  닫기: "閉じる",
  "담긴 강의가 없습니다.": "含まれている講義はありません。",
  대시보드: "ダッシュボード",
  "대표자: 이형주": "代表者：イ・ヒョンジュ",
  더보기: "もっと見る",
  둘러보기: "閲覧",
  "딱 맞는 강의가 기다리고 있어요.": "ぴったりの講義が待っています。",
  "랠릿 서비스 링크": "レリットサービスリンク",
  로그아웃: "ログアウト",
  로그인: "ログイン",
  "로그인 또는 회원가입": "ログインまたは新規登録",
  "로그인이 필요한 요청입니다.": "ログインが必要なリクエストです。",
  로드맵: "ロードマップ",
  "마음에 드는 강의를 수강해보세요!": "気に入った講義を受けてみてください！",
  "많은 사람들에게 배움의 기회를 주고,": "多くの人々に学習の機会を与え、",
  "메인 페이지로 이동하기": "メインページに移動する",
  멘토링: "メンタリング",
  "멘토링 소개": "メンタリング紹介",
  "멘토링 후기": "メンタリング後記",
  "모임/부트캠프": "集まり/ブートキャンプ",
  "문제가 발생했습니다.": "問題が発生しました。",
  보관함: "保管箱",
  분: "分",
  블로그: "ブログ",
  비밀번호: "パスワード",
  "비밀번호 찾기": "パスワード探し",
  "비밀번호를 입력해주세요.": "パスワードを入力してください。",
  비즈니스: "ビジネス",
  "비즈니스 브랜드 로고": "ビジネスブランドロゴ",
  "비즈니스 수강내역": "ビジネス受講履歴",
  "사업자 정보 확인": "事業者情報確認",
  "사업자번호: 499-81-00612": "事業者番号：499-81-00612",
  "사용자 대시보드 페이지로 이동": "ユーザーダッシュボードページに移動",
  "사용자 알림 페이지로 이동": "ユーザー通知ページに移動",
  서비스: "サービス",
  "서비스 언어를 선택하세요.": "サービス言語を選択してください。",
  "선수 지식이 필요한": "前提知識が必要な",
  설정: "設定",
  수강바구니: "受講カート",
  "수강바구니에서 전체보기": "受講カートで全体を見る",
  "수강코드 등록": "受講コード登録",
  수강평: "受講評価",
  "수강평 모아보기": "受講評価をまとめて見る",
  "수료증 확인": "修了証確認",
  스터디: "スタディ",
  시간: "時間",
  신청하기: "申し込む",
  "아이디(이메일) 찾기": "ID（メール）検索",
  애플: "アップル",
  어드민: "アドミン",
  "언어 변경": "言語変更",
  "언어 설정": "言語設定",
  원: "ウォン",
  "유저 대시보드로 이동": "ユーザーダッシュボードに移動",
  "이 공지를 그만 볼래요": "この通知をもう見たくない",
  이메일: "メール",
  "이메일 또는 비밀번호를 확인해주세요.": "メールまたはパスワードを確認してください。",
  "이메일 형식이 올바르지 않습니다.": "メールアドレスの形式が正しくありません。",
  "이메일을 입력해주세요.": "メールを入力してください。",
  "이어서 학습하기": "続けて学習する",
  이용약관: "利用約款",
  인프랩: "インフラップ",
  "인프랩 스토리": "インフラップストーリー",
  "인프랩 실Log": "インフラップ実ログ",
  "인프랩 테크": "インフラップテック",
  인프런: "インフラン",
  "인프런 네이버 블로그 바로가기": "インフランネイバーブログ直接リンク",
  "인프런 네이버 포스트 바로가기": "インフランネイバーポスト直接リンク",
  "인프런 메인 페이지로 이동": "インフランメインページに移動",
  "인프런 브랜드 로고": "インフランブランドロゴ",
  "인프런 비즈니스": "インフランビジネス",
  "인프런 소개": "インフラン紹介",
  "인프런 영문 브랜드 로고": "インフラン英文ブランドロゴ",
  "인프런 유튜브 바로가기": "インフランユーチューブ直接リンク",
  "인프런 인스타그램 바로가기": "インフランインスタグラム直接リンク",
  "인프런 제휴": "インフラン提携",
  "인프런 통합 검색": "インフラン統合検索",
  "인프런 트위터 바로가기": "インフラントゥイッター直接リンク",
  "인프런 페이스북 바로가기": "インフランフェイスブック直接リンク",
  "인프런 피드": "インフランフィード",
  "인프런으로 이동하기": "インフランへ移動する",
  입문: "入門",
  잎: "リーフ",
  "자유롭게 학습하는 환경을 제공하세요.": "自由に学習できる環境を提供してください。",
  "자주묻는 질문": "よくある質問",
  "작성한 게시글": "作成した投稿",
  "장바구니 페이지로 이동": "カートページに移動",
  "저작권 신고센터": "著作権通報センター",
  "전문성을 높이는": "専門性を高める",
  전체: "全体",
  "전체 강의": "全体講義",
  "전화번호: 070-4948-1181": "電話番号：070-4948-1181",
  좋아요: "いいね",
  주소: "住所",
  중급이상: "中級以上",
  "지금 둘러 보기": "今すぐ見る",
  지식공유: "知識共有",
  "지식공유 참여": "知識共有参加",
  지식공유자: "知識共有者",
  "지식공유자 되기": "知識共有者になる",
  지식공유참여: "知識共有参加",
  지식공유하기: "知識を共有",
  "질문 & 답변": "質問と回答",
  "질문 게시판": "質問掲示板",
  "채널톡 아이콘": "チャンネルトークアイコン",
  챌린지: "Challenge",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "処理中にエラーが発生しました。しばらくしてから再試行してください。",
  "청강대 게임스쿨": "青江大ゲームスクール",
  초: "秒",
  초급: "初級",
  "총 결제금액": "総決済金額",
  "최근 강의 바로가기": "最近の講義への直接リンク",
  "최근 로그인": "最近のログイン",
  카카오: "カカオ",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "カカオトークではグーグルログインをサポートしていません。",
  "카테고리 설정": "カテゴリ設定",
  커리어: "キャリア",
  커뮤니티: "コミュニティ",
  "코드 등록": "コード登録",
  쿠폰: "クーポン",
  "통신판매업: 2018-성남분당B-0062": "通信販売業：2018-城南盆唐B-0062",
  "특정 상거래법": "特定商取引法",
  "팀 프로젝트": "チームプロジェクト",
  파트너스: "パートナーズ",
  포인트: "ポイント",
  "포인트코드 등록": "ポイントコード登録",
  학생: "学生",
  "할인 종료까지": "割引終了まで",
  홈: "ホーム",
  확인: "確認",
  회원가입: "会員登録",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 サプライズ感謝割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 新規登録割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 初購入割引({{discountPercent}}%)が講義に適用されていますので、今すぐ購入してみてください！"
}, aa = {
  "(주)인프랩": "(주)인프랩",
  "(주)인프랩 사업자 정보": "(주)인프랩 사업자 정보",
  "3동 5층": "3동 5층",
  "IT 인재 채용 서비스": "IT 인재 채용 서비스",
  "MY 카테고리": "MY 카테고리",
  "With us": "With us",
  "{{category.title}} > 전체": "{{category.title}} > 전체",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}님 인프런과 함께 해주셔서 감사해요.😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}님의 첫 도약을 응원하고 있어요. 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}님의 커리어를 응원하고 있어요. 👏",
  "{{profile?.name}}님의 프로필 이미지": "{{profile?.name}}님의 프로필 이미지",
  "{{provider}}-로그인-버튼": "{{provider}}-로그인-버튼",
  "{{socialProviderNameMap[provider]}}로 로그인": "{{socialProviderNameMap[provider]}}로 로그인",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를",
  "가입 이메일 인증이 필요합니다.": "가입 이메일 인증이 필요합니다.",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `이메일 인증이 필요한 계정입니다.
24시간 후 재시도하거나 고객센터에 문의해주세요.`,
  "간편 로그인": "간편 로그인",
  강의: "강의",
  "강의 · 기능요청": "강의 · 기능요청",
  "강의/강사명을 입력해주세요": "강의/강사명을 입력해주세요",
  "강의리스트 보기": "강의리스트 보기",
  개: "개",
  "개인정보보호책임자: 이동욱": "개인정보보호책임자: 이동욱",
  개인정보처리방침: "개인정보처리방침",
  검색: "검색",
  "검색바.01": "우리는 성장 기회의 평등을 추구합니다.",
  "검색바.02": "요즘 관심 있는 주제나 기술이 있나요?",
  "검색바.03": "진짜 성장을 도와줄 강의를 찾아보세요.",
  "검색바.04": "실전에서 쓸 지식을 지금 배워보세요.",
  "검색바.05": "인프런에서 성장 여정을 시작해보세요.",
  "검색바.06": "성장을 위한 콘텐츠가 여기 있어요.",
  "검색바.07": "AI 시대에 필요한 무기, 지금 배워보세요.",
  "검색바.08": "지금 배우고싶은 지식을 찾아보세요.",
  "검색바.09": "우리는 성장 기회의 평등을 추구합니다.",
  "검색바.10": "성장하는 모든 사람을 응원합니다.",
  "검색바.11": "실전에 필요한 지식을 지금 배워보세요.",
  "검색할 강의 입력": "검색할 강의 입력",
  "경기도 성남시 분당구 판교로289번길 20": "경기도 성남시 분당구 판교로289번길 20",
  "경제적 보상을 받아보세요.": "경제적 보상을 받아보세요.",
  "계정 설정": "계정 설정",
  고객센터: "고객센터",
  고민있어요: "고민있어요",
  공지사항: "공지사항",
  교육: "교육",
  구글: "구글",
  "구매 / 혜택": "구매 / 혜택",
  "구매 내역": "구매 내역",
  국비지원교육: "국비지원교육",
  기업: "기업",
  "기업 교육을 위한 인프런": "기업 교육을 위한 인프런",
  깃허브: "깃허브",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "나를 성장 시켜줄 좋은 지식들을 찾아보세요.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요",
  "나한테 딱 맞는 걸 찾고 싶다면": "나한테 딱 맞는 걸 찾고 싶다면",
  "어떤 강의가 나한테 맞을까?": "어떤 강의가 나한테 맞을까?",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "목표·관심사에 맞는 인기 강의를 찾아드릴게요",
  "지금 많이 듣는 강의 확인해보세요": "지금 많이 듣는 강의 확인해보세요",
  난이도: "난이도",
  "난이도 선택": "난이도 선택",
  "난이도 옵션": "난이도 옵션",
  "난이도 초기화": "난이도 초기화",
  "남았어요.": "남았어요.",
  "내 학습": "내 학습",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "네이버에서 구글 로그인을 지원하지 않습니다.",
  "누구나 들을 수 있는": "누구나 들을 수 있는",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.",
  닫기: "닫기",
  "담긴 강의가 없습니다.": "담긴 강의가 없습니다.",
  대시보드: "대시보드",
  "대표자: 이형주": "대표자: 이형주",
  더보기: "더보기",
  둘러보기: "둘러보기",
  "딱 맞는 강의가 기다리고 있어요.": "딱 맞는 강의가 기다리고 있어요.",
  "랠릿 서비스 링크": "랠릿 서비스 링크",
  로그아웃: "로그아웃",
  로그인: "로그인",
  "로그인 또는 회원가입": "로그인 또는 회원가입",
  "로그인이 필요한 요청입니다.": "로그인이 필요한 요청입니다.",
  로드맵: "로드맵",
  "마음에 드는 강의를 수강해보세요!": "마음에 드는 강의를 수강해보세요!",
  "많은 사람들에게 배움의 기회를 주고,": "많은 사람들에게 배움의 기회를 주고,",
  "메인 페이지로 이동하기": "메인 페이지로 이동하기",
  멘토링: "멘토링",
  "멘토링 소개": "멘토링 소개",
  "멘토링 후기": "멘토링 후기",
  모의면접: "모의면접",
  "모임/부트캠프": "모임/부트캠프",
  "문제가 발생했습니다.": "문제가 발생했습니다.",
  보관함: "보관함",
  분: "분",
  블로그: "블로그",
  비밀번호: "비밀번호",
  "비밀번호 찾기": "비밀번호 찾기",
  "비밀번호를 입력해주세요.": "비밀번호를 입력해주세요.",
  비즈니스: "비즈니스",
  "비즈니스 브랜드 로고": "비즈니스 브랜드 로고",
  "비즈니스 수강내역": "비즈니스 수강내역",
  "사업자 정보 확인": "사업자 정보 확인",
  "사업자번호: 499-81-00612": "사업자번호: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "사용자 대시보드 페이지로 이동",
  "사용자 알림 페이지로 이동": "사용자 알림 페이지로 이동",
  서비스: "서비스",
  "서비스 언어를 선택하세요.": "서비스 언어를 선택하세요.",
  "선수 지식이 필요한": "선수 지식이 필요한",
  설정: "설정",
  수강바구니: "수강바구니",
  "수강바구니에서 전체보기": "수강바구니에서 전체보기",
  "수강코드 등록": "수강코드 등록",
  수강평: "수강평",
  "수강평 모아보기": "수강평 모아보기",
  "수료증 확인": "수료증 확인",
  스터디: "스터디",
  시간: "시간",
  신청하기: "신청하기",
  "아이디(이메일) 찾기": "아이디(이메일) 찾기",
  애플: "애플",
  어드민: "어드민",
  "언어 변경": "언어 변경",
  "언어 설정": "언어 설정",
  원: "원",
  "유저 대시보드로 이동": "유저 대시보드로 이동",
  "이 공지를 그만 볼래요": "이 공지를 그만 볼래요",
  이메일: "이메일",
  "이메일 또는 비밀번호를 확인해주세요.": "이메일 또는 비밀번호를 확인해주세요.",
  "이메일 형식이 올바르지 않습니다.": "이메일 형식이 올바르지 않습니다.",
  "이메일을 입력해주세요.": "이메일을 입력해주세요.",
  "이어서 학습하기": "이어서 학습하기",
  이용약관: "이용약관",
  인프랩: "인프랩",
  "인프랩 스토리": "인프랩 스토리",
  "인프랩 실Log": "인프랩 실Log",
  "인프랩 테크": "인프랩 테크",
  인프런: "인프런",
  "인프런 네이버 블로그 바로가기": "인프런 네이버 블로그 바로가기",
  "인프런 네이버 포스트 바로가기": "인프런 네이버 포스트 바로가기",
  "인프런 메인 페이지로 이동": "인프런 메인 페이지로 이동",
  "인프런 브랜드 로고": "인프런 브랜드 로고",
  "인프런 비즈니스": "인프런 비즈니스",
  "인프런 소개": "인프런 소개",
  "인프런 영문 브랜드 로고": "인프런 영문 브랜드 로고",
  "인프런 유튜브 바로가기": "인프런 유튜브 바로가기",
  "인프런 인스타그램 바로가기": "인프런 인스타그램 바로가기",
  "인프런 제휴": "인프런 제휴",
  "인프런 통합 검색": "인프런 통합 검색",
  "인프런 트위터 바로가기": "인프런 트위터 바로가기",
  "인프런 페이스북 바로가기": "인프런 페이스북 바로가기",
  "인프런 피드": "인프런 피드",
  "인프런으로 이동하기": "인프런으로 이동하기",
  입문: "입문",
  잎: "잎",
  "자유롭게 학습하는 환경을 제공하세요.": "자유롭게 학습하는 환경을 제공하세요.",
  "자주묻는 질문": "자주묻는 질문",
  "작성한 게시글": "작성한 게시글",
  "장바구니 페이지로 이동": "장바구니 페이지로 이동",
  "저작권 신고센터": "저작권 신고센터",
  "전문성을 높이는": "전문성을 높이는",
  전체: "전체",
  "전체 강의": "전체 강의",
  "전화번호: 070-4948-1181": "전화번호: 070-4948-1181",
  좋아요: "좋아요",
  주소: "주소",
  중급이상: "중급이상",
  "지금 둘러 보기": "지금 둘러 보기",
  지식공유: "지식공유",
  "지식공유 참여": "지식공유 참여",
  지식공유자: "지식공유자",
  "지식공유자 되기": "지식공유자 되기",
  지식공유참여: "지식공유참여",
  지식공유하기: "지식공유하기",
  "질문 & 답변": "질문 & 답변",
  "질문 게시판": "질문 게시판",
  "채널톡 아이콘": "채널톡 아이콘",
  챌린지: "챌린지",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  "청강대 게임스쿨": "청강대 게임스쿨",
  초: "초",
  초급: "초급",
  "총 결제금액": "총 결제금액",
  "최근 강의 바로가기": "최근 강의 바로가기",
  "최근 로그인": "최근 로그인",
  카카오: "카카오",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "카카오톡에서 구글 로그인을 지원하지 않습니다.",
  "카테고리 설정": "카테고리 설정",
  커리어: "커리어",
  커뮤니티: "커뮤니티",
  "코드 등록": "코드 등록",
  쿠폰: "쿠폰",
  "통신판매업: 2018-성남분당B-0062": "통신판매업: 2018-성남분당B-0062",
  "특정 상거래법": "",
  "팀 프로젝트": "팀 프로젝트",
  파트너스: "파트너스",
  포인트: "포인트",
  "포인트코드 등록": "포인트코드 등록",
  학생: "학생",
  "할인 종료까지": "할인 종료까지",
  홈: "홈",
  확인: "확인",
  회원가입: "회원가입",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!"
}, sa = {
  "(주)인프랩": "Công ty TNHH Inflab",
  "(주)인프랩 사업자 정보": "Thông tin doanh nghiệp Công ty TNHH Inflab",
  "3동 5층": "Đại Hàn Dân Quốc",
  "IT 인재 채용 서비스": "Dịch vụ tuyển dụng nhân tài IT",
  "MY 카테고리": "Danh mục của tôi",
  "With us": "Cùng chúng tôi",
  "{{category.title}} > 전체": "{{category.title}} > Tất cả",
  "{{name}}님 인프런과 함께 해주셔서 감사해요. 😊": "{{name}}, cảm ơn bạn đã đồng hành cùng Inflearn 😊",
  "{{name}}님의 첫 도약을 응원하고 있어요. 🙌": "{{name}}, chúng tôi cổ vũ bước tiến đầu tiên của bạn 🙌",
  "{{name}}님의 커리어를 응원하고 있어요. 👏": "{{name}}, chúng tôi cổ vũ cho sự nghiệp của bạn 👏",
  "{{profile?.name}}님의 프로필 이미지": "Hình ảnh hồ sơ của {{profile?.name}}",
  "{{provider}}-로그인-버튼": "Nút đăng nhập {{provider}}",
  "{{socialProviderNameMap[provider]}}로 로그인": "Đăng nhập với {{socialProviderNameMap[provider]}}",
  "“인프런 비즈니스” 를 통해 모든 팀원이 인프런의 강의를": "Với 'Inflearn Business', tất cả thành viên trong đội có thể tham gia các khóa học của Inflearn",
  "가입 이메일 인증이 필요합니다.": "Cần xác thực email để đăng ký.",
  "이메일 인증이 필요한 계정입니다.\n24시간 후 재시도하거나 고객센터에 문의해주세요.": `Tài khoản này cần xác thực email.
Vui lòng thử lại sau 24 giờ hoặc liên hệ bộ phận hỗ trợ khách hàng.`,
  "간편 로그인": "Đăng nhập nhanh",
  강의: "Khóa học",
  "강의 · 기능요청": "Yêu cầu khóa học/tính năng",
  "강의/강사명을 입력해주세요": "Vui lòng nhập tên khóa học/giảng viên",
  "강의리스트 보기": "Xem danh sách khóa học",
  개: "cái",
  "개인정보보호책임자: 이동욱": "Người phụ trách bảo mật thông tin cá nhân: Lee Dongwook",
  개인정보처리방침: "Chính sách bảo mật",
  검색: "Tìm kiếm",
  "검색바.01": "Bạn quan tâm gì hôm nay?",
  "검색바.02": "Nhập từ khóa bạn muốn.",
  "검색바.03": "Đang tìm gì cụ thể?",
  "검색바.04": "Nhập tên khóa học hoặc chủ đề.",
  "검색바.05": "Đang tìm khóa học Python?",
  "검색바.06": "Hãy thử gõ “Python”.",
  "검색바.07": "Bạn muốn rèn kỹ năng nào?",
  "검색바.08": "Khám phá khóa học mới.",
  "검색바.09": "Bạn quan tâm gì hôm nay?",
  "검색바.10": "Bạn muốn rèn kỹ năng nào?",
  "검색바.11": "Đang tìm gì cụ thể?",
  "검색할 강의 입력": "Nhập tên khóa học",
  "경기도 성남시 분당구 판교로289번길 20": "Tầng 5, Tòa nhà số 3, 20, Pangyo-ro 289beon-gil, Quận Bundang, Thành phố Seongnam, Gyeonggi-do",
  "경제적 보상을 받아보세요.": "Hãy nhận phần thưởng tài chính.",
  "계정 설정": "Cài đặt tài khoản",
  고객센터: "Trung tâm khách hàng",
  고민있어요: "Tôi cần giúp đỡ",
  공지사항: "Thông báo",
  교육: "Đào tạo",
  구글: "Google",
  "구매 / 혜택": "Mua hàng / Ưu đãi ",
  "구매 내역": "Lịch sử mua hàng",
  국비지원교육: "Khóa học được hỗ trợ bởi nhà nước",
  기업: "Doanh nghiệp",
  "기업 교육을 위한 인프런": "Inflearn cho giáo dục doanh nghiệp",
  깃허브: "GitHub",
  "나를 성장 시켜줄 좋은 지식들을 찾아보세요.": "Hãy tìm kiếm những kiến thức tuyệt vời giúp bạn phát triển.",
  "나의 진짜 성장을 도와줄 실무 강의를 찾아보세요": "Tìm các khóa học thực tiễn giúp bạn thực sự phát triển.",
  난이도: "Cấp độ",
  "난이도 선택": "Chọn cấp độ",
  "난이도 옵션": "Tùy chọn cấp độ",
  "난이도 초기화": "Đặt lại cấp độ",
  "나한테 딱 맞는 걸 찾고 싶다면": "Bạn muốn tìm khóa học phù hợp?",
  "어떤 강의가 나한테 맞을까?": "Khóa học nào phù hợp với tôi?",
  "목표와 관심사에 맞는 인기 강의를 찾아드릴게요": "Tìm khóa học cho mục tiêu của bạn",
  "지금 많이 듣는 강의 확인해보세요": "Xem ngay những khóa học đang được học nhiều nhất",
  "남았어요.": "còn lại.",
  "내 학습": "Học tập của tôi",
  "네이버에서 구글 로그인을 지원하지 않습니다.": "Naver không hỗ trợ đăng nhập bằng Google.",
  "누구나 들을 수 있는": "Mở cho tất cả mọi người",
  "다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.": "Vui lòng sử dụng trình duyệt di động khác (Chrome, Safari).",
  닫기: "Đóng",
  "담긴 강의가 없습니다.": "Không có khóa học nào trong giỏ hàng.",
  대시보드: "Bảng điều khiển",
  "대표자: 이형주": "Người đại diện: Lee Hyeongjoo",
  더보기: "Xem thêm",
  둘러보기: "Khám phá",
  "딱 맞는 강의가 기다리고 있어요.": "Khóa học phù hợp nhất đang chờ bạn.",
  "랠릿 서비스 링크": "Liên kết dịch vụ Rallit",
  로그아웃: "Đăng xuất",
  로그인: "Đăng nhập",
  "로그인 또는 회원가입": "Đăng nhập hoặc Đăng ký",
  "로그인이 필요한 요청입니다.": "Bạn cần đăng nhập để thực hiện yêu cầu này.",
  로드맵: "Lộ trình",
  "마음에 드는 강의를 수강해보세요!": "Hãy tham gia khóa học bạn yêu thích!",
  "많은 사람들에게 배움의 기회를 주고,": "Mang lại cơ hội học tập cho nhiều người,",
  "메인 페이지로 이동하기": "Đi đến trang chính",
  멘토링: "Mentoring",
  "멘토링 소개": "Giới thiệu mentoring",
  "멘토링 후기": "Đánh giá mentoring",
  "모임/부트캠프": "Câu lạc bộ/Bootcamp",
  "문제가 발생했습니다.": "Đã xảy ra sự cố.",
  보관함: "Kho lưu trữ",
  분: "phút",
  블로그: "Blog",
  비밀번호: "Mật khẩu",
  "비밀번호 찾기": "Tìm mật khẩu",
  "비밀번호를 입력해주세요.": "Vui lòng nhập mật khẩu.",
  비즈니스: "Doanh nghiệp",
  "비즈니스 브랜드 로고": "Logo thương hiệu doanh nghiệp",
  "비즈니스 수강내역": "Lịch sử khóa học doanh nghiệp",
  "사업자 정보 확인": "Kiểm tra thông tin doanh nghiệp",
  "사업자번호: 499-81-00612": "Mã số kinh doanh: 499-81-00612",
  "사용자 대시보드 페이지로 이동": "Đi đến trang bảng điều khiển người dùng",
  "사용자 알림 페이지로 이동": "Đi đến trang thông báo của người dùng",
  서비스: "Dịch vụ",
  "서비스 언어를 선택하세요.": "Vui lòng chọn ngôn ngữ dịch vụ.",
  "선수 지식이 필요한": "Yêu cầu kiến thức nền tảng",
  설정: "Cài đặt",
  수강바구니: "Giỏ khóa học",
  "수강바구니에서 전체보기": "Xem toàn bộ trong giỏ khóa học",
  "수강코드 등록": "Đăng ký mã khóa học",
  수강평: "Đánh giá khóa học",
  "수강평 모아보기": "Xem tất cả đánh giá",
  "수료증 확인": "Xem chứng chỉ hoàn thành",
  스터디: "Câu lạc bộ học tập",
  시간: "giờ",
  신청하기: "Đăng ký",
  "아이디(이메일) 찾기": "Tìm ID (email)",
  애플: "Apple",
  어드민: "Quản trị viên",
  "언어 변경": "Thay đổi ngôn ngữ",
  "언어 설정": "Cài đặt ngôn ngữ",
  원: "₫",
  "유저 대시보드로 이동": "Đi đến bảng điều khiển người dùng",
  "이 공지를 그만 볼래요": "Không muốn thấy thông báo này nữa",
  이메일: "Email",
  "이메일 또는 비밀번호를 확인해주세요.": "Vui lòng kiểm tra lại email hoặc mật khẩu.",
  "이메일 형식이 올바르지 않습니다.": "Định dạng email không hợp lệ.",
  "이메일을 입력해주세요.": "Vui lòng nhập email.",
  "이어서 학습하기": "Tiếp tục học",
  이용약관: "Điều khoản sử dụng",
  인프랩: "Inflab",
  "인프랩 스토리": "Câu chuyện về Inflab",
  "인프랩 실Log": "Nhật ký của Inflab",
  "인프랩 테크": "Công nghệ của Inflab",
  인프런: "Inflearn",
  "인프런 네이버 블로그 바로가기": "Đi đến blog Naver của Inflearn",
  "인프런 네이버 포스트 바로가기": "Đi đến bài viết Naver của Inflearn",
  "인프런 메인 페이지로 이동": "Đi đến trang chính của Inflearn",
  "인프런 브랜드 로고": "Logo thương hiệu Inflearn",
  "인프런 비즈니스": "Inflearn doanh nghiệp",
  "인프런 소개": "Giới thiệu Inflearn",
  "인프런 영문 브랜드 로고": "Logo thương hiệu tiếng Anh của Inflearn",
  "인프런 유튜브 바로가기": "Đi đến kênh YouTube của Inflearn",
  "인프런 인스타그램 바로가기": "Đi đến Instagram của Inflearn",
  "인프런 제휴": "Đối tác Inflearn",
  "인프런 통합 검색": "Tìm kiếm trong Inflearn",
  "인프런 트위터 바로가기": "Đi đến X (Twitter) của Inflearn",
  "인프런 페이스북 바로가기": "Đi đến Facebook của Inflearn",
  "인프런 피드": "Bảng tin Inflearn",
  "인프런으로 이동하기": "Đi đến Inflearn",
  입문: "Nhập môn",
  잎: "lá",
  "자유롭게 학습하는 환경을 제공하세요.": "Hãy cung cấp một môi trường học tập tự do.",
  "자주묻는 질문": "Câu hỏi thường gặp",
  "작성한 게시글": "Bài viết đã tạo",
  "장바구니 페이지로 이동": "Đi đến trang giỏ hàng",
  "저작권 신고센터": "Trung tâm báo cáo vi phạm bản quyền",
  "전문성을 높이는": "Nâng cao chuyên môn",
  전체: "Tất cả",
  "전체 강의": "Tất cả khóa học",
  "전화번호: 070-4948-1181": "Số điện thoại: 070-4948-1181",
  좋아요: "Thích",
  주소: "Địa chỉ",
  중급이상: "Trung cấp trở lên",
  "지금 둘러 보기": "Xem ngay bây giờ",
  지식공유: "Chia sẻ kiến thức",
  "지식공유 참여": "Tham gia chia sẻ kiến thức",
  지식공유자: "Người chia sẻ kiến thức",
  "지식공유자 되기": "Trở thành người chia sẻ kiến thức",
  지식공유참여: "Tham gia chia sẻ kiến thức",
  지식공유하기: "Chia sẻ kiến thức",
  "질문 & 답변": "Hỏi & Đáp",
  "질문 게시판": "Bảng câu hỏi",
  "채널톡 아이콘": "Biểu tượng ChannelTalk",
  챌린지: "Challenge",
  "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.": "Đã xảy ra lỗi trong quá trình xử lý. Vui lòng thử lại sau.",
  "청강대 게임스쿨": "Trường Game Chungkang",
  초: "giây",
  초급: "Cơ bản",
  "총 결제금액": "Tổng số tiền thanh toán",
  "최근 강의 바로가기": "Đi đến khóa học gần đây",
  "최근 로그인": "Đăng nhập gần đây",
  카카오: "Kakao",
  "카카오톡에서 구글 로그인을 지원하지 않습니다.": "KakaoTalk không hỗ trợ đăng nhập bằng Google.",
  "카테고리 설정": "Cài đặt danh mục",
  커리어: "Sự nghiệp",
  커뮤니티: "Cộng đồng",
  "코드 등록": "Đăng ký mã",
  쿠폰: "Coupon",
  "통신판매업: 2018-성남분당B-0062": "Ngành bán hàng trực tuyến: 2018-SeongnamBundangB-0062",
  "특정 상거래법": "",
  "팀 프로젝트": "Dự án nhóm",
  파트너스: "Đối tác",
  포인트: "Điểm",
  "포인트코드 등록": "Đăng ký mã điểm",
  학생: "Học sinh",
  "할인 종료까지": "Kết thúc giảm giá trong",
  홈: "Trang chủ",
  확인: "Xác nhận",
  회원가입: "Đăng ký thành viên",
  "🎁 깜짝 감사 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá cảm ơn bất ngờ ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!",
  "🎁 신규 가입 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá cho thành viên mới ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!",
  "🎁 첫 구매 할인({{discountPercent}}%)이 강의에 적용되어 있으니, 지금 바로 구매해보세요!": "🎁 Giảm giá lần mua đầu tiên ({{discountPercent}}%) đã được áp dụng cho khóa học, hãy mua ngay!"
}, Uc = {
  ko: {
    appShell: aa
  },
  en: {
    appShell: Ca
  },
  vi: {
    appShell: sa
  },
  ja: {
    appShell: ba
  }
}, Lc = Object.keys(Uc), _g = F.createInstance();
_g.use(wc).use(qn).init({
  defaultNS: "appShell",
  fallbackLng: cg,
  supportedLngs: Lc,
  detection: {
    order: ["path"]
  },
  interpolation: {
    escapeValue: !1
  },
  debug: !1,
  cleanCode: !0,
  // e.g. EN -> en
  resources: Uc
});
function Aa(g) {
  return !!Lc.find((I) => I === g);
}
function lg() {
  return Aa(_g.language) ? _g.language : cg;
}
function Oc() {
  return lg() === cg;
}
function ks(g, I) {
  return () => _g.t(g, I) ?? "";
}
function Qs(g, I = lg()) {
  return O.stringifyUrl({
    url: g,
    query: {
      lang: I
    }
  });
}
const E = {
  EMAIL: "info@inflearn.com",
  SITE: LI,
  MEMBER_HISTORY: "https://doc.clickup.com/d/3gfz7-5843/log/3gfz7-75205/%EC%9D%B8%ED%94%84%EB%9E%A9-%EC%8B%A4-log",
  STORY: "https://story.inflab.com/",
  TECH_BLOG: "https://tech.inflab.com/",
  RALLIT_BUSINESS: "https://business.rallit.com/"
};
function ua() {
  return Oc() ? E.SITE : `${E.SITE}/${lg()}`;
}
function V(g, I) {
  const e = I ?? (uC === "localhost" ? "" : E.SITE), c = g.startsWith("/") ? g : `/${g}`;
  return Oc() ? `${e}${c}` : `${e}/${lg()}${c}`;
}
const Ms = {
  INFO_PRIVACY: V("/policy/privacy", E.SITE),
  INFO_TERMS: V("/policy/terms-of-service", E.SITE),
  BIZ_INFO: "http://www.ftc.go.kr/bizCommPop.do?wrkr_no=4998100612",
  INF_EMAIL: `mailto:${E.EMAIL}`
}, Ks = {
  SPECIFIED_COMMERCIAL_TRANSACTIONS: `${E.SITE}/ja/policy/specified-commercial-transactions`
}, _s = {
  RALLIT_SITE: oe,
  RALLIT_MY_LOG: `${oe}/my/log`
}, qs = `${E.SITE}/channeltalk`, k = {
  CHALLENGES: V("/challenges"),
  MAIN: ua(),
  WITH_US: V("/pages/withus", E.SITE),
  INSTRUCTOR: V(lg() === cg ? "/instructor" : "/instructor/courses"),
  INSTRUCTOR_ABROAD: V("/instructor/courses"),
  APPLY_INSTRUCTOR: V("/instructor/application"),
  SIGN_UP: V("/signup"),
  SIGN_IN: V("/signin"),
  SIGNUP_EMAIL_REVERIFY: V("/signup/email/reverify"),
  BUSINESS_INTRO: `${Pg}/intro`,
  COURSES: (g) => {
    const I = g != null && g.category ? `/${g == null ? void 0 : g.category}` : "", e = g != null && g.subCategory ? `/${g == null ? void 0 : g.subCategory}` : "", c = ((g == null ? void 0 : g.searchKeyword) ?? "").trim();
    return c ? k.SEARCH({
      order: g == null ? void 0 : g.order,
      types: g == null ? void 0 : g.types,
      skill: g == null ? void 0 : g.skill,
      searchKeyword: c,
      completionAttributionToken: g == null ? void 0 : g.completionAttributionToken,
      selectedSuggestion: g == null ? void 0 : g.selectedSuggestion,
      selectedPosition: g == null ? void 0 : g.selectedPosition,
      levels: g == null ? void 0 : g.levels,
      tab: g == null ? void 0 : g.tab
    }) : O.stringifyUrl({
      url: V(`/courses${I}${e}`),
      query: {
        order: g == null ? void 0 : g.order,
        types: g == null ? void 0 : g.types,
        skill: g == null ? void 0 : g.skill,
        s: c,
        completionAttributionToken: g == null ? void 0 : g.completionAttributionToken,
        selectedSuggestion: g == null ? void 0 : g.selectedSuggestion,
        selectedPosition: g == null ? void 0 : g.selectedPosition,
        levels: g == null ? void 0 : g.levels,
        onboarding: g == null ? void 0 : g.onboarding,
        redirectTo: g == null ? void 0 : g.redirectTo
      }
    }, {
      skipNull: !0,
      skipEmptyString: !0
    });
  },
  SEARCH: (g) => O.stringifyUrl({
    url: V("/search"),
    query: {
      order: g == null ? void 0 : g.order,
      types: g == null ? void 0 : g.types,
      skill: g == null ? void 0 : g.skill,
      s: g == null ? void 0 : g.searchKeyword,
      completionAttributionToken: g == null ? void 0 : g.completionAttributionToken,
      selectedSuggestion: g == null ? void 0 : g.selectedSuggestion,
      selectedPosition: g == null ? void 0 : g.selectedPosition,
      levels: g == null ? void 0 : g.levels,
      tab: g == null ? void 0 : g.tab
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  COMMUNITY: V("/community"),
  COMMUNITY_USER_POSTS: V("/my/posts/question"),
  COMMUNITY_WITH_SEARCH: ({
    keyword: g
  }) => O.stringifyUrl({
    url: V("/community"),
    query: {
      s: g
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  ROADMAPS: V("/roadmaps"),
  ROADMAPS_WITH_SEARCH: ({
    keyword: g,
    sort: I,
    pageNumber: e
  }) => O.stringifyUrl({
    url: V("/roadmaps"),
    query: {
      s: g,
      sort: I,
      page_number: e
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  ENROLLED_ROADMAPS: V("/user/roadmaps/enrolled"),
  MENTORS: V("/mentors", Eg),
  MENTORING_WITH_SEARCH: ({
    keyword: g
  }) => O.stringifyUrl({
    url: V("/mentors", Eg),
    query: {
      s: g
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  }),
  COMMUNITY_QUESTION: V("/community/questions"),
  COMMUNITY_REVIEWS: V("/community/reviews"),
  BLOGS: V("/blogs"),
  COMMUNITY_STUDIES: V("/community/studies"),
  COMMUNITY_CHATS: V("/community/chats"),
  COMMUNITY_PROJECTS: V("/community/projects"),
  COMMUNITY_MENTORINGS_REVIEWS: V("/community/mentorings-reviews"),
  NOTICE_LIST: V("/notices"),
  STORIES: V("/pages"),
  INFLEARN: V("/inflearn"),
  REQUEST_TO_INFLEARN: V("/request-to-inflearn"),
  ACCOUNT_DASHBOARD: V("/users/me/dashboard"),
  ACCOUNT_SETTING: V("/my/settings/account"),
  CARTS: V("/carts"),
  MESSAGE_LIST: V("/user/messages"),
  EVENTS: V("/pages?type=event"),
  LOGOUT: (g) => O.stringifyUrl({
    url: `${LI}/signout`,
    query: {
      lang: lg(),
      redirectTo: g.redirectTo
    }
  }),
  LECTURE_LAST_VOUCHER: (g, I) => V(`/course/${g}/unit/${I}`),
  FIND_ID: V("/signin/find/id"),
  청강대게임스쿨: V("/tag-curation/tag/18123"),
  FIND_PW: V("/signin/find/password"),
  USER_MENTORINGS: V("/my/mentorings"),
  USER_POSTS: V("/my/posts"),
  MY_PARTNERS: V("/my/partners"),
  MY_PARTNERS_LINKS: V("/my/partners-links"),
  PARTNERS_NEW: V("/partners/new"),
  USER_INQUIRIES: V("/user/inquiries"),
  USER_LIKES: V("/my/likes"),
  USER_SETTINGS_ACCOUNT: V("/my/settings/account"),
  USER_COURSES: V("/my/courses"),
  MY_RECEIVED_GIFTS: V("/my/gifts/received"),
  USER_POINT: V("/user/points"),
  USER_COUPONS: V("/user/coupons"),
  FAQ: V("/faq"),
  KDT: V("/tag-curation/common_tag/kdt"),
  PARTNERS_LANDING: V("/pages/partners"),
  BUSINESS: (g) => `${Pg}/new/groups/${g}/dashboard`,
  BUSINESS_ENROLMENTS: V("/biz-enrolments"),
  USER_PROFILE: (g, I) => V(I ? `/users/${g}/@${I}` : `/users/${g}`),
  ORDERS: V("/my/orders"),
  AI_INTERVIEWS: ({
    from: g
  }) => O.stringifyUrl({
    url: V("/ai-interviews"),
    query: {
      from: g
    }
  }),
  MY_AI_INTERVIEWS: V("/my/ai-interviews"),
  FIND_RECOMMEND_COURSES: V("/courses?charge=free&order=seq"),
  CERTIFICATE: V("/certificate"),
  COURSE_DETAIL: (g) => V(`/course/${g}`),
  CLIPS: V("/clips"),
  CLIPS_WITH_SEARCH: ({
    searchKeyword: g,
    sort: I
  }) => O.stringifyUrl({
    url: V("/clips"),
    query: {
      s: g,
      sort: I
    }
  }, {
    skipNull: !0,
    skipEmptyString: !0
  })
}, GI = {
  B2B: `${Pg}/intro`,
  LIFELONG_VOUCHER: V("/pages/lifelongvoucher_2026"),
  /** ?from=header 는 트래킹용 파라미터  */
  AI_REFUND: `${V("/pages/company_pre_b")}?from=header`
}, $s = {
  INTRO: V("/inflearn"),
  FEED: V("/pages"),
  OPEN_KNOWLEDGE: V("/open-knowledge"),
  MENTORS_INTRO: V("/mentors-intro"),
  BUSINESS_INTRO: `${Pg}/intro`,
  PARTNERS: V("/partners"),
  COURSE_CODE: V("/course-code"),
  POINT_CODE: V("/point-code"),
  COPYRIGHT: V("/copyright"),
  REQUEST_TO_INFLEARN: V("/request-to-inflearn")
}, gA = {
  NAVER_BLOG: "https://blog.naver.com/inflearn",
  INSTAGRAM: "https://www.instagram.com/inflearn__official",
  YOUTUBE: "https://www.youtube.com/channel/UC0Y0T9JpgIBbyGDjvy9PbOg",
  FACEBOOK: "https://www.facebook.com/inflearn",
  TWITTER: "https://twitter.com/inflearn",
  THREADS: "https://www.threads.com/@inflearn__official"
}, IA = {
  AI_CHAT: "https://www.inflearn.com/chat/set-cookie"
};
function ra() {
  const g = sl(), {
    analytics: I
  } = al(), e = () => {
    var l, t;
    try {
      const i = g.getQueryData([yI.CLIENT_V2_ACCOUNTS_PROFILE]);
      if (!(i != null && i.data))
        return {
          user_id: null,
          user_name: null,
          user_email: null,
          user_group_id: null,
          user_group_subscription_id: null,
          role_b2b: !1,
          role_b2c: !1,
          role_admin: !1,
          role_instructor: !1
        };
      const {
        id: n,
        name: b,
        email: C
      } = i.data;
      return {
        user_id: n,
        user_name: b,
        user_email: C,
        user_group_id: (l = i.data.group) == null ? void 0 : l.id,
        user_group_subscription_id: (t = i.data.group) == null ? void 0 : t.groupSubscriptionId,
        role_b2b: pI(i.data),
        role_b2c: !pI(i.data),
        role_admin: i.data.isAdmin,
        role_instructor: i.data.isInstructor
      };
    } catch {
      return {
        user_id: null,
        user_name: null,
        user_email: null,
        user_group_id: null,
        user_group_subscription_id: null,
        role_b2b: !1,
        role_b2c: !1,
        role_admin: !1,
        role_instructor: !1
      };
    }
  };
  return {
    trackEvent: (l, t) => I.track(l, {
      mixpanelToken: dC,
      userId: e().user_id,
      mxp___user: e(),
      ...t
    })
  };
}
const da = $g(null);
function eA() {
  return gI(da);
}
function oa() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const cA = process.env.NODE_ENV === "production" ? {
  name: "lidyt8",
  styles: "*{box-sizing:border-box;}a{text-decoration:none;}.hidden{display:none;}.disabledScroll{overflow:hidden;}"
} : {
  name: "ncoqxb-globals",
  styles: "*{box-sizing:border-box;}a{text-decoration:none;}.hidden{display:none;}.disabledScroll{overflow:hidden;};label:globals;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9zdHlsZXMvZ2xvYmFscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFbUIiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL3N0eWxlcy9nbG9iYWxzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5jb25zdCBnbG9iYWxzID0gY3NzYFxuICAqIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG5cbiAgYSB7XG4gICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICB9XG5cbiAgLmhpZGRlbiB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxuXG4gIC5kaXNhYmxlZFNjcm9sbCB7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgZ2xvYmFscztcbiJdfQ== */",
  toString: oa
}, lA = {
  mobile: 768,
  tablet: 1024,
  laptop: 1365,
  desktop: 1920
}, Tg = {
  desktop: "@media (max-width: 1200px)",
  tablet: "@media (max-width: 1024px)",
  mobile: "@media (max-width: 768px)",
  smallMobile: "@media (max-width: 480px)"
};
function w(g) {
  return g === "mobile" ? Tg.mobile : g === "tablet" ? Tg.tablet : Tg.desktop;
}
const DI = (g = !1) => ({
  HEADER: g ? 72 : 200,
  HEADER_NOTICE: g ? 73 : 201,
  SCRIM: g ? 10 : 200,
  // NOTE: drawer overlay
  MOBILE_ASIDE: g ? 76 : 201,
  // NOTE: drawer
  BOTTOM_NAVIGATION: g ? 74 : 200,
  MOVE_TOP: g ? 9 : 200,
  // NOTE: 모달  dimmed 영역의 zIndex 201보다 작아야 함
  POPOVER: g ? 10 : 15,
  SEARCHBAR_MODAL: 202
}), Ga = {
  CHILDREN_WRAPPER: "children-wrapper",
  HEADER_DIVIDER_DESKTOP: "header-divider-desktop",
  HEADER_DIVIDER_MOBILE: "header-divider-mobile",
  HEADER_CONTAINER_DESKTOP: "header-container-desktop",
  HEADER_CONTAINER_MOBILE: "header-container-mobile",
  /**
   * @NOTE
   * 헤더 아래로 돌출되는 검색바 영역을 실제 레이아웃 공간으로 확보하는 스페이서.
   * main/footer 를 transform 으로 밀어내던 방식은 스크롤 중 콘텐츠가 움직이는
   * 체감 CLS(드득거림)를 유발해서 flow 상의 공간 확보로 대체함
   */
  HEADER_SEARCH_BAR_SPACER: "header-search-bar-spacer",
  FOOTER_CONTAINER: "footer-container",
  /**
   * @NOTE
   * 아래로 스크롤 했을 때 모바일 헤더 가려지게 하기 위한 식별자
   */
  HEADER_MOBILE_TOP: "header-mobile-top",
  /**
   * @NOTE
   * 아래로 스크롤 했을 때 바텀 네비 가려지게 하기 위한 식별자
   * 앤트맨에서 참조하기 위해 사용
   */
  HEADER_MOBILE_BOTTOM: "header-mobile-bottom",
  HEADER_INTEGRATED: "header-integrated"
}, Oe = {
  DESKTOP: 37,
  MOBILE: 34
}, Ec = {
  DESKTOP: {
    DEFAULT: 65,
    SEARCH_BAR: 80
  },
  MOBILE: {
    DEFAULT: 50,
    /** searchBarStyles 의 상단 패딩 4 + 검색바 46 + 하단 패딩 10 */
    SEARCH_BAR: 60
  }
}, Pc = Ec.DESKTOP.DEFAULT, tA = Ec.MOBILE.DEFAULT, Xa = /* @__PURE__ */ H({
  position: "relative",
  display: "flex",
  alignItems: "center",
  height: Pc,
  padding: "0 32px",
  maxWidth: 1440,
  width: "100%",
  minHeight: "unset",
  [w("tablet")]: {
    padding: "0 32px",
    height: "auto"
  },
  [w("mobile")]: {
    padding: "0 16px",
    height: "auto"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleHeaderContent;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Va = /* @__PURE__ */ H({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  height: Oe.DESKTOP,
  padding: "0 32px",
  maxWidth: 1440,
  width: "100%",
  [w("tablet")]: {
    height: Oe.MOBILE
  },
  [w("mobile")]: {
    padding: "0 16px"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleIntegratedHeaderContent;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnRjRDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL3N0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHsgbWVkaWFRdWVyaWVzIH0gZnJvbSAnLi4vLi4vLi4vc3R5bGVzJztcblxuZXhwb3J0IGNvbnN0IEhFQURFUl9FTEVNRU5UX0lEUyA9IHtcbiAgQ0hJTERSRU5fV1JBUFBFUjogJ2NoaWxkcmVuLXdyYXBwZXInLFxuICBIRUFERVJfRElWSURFUl9ERVNLVE9QOiAnaGVhZGVyLWRpdmlkZXItZGVza3RvcCcsXG4gIEhFQURFUl9ESVZJREVSX01PQklMRTogJ2hlYWRlci1kaXZpZGVyLW1vYmlsZScsXG4gIEhFQURFUl9DT05UQUlORVJfREVTS1RPUDogJ2hlYWRlci1jb250YWluZXItZGVza3RvcCcsXG4gIEhFQURFUl9DT05UQUlORVJfTU9CSUxFOiAnaGVhZGVyLWNvbnRhaW5lci1tb2JpbGUnLFxuICAvKipcbiAgICogQE5PVEVcbiAgICog7Zek642UIOyVhOuemOuhnCDrj4zstpzrkJjripQg6rKA7IOJ67CUIOyYgeyXreydhCDsi6TsoJwg66CI7J207JWE7JuDIOqzteqwhOycvOuhnCDtmZXrs7TtlZjripQg7Iqk7Y6Y7J207IScLlxuICAgKiBtYWluL2Zvb3RlciDrpbwgdHJhbnNmb3JtIOycvOuhnCDrsIDslrTrgrTrjZgg67Cp7Iud7J2AIOyKpO2BrOuhpCDspJEg7L2Y7YWQ7Lig6rCAIOybgOyngeydtOuKlFxuICAgKiDssrTqsJAgQ0xTKOuTnOuTneqxsOumvCnrpbwg7Jyg67Cc7ZW07IScIGZsb3cg7IOB7J2YIOqzteqwhCDtmZXrs7TroZwg64yA7LK07ZWoXG4gICAqL1xuICBIRUFERVJfU0VBUkNIX0JBUl9TUEFDRVI6ICdoZWFkZXItc2VhcmNoLWJhci1zcGFjZXInLFxuICBGT09URVJfQ09OVEFJTkVSOiAnZm9vdGVyLWNvbnRhaW5lcicsXG4gIC8qKlxuICAgKiBATk9URVxuICAgKiDslYTrnpjroZwg7Iqk7YGs66GkIO2WiOydhCDrlYwg66qo67CU7J28IO2XpOuNlCDqsIDroKTsp4Dqsowg7ZWY6riwIOychO2VnCDsi53rs4TsnpBcbiAgICovXG4gIEhFQURFUl9NT0JJTEVfVE9QOiAnaGVhZGVyLW1vYmlsZS10b3AnLFxuICAvKipcbiAgICogQE5PVEVcbiAgICog7JWE656Y66GcIOyKpO2BrOuhpCDtlojsnYQg65WMIOuwlO2FgCDrhKTruYQg6rCA66Ck7KeA6rKMIO2VmOq4sCDsnITtlZwg7Iud67OE7J6QXG4gICAqIOyVpO2KuOunqOyXkOyEnCDssLjsobDtlZjquLAg7JyE7ZW0IOyCrOyaqVxuICAgKi9cbiAgSEVBREVSX01PQklMRV9CT1RUT006ICdoZWFkZXItbW9iaWxlLWJvdHRvbScsXG4gIEhFQURFUl9JTlRFR1JBVEVEOiAnaGVhZGVyLWludGVncmF0ZWQnLFxufSBhcyBjb25zdDtcblxuLyoqXG4gKiBATk9URVxuICogc3RpY2t5IOqwgCDslYTri4wg7J2867CYIGZsb3cg65287IScIEhFQURFUl9PRkZTRVRfSEVJR0hUIOyXkCDtj6ztlajtlZjsp4Ag7JWK64qU64ukLlxuICog7JWk7Yq466eoKCNmb3ItYW50LW1hbinqs7wgU1NSIOyKpOy8iOugiO2GpOydgCDqs6DsoJUgaGVpZ2h0IOuhnCDqs7XqsITsnYQg7J6h7Jy866+A66GcXG4gKiDsnbQg6rCS7J2EIOuwlOq+uOuptCDqt7jsqr3rj4Qg7ZWo6ruYIOqwseyLoO2VtOyVvCDtlZzri6QuXG4gKi9cbmV4cG9ydCBjb25zdCBJTlRFR1JBVEVEX0hFQURFUl9IRUlHSFQgPSB7XG4gIERFU0tUT1A6IDM3LFxuICBNT0JJTEU6IDM0LFxufSBhcyBjb25zdDtcblxuZXhwb3J0IGNvbnN0IEhFQURFUl9PRkZTRVRfSEVJR0hUID0ge1xuICBERVNLVE9QOiB7XG4gICAgREVGQVVMVDogNjUsXG4gICAgU0VBUkNIX0JBUjogODAsXG4gIH0sXG4gIE1PQklMRToge1xuICAgIERFRkFVTFQ6IDUwLFxuICAgIC8qKiBzZWFyY2hCYXJTdHlsZXMg7J2YIOyDgeuLqCDtjKjrlKkgNCArIOqygOyDieuwlCA0NiArIO2VmOuLqCDtjKjrlKkgMTAgKi9cbiAgICBTRUFSQ0hfQkFSOiA2MCxcbiAgfSxcbn0gYXMgY29uc3Q7XG5cbmV4cG9ydCBjb25zdCBIRUFERVJfSEVJR0hUID0gSEVBREVSX09GRlNFVF9IRUlHSFQuREVTS1RPUC5ERUZBVUxUO1xuZXhwb3J0IGNvbnN0IEhFQURFUl9IRUlHSFRfTU9CSUxFID0gSEVBREVSX09GRlNFVF9IRUlHSFQuTU9CSUxFLkRFRkFVTFQ7XG5cbmV4cG9ydCBjb25zdCBzdHlsZUhlYWRlckNvbnRlbnQgPSBjc3Moe1xuICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgZGlzcGxheTogJ2ZsZXgnLFxuICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcbiAgaGVpZ2h0OiBIRUFERVJfSEVJR0hULFxuICBwYWRkaW5nOiAnMCAzMnB4JyxcbiAgbWF4V2lkdGg6IDE0NDAsXG4gIHdpZHRoOiAnMTAwJScsXG4gIG1pbkhlaWdodDogJ3Vuc2V0JyxcblxuICBbbWVkaWFRdWVyaWVzKCd0YWJsZXQnKV06IHtcbiAgICBwYWRkaW5nOiAnMCAzMnB4JyxcbiAgICBoZWlnaHQ6ICdhdXRvJyxcbiAgfSxcblxuICBbbWVkaWFRdWVyaWVzKCdtb2JpbGUnKV06IHtcbiAgICBwYWRkaW5nOiAnMCAxNnB4JyxcbiAgICBoZWlnaHQ6ICdhdXRvJyxcbiAgfSxcbn0pO1xuXG4vKiog66eB7YGsIOyasOy4oSDrgZ3snYQg7Zek642UIOyasOy4oSDsmIHsl63qs7wg66ee7LaU66Ck6rOgIHN0eWxlSGVhZGVyQ29udGVudCDsmYAg6rCZ7J2AIG1heFdpZHRoL+2MqOuUqeydhCDsk7Tri6QgKi9cbmV4cG9ydCBjb25zdCBzdHlsZUludGVncmF0ZWRIZWFkZXJDb250ZW50ID0gY3NzKHtcbiAgZGlzcGxheTogJ2ZsZXgnLFxuICBhbGlnbkl0ZW1zOiAnY2VudGVyJyxcbiAganVzdGlmeUNvbnRlbnQ6ICdmbGV4LWVuZCcsXG4gIGhlaWdodDogSU5URUdSQVRFRF9IRUFERVJfSEVJR0hULkRFU0tUT1AsXG4gIHBhZGRpbmc6ICcwIDMycHgnLFxuICBtYXhXaWR0aDogMTQ0MCxcbiAgd2lkdGg6ICcxMDAlJyxcblxuICBbbWVkaWFRdWVyaWVzKCd0YWJsZXQnKV06IHtcbiAgICBoZWlnaHQ6IElOVEVHUkFURURfSEVBREVSX0hFSUdIVC5NT0JJTEUsXG4gIH0sXG5cbiAgW21lZGlhUXVlcmllcygnbW9iaWxlJyldOiB7XG4gICAgcGFkZGluZzogJzAgMTZweCcsXG4gIH0sXG59KTtcbiJdfQ== */");
function Za() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const ha = [{
  label: "기업 교육",
  href: GI.B2B,
  value: "integrated_b2b"
}, {
  label: "평생교육이용권",
  href: GI.LIFELONG_VOUCHER,
  value: "integrated_lifelong_voucher"
}, {
  label: "AI 교육 90% 환급",
  href: GI.AI_REFUND,
  value: "integrated_ai_refund"
}], Wa = ({
  onLinkClick: g,
  containerStyles: I
}) => /* @__PURE__ */ Z(z, { css: [Va, I, process.env.NODE_ENV === "production" ? "" : ";label:IntegratedHeaderLinks;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL2NvbXBvbmVudHMvaW50ZWdyYXRlZEhlYWRlckNvbnRlbnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdDTyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9mZS1zaGFyZWQvZmUtc2hhcmVkL3BhY2thZ2VzL2FwcC1zaGVsbC9zcmMvY29tcG9uZW50cy9uZXh0L0hlYWRlci9jb21wb25lbnRzL2ludGVncmF0ZWRIZWFkZXJDb250ZW50LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgSW50ZXJwb2xhdGlvbiwgVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBBbmNob3IsIEJveCwgQ09MT1JfUEFMRVRURSwgR3JvdXAsIFRleHQgfSBmcm9tICdAaW5mbGVhcm4vZHMtcmVhY3QtbmV4dCc7XG5cbmltcG9ydCB7IElOVEVHUkFURURfSEVBREVSX1VSTCB9IGZyb20gJy4uLy4uLy4uLy4uL2NvbnN0YW50cy91cmxzJztcbmltcG9ydCB7IHN0eWxlSW50ZWdyYXRlZEhlYWRlckNvbnRlbnQgfSBmcm9tICcuLi9zdHlsZXMnO1xuXG4vKipcbiAqIEludGVncmF0ZWRIZWFkZXIg7JmAIFNTUiDsiqTsvIjroIjthqTsnbQg6rO17Jyg7ZWY64qUIO2RnO2YhCDqs4TsuLUuXG4gKiBza2VsZXRvbiDsl5TtirjrpqzqsIAgYW5hbHl0aWNzL3JlYWN0LXF1ZXJ5IOulvCDrsojrk6Tsl5Ag64GM7Ja07Jik7KeAIOyViuuPhOuhnSDtm4Ug7J2Y7KG07J2EIOuRkOyngCDslYrripTri6QuXG4gKi9cbmV4cG9ydCBjb25zdCBJTlRFR1JBVEVEX0hFQURFUl9MSU5LUyA9IFtcbiAgeyBsYWJlbDogJ+q4sOyXhSDqtZDsnKEnLCBocmVmOiBJTlRFR1JBVEVEX0hFQURFUl9VUkwuQjJCLCB2YWx1ZTogJ2ludGVncmF0ZWRfYjJiJyB9LFxuICB7XG4gICAgbGFiZWw6ICftj4nsg53qtZDsnKHsnbTsmqnqtownLFxuICAgIGhyZWY6IElOVEVHUkFURURfSEVBREVSX1VSTC5MSUZFTE9OR19WT1VDSEVSLFxuICAgIHZhbHVlOiAnaW50ZWdyYXRlZF9saWZlbG9uZ192b3VjaGVyJyxcbiAgfSxcbiAge1xuICAgIGxhYmVsOiAnQUkg6rWQ7JyhIDkwJSDtmZjquIknLFxuICAgIGhyZWY6IElOVEVHUkFURURfSEVBREVSX1VSTC5BSV9SRUZVTkQsXG4gICAgdmFsdWU6ICdpbnRlZ3JhdGVkX2FpX3JlZnVuZCcsXG4gIH0sXG5dIGFzIGNvbnN0O1xuXG5leHBvcnQgY29uc3QgSW50ZWdyYXRlZEhlYWRlckxpbmtzID0gKHtcbiAgb25MaW5rQ2xpY2ssXG4gIGNvbnRhaW5lclN0eWxlcyxcbn06IHtcbiAgb25MaW5rQ2xpY2s/OiAodmFsdWU6IHN0cmluZykgPT4gdm9pZDtcbiAgY29udGFpbmVyU3R5bGVzPzogSW50ZXJwb2xhdGlvbjxUaGVtZT47XG59KSA9PiAoXG4gIDxCb3ggY3NzPXtbc3R5bGVJbnRlZ3JhdGVkSGVhZGVyQ29udGVudCwgY29udGFpbmVyU3R5bGVzXX0+XG4gICAgPEdyb3VwIGdhcD17MTJ9IGFsaWduPVwiY2VudGVyXCIgd3JhcD1cIm5vd3JhcFwiPlxuICAgICAge0lOVEVHUkFURURfSEVBREVSX0xJTktTLm1hcCgoeyBsYWJlbCwgaHJlZiwgdmFsdWUgfSwgaW5kZXgpID0+IChcbiAgICAgICAgPEdyb3VwIGtleT17dmFsdWV9IGdhcD17MTJ9IGFsaWduPVwiY2VudGVyXCIgd3JhcD1cIm5vd3JhcFwiPlxuICAgICAgICAgIHtpbmRleCAhPT0gMCAmJiA8Qm94IHc9ezF9IGg9ezEyfSBiZz17Q09MT1JfUEFMRVRURS5ncmF5WzNdfSAvPn1cbiAgICAgICAgICA8QW5jaG9yIGhyZWY9e2hyZWZ9IHVuZGVybGluZT1cIm5ldmVyXCIgb25DbGljaz17KCkgPT4gb25MaW5rQ2xpY2s/Lih2YWx1ZSl9PlxuICAgICAgICAgICAgPFRleHRcbiAgICAgICAgICAgICAgZno9e3sgYmFzZTogMTIsIG1kOiAxNCB9fVxuICAgICAgICAgICAgICBjPXtDT0xPUl9QQUxFVFRFLmdyYXlbN119XG4gICAgICAgICAgICAgIGZ3PXs1MDB9XG4gICAgICAgICAgICAgIGxoPXsxLjV9XG4gICAgICAgICAgICAgIHN0eWxlPXt7IHdoaXRlU3BhY2U6ICdub3dyYXAnIH19PlxuICAgICAgICAgICAgICB7bGFiZWx9XG4gICAgICAgICAgICA8L1RleHQ+XG4gICAgICAgICAgPC9BbmNob3I+XG4gICAgICAgIDwvR3JvdXA+XG4gICAgICApKX1cbiAgICA8L0dyb3VwPlxuICA8L0JveD5cbik7XG5cbmV4cG9ydCBjb25zdCBzdHlsZUludGVncmF0ZWRIZWFkZXJSb290ID0gY3NzKHtcbiAgZGlzcGxheTogJ2ZsZXgnLFxuICBqdXN0aWZ5Q29udGVudDogJ2NlbnRlcicsXG4gIHdpZHRoOiAnMTAwJScsXG4gIGJhY2tncm91bmRDb2xvcjogJ3doaXRlJyxcbn0pO1xuIl19 */"], children: /* @__PURE__ */ Z(B, { gap: 12, align: "center", wrap: "nowrap", children: ha.map(({
  label: e,
  href: c,
  value: l
}, t) => /* @__PURE__ */ Y(B, { gap: 12, align: "center", wrap: "nowrap", children: [
  t !== 0 && /* @__PURE__ */ Z(z, { w: 1, h: 12, bg: hg.gray[3] }),
  /* @__PURE__ */ Z(FI, { href: c, underline: "never", onClick: () => g == null ? void 0 : g(l), children: /* @__PURE__ */ Z(Qe, { fz: {
    base: 12,
    md: 14
  }, c: hg.gray[7], fw: 500, lh: 1.5, style: {
    whiteSpace: "nowrap"
  }, children: e }) })
] }, l)) }) }), ma = process.env.NODE_ENV === "production" ? {
  name: "nr8bfq",
  styles: "display:flex;justify-content:center;width:100%;background-color:white"
} : {
  name: "knl97s-styleIntegratedHeaderRoot",
  styles: "display:flex;justify-content:center;width:100%;background-color:white;label:styleIntegratedHeaderRoot;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL2NvbXBvbmVudHMvaW50ZWdyYXRlZEhlYWRlckNvbnRlbnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXFEeUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9IZWFkZXIvY29tcG9uZW50cy9pbnRlZ3JhdGVkSGVhZGVyQ29udGVudC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IEludGVycG9sYXRpb24sIFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgQW5jaG9yLCBCb3gsIENPTE9SX1BBTEVUVEUsIEdyb3VwLCBUZXh0IH0gZnJvbSAnQGluZmxlYXJuL2RzLXJlYWN0LW5leHQnO1xuXG5pbXBvcnQgeyBJTlRFR1JBVEVEX0hFQURFUl9VUkwgfSBmcm9tICcuLi8uLi8uLi8uLi9jb25zdGFudHMvdXJscyc7XG5pbXBvcnQgeyBzdHlsZUludGVncmF0ZWRIZWFkZXJDb250ZW50IH0gZnJvbSAnLi4vc3R5bGVzJztcblxuLyoqXG4gKiBJbnRlZ3JhdGVkSGVhZGVyIOyZgCBTU1Ig7Iqk7LyI66CI7Yak7J20IOqzteycoO2VmOuKlCDtkZztmIQg6rOE7Li1LlxuICogc2tlbGV0b24g7JeU7Yq466as6rCAIGFuYWx5dGljcy9yZWFjdC1xdWVyeSDrpbwg67KI65Ok7JeQIOuBjOyWtOyYpOyngCDslYrrj4TroZ0g7ZuFIOydmOyhtOydhCDrkZDsp4Ag7JWK64qU64ukLlxuICovXG5leHBvcnQgY29uc3QgSU5URUdSQVRFRF9IRUFERVJfTElOS1MgPSBbXG4gIHsgbGFiZWw6ICfquLDsl4Ug6rWQ7JyhJywgaHJlZjogSU5URUdSQVRFRF9IRUFERVJfVVJMLkIyQiwgdmFsdWU6ICdpbnRlZ3JhdGVkX2IyYicgfSxcbiAge1xuICAgIGxhYmVsOiAn7Y+J7IOd6rWQ7Jyh7J207Jqp6raMJyxcbiAgICBocmVmOiBJTlRFR1JBVEVEX0hFQURFUl9VUkwuTElGRUxPTkdfVk9VQ0hFUixcbiAgICB2YWx1ZTogJ2ludGVncmF0ZWRfbGlmZWxvbmdfdm91Y2hlcicsXG4gIH0sXG4gIHtcbiAgICBsYWJlbDogJ0FJIOq1kOycoSA5MCUg7ZmY6riJJyxcbiAgICBocmVmOiBJTlRFR1JBVEVEX0hFQURFUl9VUkwuQUlfUkVGVU5ELFxuICAgIHZhbHVlOiAnaW50ZWdyYXRlZF9haV9yZWZ1bmQnLFxuICB9LFxuXSBhcyBjb25zdDtcblxuZXhwb3J0IGNvbnN0IEludGVncmF0ZWRIZWFkZXJMaW5rcyA9ICh7XG4gIG9uTGlua0NsaWNrLFxuICBjb250YWluZXJTdHlsZXMsXG59OiB7XG4gIG9uTGlua0NsaWNrPzogKHZhbHVlOiBzdHJpbmcpID0+IHZvaWQ7XG4gIGNvbnRhaW5lclN0eWxlcz86IEludGVycG9sYXRpb248VGhlbWU+O1xufSkgPT4gKFxuICA8Qm94IGNzcz17W3N0eWxlSW50ZWdyYXRlZEhlYWRlckNvbnRlbnQsIGNvbnRhaW5lclN0eWxlc119PlxuICAgIDxHcm91cCBnYXA9ezEyfSBhbGlnbj1cImNlbnRlclwiIHdyYXA9XCJub3dyYXBcIj5cbiAgICAgIHtJTlRFR1JBVEVEX0hFQURFUl9MSU5LUy5tYXAoKHsgbGFiZWwsIGhyZWYsIHZhbHVlIH0sIGluZGV4KSA9PiAoXG4gICAgICAgIDxHcm91cCBrZXk9e3ZhbHVlfSBnYXA9ezEyfSBhbGlnbj1cImNlbnRlclwiIHdyYXA9XCJub3dyYXBcIj5cbiAgICAgICAgICB7aW5kZXggIT09IDAgJiYgPEJveCB3PXsxfSBoPXsxMn0gYmc9e0NPTE9SX1BBTEVUVEUuZ3JheVszXX0gLz59XG4gICAgICAgICAgPEFuY2hvciBocmVmPXtocmVmfSB1bmRlcmxpbmU9XCJuZXZlclwiIG9uQ2xpY2s9eygpID0+IG9uTGlua0NsaWNrPy4odmFsdWUpfT5cbiAgICAgICAgICAgIDxUZXh0XG4gICAgICAgICAgICAgIGZ6PXt7IGJhc2U6IDEyLCBtZDogMTQgfX1cbiAgICAgICAgICAgICAgYz17Q09MT1JfUEFMRVRURS5ncmF5WzddfVxuICAgICAgICAgICAgICBmdz17NTAwfVxuICAgICAgICAgICAgICBsaD17MS41fVxuICAgICAgICAgICAgICBzdHlsZT17eyB3aGl0ZVNwYWNlOiAnbm93cmFwJyB9fT5cbiAgICAgICAgICAgICAge2xhYmVsfVxuICAgICAgICAgICAgPC9UZXh0PlxuICAgICAgICAgIDwvQW5jaG9yPlxuICAgICAgICA8L0dyb3VwPlxuICAgICAgKSl9XG4gICAgPC9Hcm91cD5cbiAgPC9Cb3g+XG4pO1xuXG5leHBvcnQgY29uc3Qgc3R5bGVJbnRlZ3JhdGVkSGVhZGVyUm9vdCA9IGNzcyh7XG4gIGRpc3BsYXk6ICdmbGV4JyxcbiAganVzdGlmeUNvbnRlbnQ6ICdjZW50ZXInLFxuICB3aWR0aDogJzEwMCUnLFxuICBiYWNrZ3JvdW5kQ29sb3I6ICd3aGl0ZScsXG59KTtcbiJdfQ== */",
  toString: Za
}, iA = ({
  styles: g
}) => /* @__PURE__ */ Z(z, { component: "header", id: Ga.HEADER_INTEGRATED, css: [ma, g == null ? void 0 : g.root, process.env.NODE_ENV === "production" ? "" : ";label:IntegratedHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvU2tlbGV0b24vSW50ZWdyYXRlZEhlYWRlclNrZWxldG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3QkkiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9Ta2VsZXRvbi9JbnRlZ3JhdGVkSGVhZGVyU2tlbGV0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBJbnRlcnBvbGF0aW9uLCBUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEJveCB9IGZyb20gJ0BpbmZsZWFybi9kcy1yZWFjdC1uZXh0JztcblxuaW1wb3J0IHtcbiAgSW50ZWdyYXRlZEhlYWRlckxpbmtzLFxuICBzdHlsZUludGVncmF0ZWRIZWFkZXJSb290LFxufSBmcm9tICcuLi9IZWFkZXIvY29tcG9uZW50cy9pbnRlZ3JhdGVkSGVhZGVyQ29udGVudCc7XG5pbXBvcnQgeyBIRUFERVJfRUxFTUVOVF9JRFMgfSBmcm9tICcuLi9IZWFkZXIvc3R5bGVzJztcblxuLyoqXG4gKiDthrXtlakg7Zek642U7J2YIFNTUi9TdXNwZW5zZSDsiqTsvIjroIjthqQuXG4gKiDtlZjsnbTrk5zroIjsnbTshZgg7KCE7J206528IEtvT25seSDrpbwg7JO4IOyImCDsl4bslrTshJwg64W47LacIO2MkOuLqOydgCDtmLjstpzrtoDsl5Ag66eh6ri064ukLlxuICovXG5leHBvcnQgY29uc3QgSW50ZWdyYXRlZEhlYWRlclNrZWxldG9uID0gKHtcbiAgc3R5bGVzLFxufToge1xuICBzdHlsZXM/OiB7XG4gICAgcm9vdD86IEludGVycG9sYXRpb248VGhlbWU+O1xuICAgIGNvbnRhaW5lcj86IEludGVycG9sYXRpb248VGhlbWU+O1xuICB9O1xufSkgPT4gKFxuICA8Qm94XG4gICAgY29tcG9uZW50PVwiaGVhZGVyXCJcbiAgICBpZD17SEVBREVSX0VMRU1FTlRfSURTLkhFQURFUl9JTlRFR1JBVEVEfVxuICAgIGNzcz17W3N0eWxlSW50ZWdyYXRlZEhlYWRlclJvb3QsIHN0eWxlcz8ucm9vdF19PlxuICAgIDxJbnRlZ3JhdGVkSGVhZGVyTGlua3MgY29udGFpbmVyU3R5bGVzPXtzdHlsZXM/LmNvbnRhaW5lcn0gLz5cbiAgPC9Cb3g+XG4pO1xuIl19 */"], children: /* @__PURE__ */ Z(Wa, { containerStyles: g == null ? void 0 : g.container }) });
var Dc = {}, jI = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", e = "globe", c = 512, l = 512, t = [127760], i = "f0ac", n = "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z";
  g.definition = {
    prefix: I,
    iconName: e,
    icon: [
      c,
      l,
      t,
      i,
      n
    ]
  }, g.faGlobe = g.definition, g.prefix = I, g.iconName = e, g.width = c, g.height = l, g.ligatures = t, g.unicode = i, g.svgPathData = n, g.aliases = t;
})(jI);
var jc = {};
(function(g) {
  Object.defineProperty(g, "__esModule", { value: !0 });
  var I = "fas", e = "grid", c = 448, l = 512, t = ["grid-3"], i = "e195", n = "M0 72C0 49.9 17.9 32 40 32H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zM0 232c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V232zM128 392v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40zM160 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V72zM288 232v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM160 392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392zM448 72v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V232zM448 392v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z";
  g.definition = {
    prefix: I,
    iconName: e,
    icon: [
      c,
      l,
      t,
      i,
      n
    ]
  }, g.faGrid = g.definition, g.prefix = I, g.iconName = e, g.width = c, g.height = l, g.ligatures = t, g.unicode = i, g.svgPathData = n, g.aliases = t;
})(jc);
const Na = (g) => {
  const I = YI(g);
  I.current = g, eg(() => {
    let e = window.location.href;
    const c = () => {
      e = window.location.href, I.current();
    };
    function l() {
      const i = window.location.href;
      e !== i && (e = i, c());
    }
    window.addEventListener("popstate", c);
    const t = setInterval(l, 100);
    return () => {
      window.removeEventListener("popstate", c), clearInterval(t);
    };
  }, []);
}, nA = {
  COURSES: "COURSES",
  CHALLENGES: "CHALLENGES",
  MENTORING: "MENTORING",
  CLIPS: "CLIPS",
  ROADMAPS: "ROADMAPS",
  COMMUNITY: "COMMUNITY"
}, kc = 285, xa = 25 * 3, XI = {
  COURSES: {
    icon: "course",
    text: "강의",
    href: k.COURSES()
  },
  CHALLENGES: {
    icon: "challenge",
    text: "챌린지",
    href: k.CHALLENGES
  },
  MENTORING: {
    icon: "mentoring",
    text: "멘토링",
    href: k.MENTORS
  },
  ROADMAPS: {
    icon: "roadmap",
    text: "로드맵",
    href: k.ROADMAPS
  },
  COMMUNITY: {
    icon: "community",
    text: "커뮤니티",
    href: k.COMMUNITY
  },
  CLIPS: {
    icon: "clip",
    text: "클립",
    href: k.CLIPS
  }
}, Qc = {
  // 검색바 내부 요소들
  SEARCH_MENU_DROPDOWN: 1,
  // 메뉴 드롭다운
  SEARCH_INPUT: 2,
  // 검색 입력 필드
  EXPLORE_ITEM: 2,
  // 검색 입력 필드의 둘러보기 아이템
  SEARCH_BUTTON: 3,
  // 검색 버튼
  // 메인 GNB 요소들
  BRAND_LOGO: 10,
  // 브랜드 로고
  MENU_LIST: 20,
  // 메뉴 리스트
  // 플로팅 버튼들
  MOVE_TOP: 30,
  // 맨 위로 이동 버튼
  // 제외할 요소들
  HIDDEN: -1
  // 탭 포커스에서 제외
};
function kI() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Ja = process.env.NODE_ENV === "production" ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : {
  name: "1hwwzz7-menuLabel",
  styles: "white-space:nowrap;label:menuLabel;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: kI
}, Ra = process.env.NODE_ENV === "production" ? {
  name: "1j389vi",
  styles: "font-weight:700"
} : {
  name: "l85uma-MenuItemWithIcon",
  styles: "font-weight:700;label:MenuItemWithIcon;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: kI
};
const pa = ({
  type: g,
  label: I,
  showIndicator: e = !1,
  onClick: c,
  skeletonType: l
}) => {
  const t = /* @__PURE__ */ Z(B, { w: 32, h: 32, align: "center", justify: "center", children: /* @__PURE__ */ Z(Me, { src: `${UI}/assets/images/header/${XI[g].icon}.png`, alt: XI[g].text, w: xa, width: 32, height: 32 }) }), i = /* @__PURE__ */ Z(Ba, { type: g, isSkeleton: !!l, children: /* @__PURE__ */ Z(Qe, { fz: 16, c: "gray.9", fw: 700, className: l ? `class-label-${l.toLowerCase()}` : "", css: Ja, children: !l && I }) });
  return /* @__PURE__ */ Z(FI, { h: 44, py: 6, px: 10, href: g ? XI[g].href : void 0, tabIndex: Qc.MENU_LIST, display: "flex", css: /* @__PURE__ */ H({
    flexShrink: 0,
    "&:hover": {
      textDecoration: "none",
      borderRadius: 50,
      backgroundColor: hg.gray[0]
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:MenuItemWithIcon;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL2NvbXBvbmVudHMvTWVudUl0ZW1XaXRoSWNvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0VNIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL2NvbXBvbmVudHMvTWVudUl0ZW1XaXRoSWNvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge1xuICBBbmNob3IsXG4gIEJveCxcbiAgQ09MT1JfUEFMRVRURSxcbiAgR3JvdXAsXG4gIEluZGljYXRvcixcbiAgT3B0aW1pemVJbWFnZSxcbiAgVGV4dCxcbn0gZnJvbSAnQGluZmxlYXJuL2RzLXJlYWN0LW5leHQnO1xuaW1wb3J0IHsgdXNlQ2FsbGJhY2ssIHVzZVN0YXRlIH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyBDRE5fVVJMIH0gZnJvbSAnLi4vLi4vLi4vLi4vYXBwQ29uZmlnJztcbmltcG9ydCB7IHVzZVVybENoYW5nZSB9IGZyb20gJy4uLy4uLy4uLy4uL2hvb2tzL3VzZVVybENoYW5nZSc7XG5pbXBvcnQgeyBpc0FjdGl2ZU1lbnUgfSBmcm9tICcuLi8uLi8uLi8uLi91dGlscy9tZW51TGlzdCc7XG5pbXBvcnQgdHlwZSB7IE1FTlVfTEFCRUxTIH0gZnJvbSAnLi4vY29uc3RhbnRzL21lbnVJdGVtcyc7XG5pbXBvcnQgeyBNRU5VX0lDT05fT1BUSU1JWkVfSU1BR0VfV0lEVEgsIE1FTlVfSVRFTVMgfSBmcm9tICcuLi9jb25zdGFudHMvbWVudUl0ZW1zJztcbmltcG9ydCB7IFRBQl9JTkRFWCB9IGZyb20gJy4uL2NvbnN0YW50cy90YWJJbmRleCc7XG5cbi8qKlxuICogaTE4biDtm4Ug7JeG7J20IOuPmeyeke2VmOuKlCDtl6TrjZQg66mU64m0IOyVhOydtO2FnC5cbiAqXG4gKiBTdGlja3lIZWFkZXJTa2VsZXRvbihza2VsZXRvbiDsl5Ttirjrpqwp7J20IOyCrOyaqe2VmOuvgOuhnCDsnbQg7YyM7J287J2AIOuyiOyXrS/tirjrnpjtgrkg7ZuF7J2EXG4gKiBpbXBvcnQg7ZWY7KeAIOyViuuKlOuLpCDigJQg7Iqk7LyI66CI7YakIOuqqOuTnOuKlCDrnbzrsqjsnYQg66CM642U7ZWY7KeAIOyViuyVhCBsYWJlbCDsnbQg7ZWE7JqUIOyXhuqzoCxcbiAqIOyLpOygnCDtl6TrjZQoTWVudUxpc3Qp64qUIOuyiOyXreuQnCBsYWJlbCDsnYQgcHJvcCDsnLzroZwg7KO87J6F7ZWc64ukLlxuICovXG5leHBvcnQgY29uc3QgTWVudUl0ZW1XaXRoSWNvbiA9ICh7XG4gIHR5cGUsXG4gIGxhYmVsLFxuICBzaG93SW5kaWNhdG9yID0gZmFsc2UsXG4gIG9uQ2xpY2ssXG4gIHNrZWxldG9uVHlwZSxcbn06IHtcbiAgdHlwZToga2V5b2YgdHlwZW9mIE1FTlVfSVRFTVM7XG4gIC8qKiDrsojsl63rkJwg66mU64m0IOudvOuyqC4gc2tlbGV0b25UeXBlIOydtCDsnojsnLzrqbQg66CM642U65CY7KeAIOyViuuKlOuLpC4gKi9cbiAgbGFiZWw/OiBzdHJpbmc7XG4gIHNob3dJbmRpY2F0b3I/OiBib29sZWFuO1xuICBvbkNsaWNrPzogKCkgPT4gdm9pZDtcbiAgc2tlbGV0b25UeXBlPzoga2V5b2YgdHlwZW9mIE1FTlVfSVRFTVM7XG59KSA9PiB7XG4gIGNvbnN0IG1lbnVJY29uSW1hZ2UgPSAoXG4gICAgPEdyb3VwIHc9ezMyfSBoPXszMn0gYWxpZ249XCJjZW50ZXJcIiBqdXN0aWZ5PVwiY2VudGVyXCI+XG4gICAgICA8T3B0aW1pemVJbWFnZVxuICAgICAgICBzcmM9e2Ake0NETl9VUkx9L2Fzc2V0cy9pbWFnZXMvaGVhZGVyLyR7TUVOVV9JVEVNU1t0eXBlXS5pY29ufS5wbmdgfVxuICAgICAgICBhbHQ9e01FTlVfSVRFTVNbdHlwZV0udGV4dH1cbiAgICAgICAgdz17TUVOVV9JQ09OX09QVElNSVpFX0lNQUdFX1dJRFRIfVxuICAgICAgICB3aWR0aD17MzJ9XG4gICAgICAgIGhlaWdodD17MzJ9XG4gICAgICAvPlxuICAgIDwvR3JvdXA+XG4gICk7XG5cbiAgY29uc3QgbWVudUxhYmVsID0gKFxuICAgIDxNZW51TGlzdEFjdGl2ZVdyYXBwZXIgdHlwZT17dHlwZX0gaXNTa2VsZXRvbj17ISFza2VsZXRvblR5cGV9PlxuICAgICAgPFRleHRcbiAgICAgICAgZno9ezE2fVxuICAgICAgICBjPVwiZ3JheS45XCJcbiAgICAgICAgZnc9ezcwMH1cbiAgICAgICAgY2xhc3NOYW1lPXtza2VsZXRvblR5cGUgPyBgY2xhc3MtbGFiZWwtJHtza2VsZXRvblR5cGUudG9Mb3dlckNhc2UoKX1gIDogJyd9XG4gICAgICAgIGNzcz17eyB3aGl0ZVNwYWNlOiAnbm93cmFwJyB9fT5cbiAgICAgICAgeyFza2VsZXRvblR5cGUgJiYgbGFiZWx9XG4gICAgICA8L1RleHQ+XG4gICAgPC9NZW51TGlzdEFjdGl2ZVdyYXBwZXI+XG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8QW5jaG9yXG4gICAgICBoPXs0NH1cbiAgICAgIHB5PXs2fVxuICAgICAgcHg9ezEwfVxuICAgICAgaHJlZj17dHlwZSA/IE1FTlVfSVRFTVNbdHlwZV0uaHJlZiA6IHVuZGVmaW5lZH1cbiAgICAgIHRhYkluZGV4PXtUQUJfSU5ERVguTUVOVV9MSVNUfVxuICAgICAgZGlzcGxheT1cImZsZXhcIlxuICAgICAgY3NzPXt7XG4gICAgICAgIGZsZXhTaHJpbms6IDAsXG4gICAgICAgICcmOmhvdmVyJzoge1xuICAgICAgICAgIHRleHREZWNvcmF0aW9uOiAnbm9uZScsXG4gICAgICAgICAgYm9yZGVyUmFkaXVzOiA1MCxcbiAgICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IENPTE9SX1BBTEVUVEUuZ3JheVswXSxcbiAgICAgICAgfSxcbiAgICAgIH19XG4gICAgICBvbkNsaWNrPXtvbkNsaWNrfT5cbiAgICAgIHtzaG93SW5kaWNhdG9yID8gKFxuICAgICAgICA8SW5kaWNhdG9yIHNpemU9ezE2fSByYWRpdXM9XCJ4bFwiIGxhYmVsPVwiTlwiIHBvc2l0aW9uPVwidG9wLWVuZFwiIGNvbG9yPVwicmVkXCIgb2Zmc2V0PXszfSBpbmxpbmU+XG4gICAgICAgICAgPEdyb3VwIGFsaWduPVwiY2VudGVyXCIgZ2FwPXs0fSB3cmFwPVwibm93cmFwXCI+XG4gICAgICAgICAgICB7bWVudUljb25JbWFnZX1cbiAgICAgICAgICAgIHttZW51TGFiZWx9XG4gICAgICAgICAgPC9Hcm91cD5cbiAgICAgICAgPC9JbmRpY2F0b3I+XG4gICAgICApIDogKFxuICAgICAgICA8R3JvdXAgYWxpZ249XCJjZW50ZXJcIiBnYXA9ezR9IGNzcz17eyBmb250V2VpZ2h0OiA3MDAgfX0gd3JhcD1cIm5vd3JhcFwiPlxuICAgICAgICAgIHttZW51SWNvbkltYWdlfVxuICAgICAgICAgIHttZW51TGFiZWx9XG4gICAgICAgIDwvR3JvdXA+XG4gICAgICApfVxuICAgIDwvQW5jaG9yPlxuICApO1xufTtcblxuZXhwb3J0IGNvbnN0IE1lbnVMaXN0QWN0aXZlV3JhcHBlciA9ICh7XG4gIHR5cGUsXG4gIGNoaWxkcmVuLFxuICBpc1NrZWxldG9uOiBpc1NTUiA9IGZhbHNlLFxufToge1xuICB0eXBlOiBrZXlvZiB0eXBlb2YgTUVOVV9MQUJFTFM7XG4gIGNoaWxkcmVuOiBSZWFjdC5SZWFjdE5vZGU7XG4gIGlzU2tlbGV0b24/OiBib29sZWFuO1xufSkgPT4ge1xuICBjb25zdCBbaXNBY3RpdmUsIHNldElzQWN0aXZlXSA9IHVzZVN0YXRlKCgpID0+IChpc1NTUiA/IGZhbHNlIDogaXNBY3RpdmVNZW51KHR5cGUpKSk7XG5cbiAgLy8gVVJMIOuzgOqyvSDsi5wgYWN0aXZlIOyDge2DnCDrj5nquLDtmZRcbiAgY29uc3QgaGFuZGxlTG9jYXRpb25DaGFuZ2UgPSB1c2VDYWxsYmFjaygoKSA9PiB7XG4gICAgaWYgKGlzU1NSKSB7XG4gICAgICByZXR1cm47XG4gICAgfVxuXG4gICAgY29uc3QgbmV3SXNBY3RpdmUgPSBpc0FjdGl2ZU1lbnUodHlwZSk7XG4gICAgc2V0SXNBY3RpdmUobmV3SXNBY3RpdmUpO1xuICB9LCBbdHlwZSwgaXNTU1JdKTtcblxuICB1c2VVcmxDaGFuZ2UoaGFuZGxlTG9jYXRpb25DaGFuZ2UpO1xuXG4gIHJldHVybiAoXG4gICAgPEJveCBjc3M9e3sgcG9zaXRpb246ICdyZWxhdGl2ZScgfX0+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgICB7aXNBY3RpdmUgJiYgKFxuICAgICAgICA8Qm94XG4gICAgICAgICAgdz1cIjEwMCVcIlxuICAgICAgICAgIGg9ezN9XG4gICAgICAgICAgY3NzPXt7XG4gICAgICAgICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgICAgICAgICAgIGJvdHRvbTogLTIsXG4gICAgICAgICAgICBsZWZ0OiAnNTAlJyxcbiAgICAgICAgICAgIHRyYW5zZm9ybTogJ3RyYW5zbGF0ZVgoLTUwJSknLFxuICAgICAgICAgIH19PlxuICAgICAgICAgIDxCb3hcbiAgICAgICAgICAgIHc9XCIxMDAlXCJcbiAgICAgICAgICAgIGg9ezJ9XG4gICAgICAgICAgICBjc3M9e3tcbiAgICAgICAgICAgICAgYm9yZGVyUmFkaXVzOiA4LFxuICAgICAgICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IENPTE9SX1BBTEVUVEUuaW5mZ3JlZW5bN10sXG4gICAgICAgICAgICB9fVxuICAgICAgICAgIC8+XG4gICAgICAgIDwvQm94PlxuICAgICAgKX1cbiAgICA8L0JveD5cbiAgKTtcbn07XG4iXX0= */"), onClick: c, children: e ? /* @__PURE__ */ Z(cl, { size: 16, radius: "xl", label: "N", position: "top-end", color: "red", offset: 3, inline: !0, children: /* @__PURE__ */ Y(B, { align: "center", gap: 4, wrap: "nowrap", children: [
    t,
    i
  ] }) }) : /* @__PURE__ */ Y(B, { align: "center", gap: 4, css: Ra, wrap: "nowrap", children: [
    t,
    i
  ] }) });
};
var ya = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1y6y0da-MenuListActiveWrapper",
  styles: "position:relative;label:MenuListActiveWrapper;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: kI
};
const Ba = ({
  type: g,
  children: I,
  isSkeleton: e = !1
}) => {
  const [c, l] = fI(() => e ? !1 : he(g)), t = wg(() => {
    if (e)
      return;
    const i = he(g);
    l(i);
  }, [g, e]);
  return Na(t), /* @__PURE__ */ Y(z, { css: ya, children: [
    I,
    c && /* @__PURE__ */ Z(z, { w: "100%", h: 3, css: /* @__PURE__ */ H({
      position: "absolute",
      bottom: -2,
      left: "50%",
      transform: "translateX(-50%)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:MenuListActiveWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ Z(z, { w: "100%", h: 2, css: /* @__PURE__ */ H({
      borderRadius: 8,
      backgroundColor: hg.infgreen[7]
    }, process.env.NODE_ENV === "production" ? "" : ";label:MenuListActiveWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") }) })
  ] });
}, Ee = 20, Pe = 4, De = 10, va = (g) => g ? 58 : 46, Fa = ({
  showMenuList: g,
  isAntMan: I
}) => /* @__PURE__ */ H({
  width: 520,
  zIndex: DI(I).HEADER,
  position: "absolute",
  paddingTop: Ee,
  top: g ? "auto" : 28,
  height: g ? `calc(58px + ${Ee}px)` : "auto",
  transform: "translateX(-50%)",
  left: "50%",
  transition: "top 0.2s ease-out, padding-top 0.2s ease-out, height 0.2s ease-out",
  [w("tablet")]: {
    display: "none"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAppShellSearchBarWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Mc = ({
  showMenuList: g,
  isFocused: I,
  isMobile: e
}) => /* @__PURE__ */ H({
  width: e ? "100%" : g ? 518 : 420,
  height: va(g),
  paddingLeft: g ? 8 : 7,
  paddingRight: g ? 8 : 7,
  transition: "width 0.2s ease-out, height 0.2s ease-out, border-radius 0.2s ease-out, border 0.2s ease-out, box-shadow 0.2s ease-out",
  borderRadius: 50,
  border: `1px solid ${hg.gray[I ? 9 : 3]}`,
  backgroundColor: "white",
  boxShadow: !e && I ? "0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 36px 28px -7px rgba(0, 0, 0, 0.05), 0 17px 17px -7px rgba(0, 0, 0, 0.04)" : "none"
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAppShellSearchBarInnerWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), fa = ({
  showMenuList: g
}) => /* @__PURE__ */ H({
  display: "none",
  zIndex: DI(!0).HEADER,
  top: g ? "auto" : 12,
  height: "auto",
  backgroundColor: "white",
  transition: "top 0.2s ease-out, padding-top 0.2s ease-out, height 0.2s ease-out",
  [w("tablet")]: {
    display: "flex",
    margin: "0 -32px",
    padding: `${Pe}px 32px ${De}px`
  },
  [w("mobile")]: {
    margin: "0 -16px",
    padding: `${Pe}px 16px ${De}px`
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleAppShellSearchBarMobileWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Kc = $g({
  profile: void 0,
  isLoading: !1
}), CA = ({
  children: g
}) => {
  const {
    data: I,
    isLoading: e,
    error: c
  } = ub();
  db(c);
  const l = qe(() => ({
    profile: I ? {
      ...I,
      isB2b: pI(I),
      isGroupManager: ib(I),
      isGroupUser: tb(I),
      isPartner: nb(I)
    } : void 0,
    isLoading: e
  }), [I, e]);
  return /* @__PURE__ */ Z(Kc.Provider, { value: l, children: g });
}, Ya = () => {
  const g = gI(Kc);
  if (!g)
    throw new Error("useProfileContext must be used within a ProfileProvider");
  return g;
};
function _c() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const Sa = `${UI}/assets/images/header/inflearn_logo_business.svg`, Ta = `${UI}/assets/brand/logo.png?t=1`, je = 48, ke = 42, bA = ({
  isMobile: g = !1
}) => {
  var b;
  const {
    getSnapshot: I,
    setSnapshot: e
  } = lb(), {
    trackEvent: c
  } = ra(), {
    profile: l
  } = Ya(), i = (l == null ? void 0 : l.isB2b) ? ((b = l == null ? void 0 : l.group) == null ? void 0 : b.logoUrl) ?? Sa : Ta, n = I();
  return eg(() => {
    (!n || n.logo !== i) && e({
      logo: i
    });
  }, [i, e, I, n]), /* @__PURE__ */ Z(Ha, { url: i, onClick: () => {
    c(Wb.CLICK_LOGO_AT_HEADER);
  }, isMobile: g });
}, QI = ({
  onClick: g,
  children: I
}) => {
  const {
    t: e
  } = Jc();
  return /* @__PURE__ */ Z(FI, { href: k.MAIN, "aria-label": e("인프런 메인 페이지로 이동"), tabIndex: Qc.BRAND_LOGO, css: wa, onClick: g, children: I });
};
var za = process.env.NODE_ENV === "production" ? {
  name: "1qesdsb",
  styles: "background-color:white"
} : {
  name: "uzjx03-HeaderBrandLogoImage",
  styles: "background-color:white;label:HeaderBrandLogoImage;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _c
};
const Ha = ({
  url: g,
  onClick: I,
  isMobile: e
}) => {
  const [c, l] = fI(!1);
  return /* @__PURE__ */ Z(qg, { pos: "relative", children: /* @__PURE__ */ Y(QI, { onClick: I, children: [
    /* @__PURE__ */ Z(Ke, { h: e ? ke : je, children: /* @__PURE__ */ Z(Me, { w: 201, height: e ? ke : je, src: g, alt: "inflearn logo", onLoad: () => {
      l(!0);
    } }) }),
    !c && /* @__PURE__ */ Z(z, { pos: "absolute", top: 0, left: 0, w: "auto", h: "auto", css: za, children: /* @__PURE__ */ Z(z, { className: "class-logo" }) })
  ] }) });
}, wa = process.env.NODE_ENV === "production" ? {
  name: "1eingpo",
  styles: "display:flex;height:100%;align-items:center;& picture{display:flex;width:100%;height:100%;}"
} : {
  name: "1qgh1ec-styleHeaderBrandLogo",
  styles: "display:flex;height:100%;align-items:center;& picture{display:flex;width:100%;height:100%;};label:styleHeaderBrandLogo;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _c
};
function Ua() {
  return /* @__PURE__ */ Z(B, { w: kc, mt: -4, children: /* @__PURE__ */ Z(B, { className: "class-show-logo", children: /* @__PURE__ */ Z(QI, { children: /* @__PURE__ */ Z(z, { className: "class-logo" }) }) }) });
}
function La() {
  return /* @__PURE__ */ Z(B, { mt: -4, children: /* @__PURE__ */ Z(B, { className: "class-show-logo", children: /* @__PURE__ */ Z(QI, { children: /* @__PURE__ */ Z(z, { className: "class-logo" }) }) }) });
}
function bI() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function aA({
  styles: g,
  isAntMan: I,
  showLanguageSectionButton: e = !0
}) {
  var c, l, t, i;
  return /* @__PURE__ */ Z(Ke, { component: "header", className: "class-show-search-bar-header", css: [/* @__PURE__ */ H({
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    width: "100%",
    backgroundColor: "#fff",
    zIndex: DI(I).HEADER,
    alignItems: "flex-start",
    justifyContent: "center",
    [w("tablet")]: {
      height: 50
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:StickyHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), (c = g == null ? void 0 : g.header) == null ? void 0 : c.root, process.env.NODE_ENV === "production" ? "" : ";label:StickyHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ Y(B, { css: [Xa, qa, (l = g == null ? void 0 : g.header) == null ? void 0 : l.container, process.env.NODE_ENV === "production" ? "" : ";label:StickyHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
    /* @__PURE__ */ Z(Ea, { styles: (t = g == null ? void 0 : g.header) == null ? void 0 : t.desktop, isAntMan: I, showLanguageSectionButton: e }),
    /* @__PURE__ */ Z(Ma, { styles: (i = g == null ? void 0 : g.header) == null ? void 0 : i.mobile, showLanguageSectionButton: e })
  ] }) });
}
var Oa = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1gwiwrs-DesktopHeaderSkeleton",
  styles: "position:relative;label:DesktopHeaderSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: bI
};
const Ea = ({
  styles: g,
  isAntMan: I,
  showLanguageSectionButton: e
}) => /* @__PURE__ */ Z(qg, { justify: "flex-start", align: "center", w: "100%", className: "class-show-search-bar-wrapper", css: /* @__PURE__ */ H({
  backgroundColor: "white",
  [w("tablet")]: {
    height: "auto"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), children: /* @__PURE__ */ Y(B, { justify: "space-between", align: "center", gap: 0, w: "100%", h: Pc, wrap: "nowrap", css: [/* @__PURE__ */ H({
  [w("tablet")]: {
    display: "none"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), g == null ? void 0 : g.root, process.env.NODE_ENV === "production" ? "" : ";label:DesktopHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
  /* @__PURE__ */ Z(Ua, {}),
  /* @__PURE__ */ Y(z, { css: Oa, children: [
    /* @__PURE__ */ Z(ka, {}),
    /* @__PURE__ */ Z(ja, { isAntMan: I })
  ] }),
  /* @__PURE__ */ Z(Pa, { showLanguageSectionButton: e })
] }) }), Pa = ({
  showLanguageSectionButton: g
}) => /* @__PURE__ */ Y(B, { w: kc, gap: 10, justify: "flex-end", children: [
  /* @__PURE__ */ Z(Wg, { variant: "light", size: "n-md", color: "gray", radius: "xl", disabled: !0, children: /* @__PURE__ */ Z(mg, { icon: jc.faGrid }) }),
  g && /* @__PURE__ */ Z(Wg, { variant: "light", size: "n-md", color: "gray", radius: "xl", disabled: !0, children: /* @__PURE__ */ Z(mg, { icon: jI.faGlobe }) }),
  /* @__PURE__ */ Z(_e, { width: 92, height: 42, radius: "xl" })
] });
var Da = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "184j5yn-SearchBarSkeleton",
  styles: "flex:1;label:SearchBarSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: bI
};
const ja = ({
  isAntMan: g
}) => /* @__PURE__ */ Z(B, { className: "class-show-search-bar", css: Fa({
  showMenuList: !0,
  isAntMan: g
}), children: /* @__PURE__ */ Y(B, { css: Mc({
  showMenuList: !0,
  isFocused: !1,
  isMobile: !1
}), children: [
  /* @__PURE__ */ Z(z, { css: Da }),
  /* @__PURE__ */ Z(Wg, { type: "submit", size: "n-md", variant: "filled", color: "infgreen", radius: 999, disabled: !0, children: /* @__PURE__ */ Z(mg, { icon: Dc.faSearch, size: "md" }) })
] }) }), ka = () => /* @__PURE__ */ Z(B, { h: 44, children: /* @__PURE__ */ Y(B, { gap: 10, className: "class-show-menu-list", wrap: "nowrap", children: [
  /* @__PURE__ */ Z(Gg, { type: "COURSES" }),
  /* @__PURE__ */ Z(Gg, { type: "CHALLENGES" }),
  /* @__PURE__ */ Z(Gg, { type: "MENTORING" }),
  /* @__PURE__ */ Z(Gg, { type: "ROADMAPS" }),
  /* @__PURE__ */ Z(Gg, { type: "COMMUNITY" })
] }) }), Gg = ({
  type: g,
  showIndicator: I = !1
}) => /* @__PURE__ */ Z(qg, { justify: "center", className: `class-show-menu-${g.toLowerCase()}`, children: /* @__PURE__ */ Z(pa, { type: g, skeletonType: g, showIndicator: I }) });
var Qa = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "ow3ghr-MobileHeaderSkeleton",
  styles: "flex:1;label:MobileHeaderSkeleton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: bI
};
const Ma = ({
  styles: g,
  showLanguageSectionButton: I
}) => /* @__PURE__ */ Y(qg, { w: "100%", gap: 0, css: /* @__PURE__ */ H({
  display: "none",
  [w("tablet")]: {
    display: "flex"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:MobileHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2ZlLXNoYXJlZC9mZS1zaGFyZWQvcGFja2FnZXMvYXBwLXNoZWxsL3NyYy9jb21wb25lbnRzL25leHQvSGVhZGVyL1N0aWNreUhlYWRlclNrZWxldG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5TUkiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvZmUtc2hhcmVkL2ZlLXNoYXJlZC9wYWNrYWdlcy9hcHAtc2hlbGwvc3JjL2NvbXBvbmVudHMvbmV4dC9IZWFkZXIvU3RpY2t5SGVhZGVyU2tlbGV0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBJbnRlcnBvbGF0aW9uLCBUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEFjdGlvbkljb24sIEJveCwgRmxleCwgR3JvdXAsIEljb24sIFNrZWxldG9uLCBTdGFjayB9IGZyb20gJ0BpbmZsZWFybi9kcy1yZWFjdC1uZXh0JztcbmltcG9ydCB7IHNvbGlkIH0gZnJvbSAnQGluZmxlYXJuL2ZvbnRhd2Vzb21lLXN2Zy1jb3JlL2ltcG9ydC5tYWNybyc7XG5cbmltcG9ydCB7IE1lbnVJdGVtV2l0aEljb24gfSBmcm9tICcuL2NvbXBvbmVudHMvTWVudUl0ZW1XaXRoSWNvbic7XG5pbXBvcnQgdHlwZSB7IE1FTlVfSVRFTVMgfSBmcm9tICcuL2NvbnN0YW50cy9tZW51SXRlbXMnO1xuaW1wb3J0IHsgR05CX1NJREVfV0lEVEggfSBmcm9tICcuL2NvbnN0YW50cy9tZW51SXRlbXMnO1xuaW1wb3J0IHsgSEVBREVSX0hFSUdIVCwgc3R5bGVIZWFkZXJDb250ZW50IH0gZnJvbSAnLi9zdHlsZXMnO1xuaW1wb3J0IHsgZ2V0WkluZGV4LCBtZWRpYVF1ZXJpZXMgfSBmcm9tICcuLi8uLi8uLi9zdHlsZXMnO1xuaW1wb3J0IHtcbiAgc3R5bGVBcHBTaGVsbFNlYXJjaEJhcklubmVyV3JhcHBlcixcbiAgc3R5bGVBcHBTaGVsbFNlYXJjaEJhck1vYmlsZVdyYXBwZXIsXG4gIHN0eWxlQXBwU2hlbGxTZWFyY2hCYXJXcmFwcGVyLFxufSBmcm9tICcuLi9TZWFyY2hCYXIvc2VhcmNoQmFyU3R5bGVzJztcbmltcG9ydCB7XG4gIEhlYWRlckJyYW5kTG9nb1NrZWxldG9uLFxuICBIZWFkZXJCcmFuZExvZ29Ta2VsZXRvbk1vYmlsZSxcbn0gZnJvbSAnLi4vU2tlbGV0b24vSGVhZGVyQnJhbmRMb2dvU2tlbGV0b24nO1xuXG50eXBlIFN0aWNreUhlYWRlclNrZWxldG9uUHJvcHMgPSB7XG4gIGlzQW50TWFuOiBib29sZWFuO1xuICAvKipcbiAgICog7Iuk7KCcIO2XpOuNlChSaWdodFNlY3Rpb24p7JmAIOqwmeydgCDsobDqsbTsnLzroZwg7Ja47Ja0IOuyhO2KvCDsnpDrpqzrpbwg7J6h7JWE7JW8IO2VnOuLpC5cbiAgICog7Zi47Iqk7Yq46rCAIFNrZWxldG9uSGVhZGVyIOulvCDsp4HsoJEg7JOw64qUIOqyveyasOulvCDsnITtlbQg6riw67O46rCS7J2AIOuFuOy2nCh0cnVlKS5cbiAgICovXG4gIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b24/OiBib29sZWFuO1xuICBzdHlsZXM/OiB7XG4gICAgaGVhZGVyPzoge1xuICAgICAgcm9vdD86IEludGVycG9sYXRpb248VGhlbWU+O1xuICAgICAgY29udGFpbmVyPzogSW50ZXJwb2xhdGlvbjxUaGVtZT47XG4gICAgICBtb2JpbGU/OiB7XG4gICAgICAgIHJvb3Q/OiBJbnRlcnBvbGF0aW9uPFRoZW1lPjtcbiAgICAgIH07XG4gICAgICBkZXNrdG9wPzoge1xuICAgICAgICByb290PzogSW50ZXJwb2xhdGlvbjxUaGVtZT47XG4gICAgICB9O1xuICAgIH07XG4gIH07XG59O1xuXG5leHBvcnQgZnVuY3Rpb24gU3RpY2t5SGVhZGVyU2tlbGV0b24oe1xuICBzdHlsZXMsXG4gIGlzQW50TWFuLFxuICBzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uID0gdHJ1ZSxcbn06IFN0aWNreUhlYWRlclNrZWxldG9uUHJvcHMpIHtcbiAgcmV0dXJuIChcbiAgICA8RmxleFxuICAgICAgY29tcG9uZW50PVwiaGVhZGVyXCJcbiAgICAgIGNsYXNzTmFtZT1cImNsYXNzLXNob3ctc2VhcmNoLWJhci1oZWFkZXJcIlxuICAgICAgY3NzPXtbXG4gICAgICAgIGNzcyh7XG4gICAgICAgICAgcG9zaXRpb246ICdzdGlja3knLFxuICAgICAgICAgIHRvcDogMCxcbiAgICAgICAgICBsZWZ0OiAwLFxuICAgICAgICAgIHJpZ2h0OiAwLFxuICAgICAgICAgIHdpZHRoOiAnMTAwJScsXG4gICAgICAgICAgYmFja2dyb3VuZENvbG9yOiAnI2ZmZicsXG4gICAgICAgICAgekluZGV4OiBnZXRaSW5kZXgoaXNBbnRNYW4pLkhFQURFUixcbiAgICAgICAgICBhbGlnbkl0ZW1zOiAnZmxleC1zdGFydCcsXG4gICAgICAgICAganVzdGlmeUNvbnRlbnQ6ICdjZW50ZXInLFxuXG4gICAgICAgICAgW21lZGlhUXVlcmllcygndGFibGV0JyldOiB7XG4gICAgICAgICAgICBoZWlnaHQ6IDUwLFxuICAgICAgICAgIH0sXG4gICAgICAgIH0pLFxuICAgICAgICBzdHlsZXM/LmhlYWRlcj8ucm9vdCxcbiAgICAgIF19PlxuICAgICAgPEdyb3VwIGNzcz17W3N0eWxlSGVhZGVyQ29udGVudCwgc3R5bGVIZWFkZXJDb250YWluZXJJbm5lciwgc3R5bGVzPy5oZWFkZXI/LmNvbnRhaW5lcl19PlxuICAgICAgICA8RGVza3RvcEhlYWRlclNrZWxldG9uXG4gICAgICAgICAgc3R5bGVzPXtzdHlsZXM/LmhlYWRlcj8uZGVza3RvcH1cbiAgICAgICAgICBpc0FudE1hbj17aXNBbnRNYW59XG4gICAgICAgICAgc2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbj17c2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbn1cbiAgICAgICAgLz5cbiAgICAgICAgPE1vYmlsZUhlYWRlclNrZWxldG9uXG4gICAgICAgICAgc3R5bGVzPXtzdHlsZXM/LmhlYWRlcj8ubW9iaWxlfVxuICAgICAgICAgIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b249e3Nob3dMYW5ndWFnZVNlY3Rpb25CdXR0b259XG4gICAgICAgIC8+XG4gICAgICA8L0dyb3VwPlxuICAgIDwvRmxleD5cbiAgKTtcbn1cblxuY29uc3QgRGVza3RvcEhlYWRlclNrZWxldG9uID0gKHtcbiAgc3R5bGVzLFxuICBpc0FudE1hbixcbiAgc2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbixcbn06IHtcbiAgc3R5bGVzPzoge1xuICAgIHJvb3Q/OiBJbnRlcnBvbGF0aW9uPFRoZW1lPjtcbiAgfTtcbiAgaXNBbnRNYW46IGJvb2xlYW47XG4gIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b246IGJvb2xlYW47XG59KSA9PiAoXG4gIDxTdGFja1xuICAgIGp1c3RpZnk9XCJmbGV4LXN0YXJ0XCJcbiAgICBhbGlnbj1cImNlbnRlclwiXG4gICAgdz1cIjEwMCVcIlxuICAgIGNsYXNzTmFtZT1cImNsYXNzLXNob3ctc2VhcmNoLWJhci13cmFwcGVyXCJcbiAgICBjc3M9e3tcbiAgICAgIGJhY2tncm91bmRDb2xvcjogJ3doaXRlJyxcbiAgICAgIFttZWRpYVF1ZXJpZXMoJ3RhYmxldCcpXToge1xuICAgICAgICBoZWlnaHQ6ICdhdXRvJyxcbiAgICAgIH0sXG4gICAgfX0+XG4gICAgPEdyb3VwXG4gICAgICBqdXN0aWZ5PVwic3BhY2UtYmV0d2VlblwiXG4gICAgICBhbGlnbj1cImNlbnRlclwiXG4gICAgICBnYXA9ezB9XG4gICAgICB3PVwiMTAwJVwiXG4gICAgICBoPXtIRUFERVJfSEVJR0hUfVxuICAgICAgd3JhcD1cIm5vd3JhcFwiXG4gICAgICBjc3M9e1tcbiAgICAgICAgY3NzKHtcbiAgICAgICAgICBbbWVkaWFRdWVyaWVzKCd0YWJsZXQnKV06IHtcbiAgICAgICAgICAgIGRpc3BsYXk6ICdub25lJyxcbiAgICAgICAgICB9LFxuICAgICAgICB9KSxcbiAgICAgICAgc3R5bGVzPy5yb290LFxuICAgICAgXX0+XG4gICAgICA8SGVhZGVyQnJhbmRMb2dvU2tlbGV0b24gLz5cbiAgICAgIDxCb3ggY3NzPXt7IHBvc2l0aW9uOiAncmVsYXRpdmUnIH19PlxuICAgICAgICA8TWVudUxpc3RTa2VsZXRvbiAvPlxuICAgICAgICA8U2VhcmNoQmFyU2tlbGV0b24gaXNBbnRNYW49e2lzQW50TWFufSAvPlxuICAgICAgPC9Cb3g+XG4gICAgICA8UmlnaHRTZWN0aW9uU2tlbGV0b24gc2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbj17c2hvd0xhbmd1YWdlU2VjdGlvbkJ1dHRvbn0gLz5cbiAgICA8L0dyb3VwPlxuICA8L1N0YWNrPlxuKTtcblxuY29uc3QgUmlnaHRTZWN0aW9uU2tlbGV0b24gPSAoe1xuICBzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uLFxufToge1xuICBzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uOiBib29sZWFuO1xufSkgPT4gKFxuICA8R3JvdXAgdz17R05CX1NJREVfV0lEVEh9IGdhcD17MTB9IGp1c3RpZnk9XCJmbGV4LWVuZFwiPlxuICAgIDxBY3Rpb25JY29uIHZhcmlhbnQ9XCJsaWdodFwiIHNpemU9XCJuLW1kXCIgY29sb3I9XCJncmF5XCIgcmFkaXVzPVwieGxcIiBkaXNhYmxlZD5cbiAgICAgIDxJY29uIGljb249e3NvbGlkKCdncmlkJyl9IC8+XG4gICAgPC9BY3Rpb25JY29uPlxuICAgIHtzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uICYmIChcbiAgICAgIDxBY3Rpb25JY29uIHZhcmlhbnQ9XCJsaWdodFwiIHNpemU9XCJuLW1kXCIgY29sb3I9XCJncmF5XCIgcmFkaXVzPVwieGxcIiBkaXNhYmxlZD5cbiAgICAgICAgPEljb24gaWNvbj17c29saWQoJ2dsb2JlJyl9IC8+XG4gICAgICA8L0FjdGlvbkljb24+XG4gICAgKX1cbiAgICA8U2tlbGV0b24gd2lkdGg9ezkyfSBoZWlnaHQ9ezQyfSByYWRpdXM9XCJ4bFwiIC8+XG4gIDwvR3JvdXA+XG4pO1xuXG5jb25zdCBTZWFyY2hCYXJTa2VsZXRvbiA9ICh7IGlzQW50TWFuIH06IHsgaXNBbnRNYW46IGJvb2xlYW4gfSkgPT4gKFxuICA8R3JvdXBcbiAgICBjbGFzc05hbWU9XCJjbGFzcy1zaG93LXNlYXJjaC1iYXJcIlxuICAgIGNzcz17c3R5bGVBcHBTaGVsbFNlYXJjaEJhcldyYXBwZXIoeyBzaG93TWVudUxpc3Q6IHRydWUsIGlzQW50TWFuIH0pfT5cbiAgICA8R3JvdXBcbiAgICAgIGNzcz17c3R5bGVBcHBTaGVsbFNlYXJjaEJhcklubmVyV3JhcHBlcih7XG4gICAgICAgIHNob3dNZW51TGlzdDogdHJ1ZSxcbiAgICAgICAgaXNGb2N1c2VkOiBmYWxzZSxcbiAgICAgICAgaXNNb2JpbGU6IGZhbHNlLFxuICAgICAgfSl9PlxuICAgICAgPEJveCBjc3M9e3sgZmxleDogMSB9fT48L0JveD5cbiAgICAgIDxBY3Rpb25JY29uIHR5cGU9XCJzdWJtaXRcIiBzaXplPVwibi1tZFwiIHZhcmlhbnQ9XCJmaWxsZWRcIiBjb2xvcj1cImluZmdyZWVuXCIgcmFkaXVzPXs5OTl9IGRpc2FibGVkPlxuICAgICAgICA8SWNvbiBpY29uPXtzb2xpZCgnc2VhcmNoJyl9IHNpemU9XCJtZFwiIC8+XG4gICAgICA8L0FjdGlvbkljb24+XG4gICAgPC9Hcm91cD5cbiAgPC9Hcm91cD5cbik7XG5cbmNvbnN0IE1lbnVMaXN0U2tlbGV0b24gPSAoKSA9PiAoXG4gIDxHcm91cCBoPXs0NH0+XG4gICAgPEdyb3VwIGdhcD17MTB9IGNsYXNzTmFtZT1cImNsYXNzLXNob3ctbWVudS1saXN0XCIgd3JhcD1cIm5vd3JhcFwiPlxuICAgICAgPE1lbnVJdGVtV2l0aEljb25Ta2VsZXRvbiB0eXBlPVwiQ09VUlNFU1wiIC8+XG4gICAgICA8TWVudUl0ZW1XaXRoSWNvblNrZWxldG9uIHR5cGU9XCJDSEFMTEVOR0VTXCIgLz5cbiAgICAgIDxNZW51SXRlbVdpdGhJY29uU2tlbGV0b24gdHlwZT1cIk1FTlRPUklOR1wiIC8+XG4gICAgICA8TWVudUl0ZW1XaXRoSWNvblNrZWxldG9uIHR5cGU9XCJST0FETUFQU1wiIC8+XG4gICAgICA8TWVudUl0ZW1XaXRoSWNvblNrZWxldG9uIHR5cGU9XCJDT01NVU5JVFlcIiAvPlxuICAgIDwvR3JvdXA+XG4gIDwvR3JvdXA+XG4pO1xuXG5jb25zdCBNZW51SXRlbVdpdGhJY29uU2tlbGV0b24gPSAoe1xuICB0eXBlLFxuICBzaG93SW5kaWNhdG9yID0gZmFsc2UsXG59OiB7XG4gIHR5cGU6IGtleW9mIHR5cGVvZiBNRU5VX0lURU1TO1xuICBzaG93SW5kaWNhdG9yPzogYm9vbGVhbjtcbn0pID0+IChcbiAgPFN0YWNrIGp1c3RpZnk9XCJjZW50ZXJcIiBjbGFzc05hbWU9e2BjbGFzcy1zaG93LW1lbnUtJHt0eXBlLnRvTG93ZXJDYXNlKCl9YH0+XG4gICAgPE1lbnVJdGVtV2l0aEljb24gdHlwZT17dHlwZX0gc2tlbGV0b25UeXBlPXt0eXBlfSBzaG93SW5kaWNhdG9yPXtzaG93SW5kaWNhdG9yfSAvPlxuICA8L1N0YWNrPlxuKTtcblxudHlwZSBNb2JpbGVIZWFkZXJTa2VsZXRvblByb3BzID0ge1xuICBzdHlsZXM/OiB7XG4gICAgcm9vdD86IEludGVycG9sYXRpb248VGhlbWU+O1xuICB9O1xuICBzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uOiBib29sZWFuO1xufTtcblxuY29uc3QgTW9iaWxlSGVhZGVyU2tlbGV0b24gPSAoeyBzdHlsZXMsIHNob3dMYW5ndWFnZVNlY3Rpb25CdXR0b24gfTogTW9iaWxlSGVhZGVyU2tlbGV0b25Qcm9wcykgPT4gKFxuICA8U3RhY2tcbiAgICB3PVwiMTAwJVwiXG4gICAgZ2FwPXswfVxuICAgIGNzcz17e1xuICAgICAgZGlzcGxheTogJ25vbmUnLFxuICAgICAgW21lZGlhUXVlcmllcygndGFibGV0JyldOiB7XG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcbiAgICAgIH0sXG4gICAgfX0+XG4gICAgPEdyb3VwIHc9XCIxMDAlXCIgaD17NTB9IHdyYXA9XCJub3dyYXBcIiBjc3M9e1tzdHlsZXM/LnJvb3RdfT5cbiAgICAgIDxIZWFkZXJCcmFuZExvZ29Ta2VsZXRvbk1vYmlsZSAvPlxuICAgICAgPEdyb3VwIGp1c3RpZnk9XCJmbGV4LWVuZFwiIGdhcD17OH0gbWw9ezEwfSB3cmFwPVwibm93cmFwXCIgY3NzPXt7IGZsZXg6IDEgfX0+XG4gICAgICAgIHtzaG93TGFuZ3VhZ2VTZWN0aW9uQnV0dG9uICYmIChcbiAgICAgICAgICA8QWN0aW9uSWNvbiB2YXJpYW50PVwibGlnaHRcIiBzaXplPVwibi1zbVwiIGNvbG9yPVwiZ3JheVwiIHJhZGl1cz1cInhsXCIgZGlzYWJsZWQ+XG4gICAgICAgICAgICA8SWNvbiBpY29uPXtzb2xpZCgnZ2xvYmUnKX0gLz5cbiAgICAgICAgICA8L0FjdGlvbkljb24+XG4gICAgICAgICl9XG4gICAgICAgIDxTa2VsZXRvbiB3aWR0aD17MzZ9IGhlaWdodD17MzZ9IHJhZGl1cz1cInhsXCIgdmlzaWJsZSAvPlxuICAgICAgPC9Hcm91cD5cbiAgICA8L0dyb3VwPlxuICAgIDxTZWFyY2hCYXJTa2VsZXRvbk1vYmlsZSAvPlxuICA8L1N0YWNrPlxuKTtcblxuY29uc3QgU2VhcmNoQmFyU2tlbGV0b25Nb2JpbGUgPSAoKSA9PiAoXG4gIDxHcm91cFxuICAgIHc9XCIxMDB2d1wiXG4gICAgY2xhc3NOYW1lPVwiY2xhc3Mtc2hvdy1zZWFyY2gtYmFyXCJcbiAgICBjc3M9e3N0eWxlQXBwU2hlbGxTZWFyY2hCYXJNb2JpbGVXcmFwcGVyKHsgc2hvd01lbnVMaXN0OiBmYWxzZSB9KX0+XG4gICAgPEdyb3VwXG4gICAgICB3PVwiMTAwJVwiXG4gICAgICBjc3M9e3N0eWxlQXBwU2hlbGxTZWFyY2hCYXJJbm5lcldyYXBwZXIoe1xuICAgICAgICBzaG93TWVudUxpc3Q6IGZhbHNlLFxuICAgICAgICBpc0ZvY3VzZWQ6IGZhbHNlLFxuICAgICAgICBpc01vYmlsZTogdHJ1ZSxcbiAgICAgIH0pfT5cbiAgICAgIDxCb3ggY3NzPXt7IGZsZXg6IDEgfX0+PC9Cb3g+XG4gICAgICA8QWN0aW9uSWNvbiB0eXBlPVwic3VibWl0XCIgc2l6ZT1cIm4teHNcIiB2YXJpYW50PVwiZmlsbGVkXCIgY29sb3I9XCJpbmZncmVlblwiIHJhZGl1cz17OTk5fSBkaXNhYmxlZD5cbiAgICAgICAgPEljb24gaWNvbj17c29saWQoJ3NlYXJjaCcpfSBzaXplPVwibWRcIiAvPlxuICAgICAgPC9BY3Rpb25JY29uPlxuICAgIDwvR3JvdXA+XG4gIDwvR3JvdXA+XG4pO1xuXG5leHBvcnQgY29uc3Qgc3R5bGVIZWFkZXJDb250YWluZXJJbm5lciA9IGNzcyh7XG4gIG1heFdpZHRoOiAxNDQwLFxuICBwYWRkaW5nOiAnMCAzMnB4JyxcbiAgYmFja2dyb3VuZENvbG9yOiAnd2hpdGUnLFxuXG4gIFttZWRpYVF1ZXJpZXMoJ21vYmlsZScpXToge1xuICAgIHBhZGRpbmc6ICcwIDE2cHgnLFxuICB9LFxufSk7XG4iXX0= */"), children: [
  /* @__PURE__ */ Y(B, { w: "100%", h: 50, wrap: "nowrap", css: [g == null ? void 0 : g.root, process.env.NODE_ENV === "production" ? "" : ";label:MobileHeaderSkeleton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
    /* @__PURE__ */ Z(La, {}),
    /* @__PURE__ */ Y(B, { justify: "flex-end", gap: 8, ml: 10, wrap: "nowrap", css: Qa, children: [
      I && /* @__PURE__ */ Z(Wg, { variant: "light", size: "n-sm", color: "gray", radius: "xl", disabled: !0, children: /* @__PURE__ */ Z(mg, { icon: jI.faGlobe }) }),
      /* @__PURE__ */ Z(_e, { width: 36, height: 36, radius: "xl", visible: !0 })
    ] })
  ] }),
  /* @__PURE__ */ Z(_a, {})
] });
var Ka = process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "11fw941-SearchBarSkeletonMobile",
  styles: "flex:1;label:SearchBarSkeletonMobile;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: bI
};
const _a = () => /* @__PURE__ */ Z(B, { w: "100vw", className: "class-show-search-bar", css: fa({
  showMenuList: !1
}), children: /* @__PURE__ */ Y(B, { w: "100%", css: Mc({
  showMenuList: !1,
  isFocused: !1,
  isMobile: !0
}), children: [
  /* @__PURE__ */ Z(z, { css: Ka }),
  /* @__PURE__ */ Z(Wg, { type: "submit", size: "n-xs", variant: "filled", color: "infgreen", radius: 999, disabled: !0, children: /* @__PURE__ */ Z(mg, { icon: Dc.faSearch, size: "md" }) })
] }) }), qa = /* @__PURE__ */ H({
  maxWidth: 1440,
  padding: "0 32px",
  backgroundColor: "white",
  [w("mobile")]: {
    padding: "0 16px"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:styleHeaderContainerInner;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
export {
  Ga as $,
  yI as A,
  UI as B,
  zg as C,
  Lc as D,
  cg as E,
  _g as F,
  Vs as G,
  hs as H,
  $n as I,
  Ws as J,
  Zs as K,
  wn as L,
  ng as M,
  fn as N,
  ms as O,
  xc as P,
  bn as Q,
  F as R,
  Ug as S,
  qn as T,
  iA as U,
  aA as V,
  cA as W,
  uC as X,
  Ns as Y,
  Rc as Z,
  Ds as _,
  pl as a,
  Hs as a$,
  js as a0,
  lb as a1,
  ub as a2,
  db as a3,
  pI as a4,
  ib as a5,
  tb as a6,
  nb as a7,
  Bs as a8,
  Rs as a9,
  Qs as aA,
  Ps as aB,
  kc as aC,
  zs as aD,
  PC as aE,
  Ss as aF,
  va as aG,
  xa as aH,
  nA as aI,
  rC as aJ,
  Mc as aK,
  Fa as aL,
  bA as aM,
  fa as aN,
  tA as aO,
  CA as aP,
  Xa as aQ,
  qs as aR,
  he as aS,
  Fs as aT,
  lA as aU,
  Oe as aV,
  Hg as aW,
  We as aX,
  QC as aY,
  Ib as aZ,
  Ts as a_,
  Dc as aa,
  xs as ab,
  xb as ac,
  Ya as ad,
  ps as ae,
  Ne as af,
  CC as ag,
  Ys as ah,
  Ec as ai,
  Na as aj,
  DI as ak,
  vs as al,
  Js as am,
  Es as an,
  ma as ao,
  Wa as ap,
  pa as aq,
  XI as ar,
  Qc as as,
  jc as at,
  w as au,
  $s as av,
  _s as aw,
  Us as ax,
  IA as ay,
  ys as az,
  Rl as b,
  ws as b0,
  kC as b1,
  eA as b2,
  E as b3,
  gA as b4,
  Ms as b5,
  Ig as b6,
  Ks as b7,
  hc as b8,
  WI as b9,
  Mn as ba,
  K as bb,
  Ln as bc,
  En as bd,
  _n as be,
  fs as bf,
  Xs as bg,
  ig as c,
  rc as d,
  lc as e,
  cc as f,
  zI as g,
  VI as h,
  Lg as i,
  Bg as j,
  nc as k,
  bc as l,
  wI as m,
  xi as n,
  Os as o,
  ra as p,
  O as q,
  tg as r,
  Ls as s,
  Kl as t,
  Jc as u,
  Wb as v,
  k as w,
  Ze as x,
  EI as y,
  ks as z
};
